(function (scope) {
  'use strict';

  function F(arity, fun, wrapper) {
    wrapper.a = arity;
    wrapper.f = fun;
    return wrapper;
  }
  function F2(fun) {
    return F(2, fun, function (a) {
      return function (b) {
        return fun(a, b);
      };
    });
  }
  function F3(fun) {
    return F(3, fun, function (a) {
      return function (b) {
        return function (c) {
          return fun(a, b, c);
        };
      };
    });
  }
  function F4(fun) {
    return F(4, fun, function (a) {
      return function (b) {
        return function (c) {
          return function (d) {
            return fun(a, b, c, d);
          };
        };
      };
    });
  }
  function F5(fun) {
    return F(5, fun, function (a) {
      return function (b) {
        return function (c) {
          return function (d) {
            return function (e) {
              return fun(a, b, c, d, e);
            };
          };
        };
      };
    });
  }
  function F6(fun) {
    return F(6, fun, function (a) {
      return function (b) {
        return function (c) {
          return function (d) {
            return function (e) {
              return function (f) {
                return fun(a, b, c, d, e, f);
              };
            };
          };
        };
      };
    });
  }
  function F7(fun) {
    return F(7, fun, function (a) {
      return function (b) {
        return function (c) {
          return function (d) {
            return function (e) {
              return function (f) {
                return function (g) {
                  return fun(a, b, c, d, e, f, g);
                };
              };
            };
          };
        };
      };
    });
  }
  function F8(fun) {
    return F(8, fun, function (a) {
      return function (b) {
        return function (c) {
          return function (d) {
            return function (e) {
              return function (f) {
                return function (g) {
                  return function (h) {
                    return fun(a, b, c, d, e, f, g, h);
                  };
                };
              };
            };
          };
        };
      };
    });
  }
  function F9(fun) {
    return F(9, fun, function (a) {
      return function (b) {
        return function (c) {
          return function (d) {
            return function (e) {
              return function (f) {
                return function (g) {
                  return function (h) {
                    return function (i) {
                      return fun(a, b, c, d, e, f, g, h, i);
                    };
                  };
                };
              };
            };
          };
        };
      };
    });
  }
  function A2(fun, a, b) {
    return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
  }
  function A3(fun, a, b, c) {
    return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
  }
  function A4(fun, a, b, c, d) {
    return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
  }
  function A5(fun, a, b, c, d, e) {
    return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
  }
  function A6(fun, a, b, c, d, e, f) {
    return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
  }
  function A7(fun, a, b, c, d, e, f, g) {
    return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
  }
  function A8(fun, a, b, c, d, e, f, g, h) {
    return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
  }
  function A9(fun, a, b, c, d, e, f, g, h, i) {
    return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
  }
  console.warn('Compiled in DEV mode. Follow the advice at https://elm-lang.org/0.19.1/optimize for better performance and smaller assets.');

  // EQUALITY

  function _Utils_eq(x, y) {
    for (var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack); isEqual && (pair = stack.pop()); isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)) {}
    return isEqual;
  }
  function _Utils_eqHelp(x, y, depth, stack) {
    if (x === y) {
      return true;
    }
    if (typeof x !== 'object' || x === null || y === null) {
      typeof x === 'function' && _Debug_crash(5);
      return false;
    }
    if (depth > 100) {
      stack.push(_Utils_Tuple2(x, y));
      return true;
    }

    /**/
    if (x.$ === 'Set_elm_builtin') {
      x = $elm$core$Set$toList(x);
      y = $elm$core$Set$toList(y);
    }
    if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin') {
      x = $elm$core$Dict$toList(x);
      y = $elm$core$Dict$toList(y);
    }
    //*/

    /**_UNUSED/
    if (x.$ < 0)
    {
    	x = $elm$core$Dict$toList(x);
    	y = $elm$core$Dict$toList(y);
    }
    //*/

    for (var key in x) {
      if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack)) {
        return false;
      }
    }
    return true;
  }
  var _Utils_equal = F2(_Utils_eq);
  var _Utils_notEqual = F2(function (a, b) {
    return !_Utils_eq(a, b);
  });

  // COMPARISONS

  // Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
  // the particular integer values assigned to LT, EQ, and GT.

  function _Utils_cmp(x, y, ord) {
    if (typeof x !== 'object') {
      return x === y ? /*EQ*/0 : x < y ? /*LT*/-1 : /*GT*/1;
    }

    /**/
    if (x instanceof String) {
      var a = x.valueOf();
      var b = y.valueOf();
      return a === b ? 0 : a < b ? -1 : 1;
    }
    //*/

    /**_UNUSED/
    if (typeof x.$ === 'undefined')
    //*/
    /**/
    if (x.$[0] === '#')
      //*/
      {
        return (ord = _Utils_cmp(x.a, y.a)) ? ord : (ord = _Utils_cmp(x.b, y.b)) ? ord : _Utils_cmp(x.c, y.c);
      }

    // traverse conses until end of a list or a mismatch
    for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
    return ord || (x.b ? /*GT*/1 : y.b ? /*LT*/-1 : /*EQ*/0);
  }
  var _Utils_lt = F2(function (a, b) {
    return _Utils_cmp(a, b) < 0;
  });
  var _Utils_le = F2(function (a, b) {
    return _Utils_cmp(a, b) < 1;
  });
  var _Utils_gt = F2(function (a, b) {
    return _Utils_cmp(a, b) > 0;
  });
  var _Utils_ge = F2(function (a, b) {
    return _Utils_cmp(a, b) >= 0;
  });
  var _Utils_compare = F2(function (x, y) {
    var n = _Utils_cmp(x, y);
    return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
  });

  // COMMON VALUES

  var _Utils_Tuple0_UNUSED = 0;
  var _Utils_Tuple0 = {
    $: '#0'
  };
  function _Utils_Tuple2_UNUSED(a, b) {
    return {
      a: a,
      b: b
    };
  }
  function _Utils_Tuple2(a, b) {
    return {
      $: '#2',
      a: a,
      b: b
    };
  }
  function _Utils_Tuple3_UNUSED(a, b, c) {
    return {
      a: a,
      b: b,
      c: c
    };
  }
  function _Utils_Tuple3(a, b, c) {
    return {
      $: '#3',
      a: a,
      b: b,
      c: c
    };
  }
  function _Utils_chr_UNUSED(c) {
    return c;
  }
  function _Utils_chr(c) {
    return new String(c);
  }

  // RECORDS

  function _Utils_update(oldRecord, updatedFields) {
    var newRecord = {};
    for (var key in oldRecord) {
      newRecord[key] = oldRecord[key];
    }
    for (var key in updatedFields) {
      newRecord[key] = updatedFields[key];
    }
    return newRecord;
  }

  // APPEND

  var _Utils_append = F2(_Utils_ap);
  function _Utils_ap(xs, ys) {
    // append Strings
    if (typeof xs === 'string') {
      return xs + ys;
    }

    // append Lists
    if (!xs.b) {
      return ys;
    }
    var root = _List_Cons(xs.a, ys);
    xs = xs.b;
    for (var curr = root; xs.b; xs = xs.b)
    // WHILE_CONS
    {
      curr = curr.b = _List_Cons(xs.a, ys);
    }
    return root;
  }
  var _List_Nil_UNUSED = {
    $: 0
  };
  var _List_Nil = {
    $: '[]'
  };
  function _List_Cons_UNUSED(hd, tl) {
    return {
      $: 1,
      a: hd,
      b: tl
    };
  }
  function _List_Cons(hd, tl) {
    return {
      $: '::',
      a: hd,
      b: tl
    };
  }
  var _List_cons = F2(_List_Cons);
  function _List_fromArray(arr) {
    var out = _List_Nil;
    for (var i = arr.length; i--;) {
      out = _List_Cons(arr[i], out);
    }
    return out;
  }
  function _List_toArray(xs) {
    for (var out = []; xs.b; xs = xs.b)
    // WHILE_CONS
    {
      out.push(xs.a);
    }
    return out;
  }
  var _List_map2 = F3(function (f, xs, ys) {
    for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b)
    // WHILE_CONSES
    {
      arr.push(A2(f, xs.a, ys.a));
    }
    return _List_fromArray(arr);
  });
  var _List_map3 = F4(function (f, xs, ys, zs) {
    for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b)
    // WHILE_CONSES
    {
      arr.push(A3(f, xs.a, ys.a, zs.a));
    }
    return _List_fromArray(arr);
  });
  var _List_map4 = F5(function (f, ws, xs, ys, zs) {
    for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b)
    // WHILE_CONSES
    {
      arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
    }
    return _List_fromArray(arr);
  });
  var _List_map5 = F6(function (f, vs, ws, xs, ys, zs) {
    for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b)
    // WHILE_CONSES
    {
      arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
    }
    return _List_fromArray(arr);
  });
  var _List_sortBy = F2(function (f, xs) {
    return _List_fromArray(_List_toArray(xs).sort(function (a, b) {
      return _Utils_cmp(f(a), f(b));
    }));
  });
  var _List_sortWith = F2(function (f, xs) {
    return _List_fromArray(_List_toArray(xs).sort(function (a, b) {
      var ord = A2(f, a, b);
      return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
    }));
  });
  var _JsArray_empty = [];
  function _JsArray_singleton(value) {
    return [value];
  }
  function _JsArray_length(array) {
    return array.length;
  }
  var _JsArray_initialize = F3(function (size, offset, func) {
    var result = new Array(size);
    for (var i = 0; i < size; i++) {
      result[i] = func(offset + i);
    }
    return result;
  });
  var _JsArray_initializeFromList = F2(function (max, ls) {
    var result = new Array(max);
    for (var i = 0; i < max && ls.b; i++) {
      result[i] = ls.a;
      ls = ls.b;
    }
    result.length = i;
    return _Utils_Tuple2(result, ls);
  });
  var _JsArray_unsafeGet = F2(function (index, array) {
    return array[index];
  });
  var _JsArray_unsafeSet = F3(function (index, value, array) {
    var length = array.length;
    var result = new Array(length);
    for (var i = 0; i < length; i++) {
      result[i] = array[i];
    }
    result[index] = value;
    return result;
  });
  var _JsArray_push = F2(function (value, array) {
    var length = array.length;
    var result = new Array(length + 1);
    for (var i = 0; i < length; i++) {
      result[i] = array[i];
    }
    result[length] = value;
    return result;
  });
  var _JsArray_foldl = F3(function (func, acc, array) {
    var length = array.length;
    for (var i = 0; i < length; i++) {
      acc = A2(func, array[i], acc);
    }
    return acc;
  });
  var _JsArray_foldr = F3(function (func, acc, array) {
    for (var i = array.length - 1; i >= 0; i--) {
      acc = A2(func, array[i], acc);
    }
    return acc;
  });
  var _JsArray_map = F2(function (func, array) {
    var length = array.length;
    var result = new Array(length);
    for (var i = 0; i < length; i++) {
      result[i] = func(array[i]);
    }
    return result;
  });
  var _JsArray_indexedMap = F3(function (func, offset, array) {
    var length = array.length;
    var result = new Array(length);
    for (var i = 0; i < length; i++) {
      result[i] = A2(func, offset + i, array[i]);
    }
    return result;
  });
  var _JsArray_slice = F3(function (from, to, array) {
    return array.slice(from, to);
  });
  var _JsArray_appendN = F3(function (n, dest, source) {
    var destLen = dest.length;
    var itemsToCopy = n - destLen;
    if (itemsToCopy > source.length) {
      itemsToCopy = source.length;
    }
    var size = destLen + itemsToCopy;
    var result = new Array(size);
    for (var i = 0; i < destLen; i++) {
      result[i] = dest[i];
    }
    for (var i = 0; i < itemsToCopy; i++) {
      result[i + destLen] = source[i];
    }
    return result;
  });

  // LOG

  var _Debug_log_UNUSED = F2(function (tag, value) {
    return value;
  });
  var _Debug_log = F2(function (tag, value) {
    console.log(tag + ': ' + _Debug_toString(value));
    return value;
  });

  // TODOS

  function _Debug_todo(moduleName, region) {
    return function (message) {
      _Debug_crash(8, moduleName, region, message);
    };
  }
  function _Debug_todoCase(moduleName, region, value) {
    return function (message) {
      _Debug_crash(9, moduleName, region, value, message);
    };
  }

  // TO STRING

  function _Debug_toString_UNUSED(value) {
    return '<internals>';
  }
  function _Debug_toString(value) {
    return _Debug_toAnsiString(false, value);
  }
  function _Debug_toAnsiString(ansi, value) {
    if (typeof value === 'function') {
      return _Debug_internalColor(ansi, '<function>');
    }
    if (typeof value === 'boolean') {
      return _Debug_ctorColor(ansi, value ? 'True' : 'False');
    }
    if (typeof value === 'number') {
      return _Debug_numberColor(ansi, value + '');
    }
    if (value instanceof String) {
      return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
    }
    if (typeof value === 'string') {
      return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
    }
    if (typeof value === 'object' && '$' in value) {
      var tag = value.$;
      if (typeof tag === 'number') {
        return _Debug_internalColor(ansi, '<internals>');
      }
      if (tag[0] === '#') {
        var output = [];
        for (var k in value) {
          if (k === '$') continue;
          output.push(_Debug_toAnsiString(ansi, value[k]));
        }
        return '(' + output.join(',') + ')';
      }
      if (tag === 'Set_elm_builtin') {
        return _Debug_ctorColor(ansi, 'Set') + _Debug_fadeColor(ansi, '.fromList') + ' ' + _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
      }
      if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin') {
        return _Debug_ctorColor(ansi, 'Dict') + _Debug_fadeColor(ansi, '.fromList') + ' ' + _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
      }
      if (tag === 'Array_elm_builtin') {
        return _Debug_ctorColor(ansi, 'Array') + _Debug_fadeColor(ansi, '.fromList') + ' ' + _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
      }
      if (tag === '::' || tag === '[]') {
        var output = '[';
        value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b);
        for (; value.b; value = value.b)
        // WHILE_CONS
        {
          output += ',' + _Debug_toAnsiString(ansi, value.a);
        }
        return output + ']';
      }
      var output = '';
      for (var i in value) {
        if (i === '$') continue;
        var str = _Debug_toAnsiString(ansi, value[i]);
        var c0 = str[0];
        var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
        output += ' ' + (parenless ? str : '(' + str + ')');
      }
      return _Debug_ctorColor(ansi, tag) + output;
    }
    if (typeof DataView === 'function' && value instanceof DataView) {
      return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
    }
    if (typeof File !== 'undefined' && value instanceof File) {
      return _Debug_internalColor(ansi, '<' + value.name + '>');
    }
    if (typeof value === 'object') {
      var output = [];
      for (var key in value) {
        var field = key[0] === '_' ? key.slice(1) : key;
        output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
      }
      if (output.length === 0) {
        return '{}';
      }
      return '{ ' + output.join(', ') + ' }';
    }
    return _Debug_internalColor(ansi, '<internals>');
  }
  function _Debug_addSlashes(str, isChar) {
    var s = str.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/\t/g, '\\t').replace(/\r/g, '\\r').replace(/\v/g, '\\v').replace(/\0/g, '\\0');
    if (isChar) {
      return s.replace(/\'/g, '\\\'');
    } else {
      return s.replace(/\"/g, '\\"');
    }
  }
  function _Debug_ctorColor(ansi, string) {
    return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
  }
  function _Debug_numberColor(ansi, string) {
    return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
  }
  function _Debug_stringColor(ansi, string) {
    return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
  }
  function _Debug_charColor(ansi, string) {
    return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
  }
  function _Debug_fadeColor(ansi, string) {
    return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
  }
  function _Debug_internalColor(ansi, string) {
    return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
  }
  function _Debug_toHexDigit(n) {
    return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
  }

  // CRASH

  function _Debug_crash_UNUSED(identifier) {
    throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
  }
  function _Debug_crash(identifier, fact1, fact2, fact3, fact4) {
    switch (identifier) {
      case 0:
        throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');
      case 1:
        throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');
      case 2:
        var jsonErrorString = fact1;
        throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);
      case 3:
        var portName = fact1;
        throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');
      case 4:
        var portName = fact1;
        var problem = fact2;
        throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);
      case 5:
        throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');
      case 6:
        var moduleName = fact1;
        throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');
      case 8:
        var moduleName = fact1;
        var region = fact2;
        var message = fact3;
        throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);
      case 9:
        var moduleName = fact1;
        var region = fact2;
        var value = fact3;
        var message = fact4;
        throw new Error('TODO in module `' + moduleName + '` from the `case` expression ' + _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    ' + _Debug_toString(value).replace('\n', '\n    ') + '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    '));
      case 10:
        throw new Error('Bug in https://github.com/elm/virtual-dom/issues');
      case 11:
        throw new Error('Cannot perform mod 0. Division by zero error.');
    }
  }
  function _Debug_regionToString(region) {
    if (region.start.line === region.end.line) {
      return 'on line ' + region.start.line;
    }
    return 'on lines ' + region.start.line + ' through ' + region.end.line;
  }

  // MATH

  var _Basics_add = F2(function (a, b) {
    return a + b;
  });
  var _Basics_sub = F2(function (a, b) {
    return a - b;
  });
  var _Basics_mul = F2(function (a, b) {
    return a * b;
  });
  var _Basics_fdiv = F2(function (a, b) {
    return a / b;
  });
  var _Basics_idiv = F2(function (a, b) {
    return a / b | 0;
  });
  var _Basics_pow = F2(Math.pow);
  var _Basics_remainderBy = F2(function (b, a) {
    return a % b;
  });

  // https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
  var _Basics_modBy = F2(function (modulus, x) {
    var answer = x % modulus;
    return modulus === 0 ? _Debug_crash(11) : answer > 0 && modulus < 0 || answer < 0 && modulus > 0 ? answer + modulus : answer;
  });

  // TRIGONOMETRY

  var _Basics_pi = Math.PI;
  var _Basics_e = Math.E;
  var _Basics_cos = Math.cos;
  var _Basics_sin = Math.sin;
  var _Basics_tan = Math.tan;
  var _Basics_acos = Math.acos;
  var _Basics_asin = Math.asin;
  var _Basics_atan = Math.atan;
  var _Basics_atan2 = F2(Math.atan2);

  // MORE MATH

  function _Basics_toFloat(x) {
    return x;
  }
  function _Basics_truncate(n) {
    return n | 0;
  }
  function _Basics_isInfinite(n) {
    return n === Infinity || n === -Infinity;
  }
  var _Basics_ceiling = Math.ceil;
  var _Basics_floor = Math.floor;
  var _Basics_round = Math.round;
  var _Basics_sqrt = Math.sqrt;
  var _Basics_log = Math.log;
  var _Basics_isNaN = isNaN;

  // BOOLEANS

  function _Basics_not(bool) {
    return !bool;
  }
  var _Basics_and = F2(function (a, b) {
    return a && b;
  });
  var _Basics_or = F2(function (a, b) {
    return a || b;
  });
  var _Basics_xor = F2(function (a, b) {
    return a !== b;
  });
  var _String_cons = F2(function (chr, str) {
    return chr + str;
  });
  function _String_uncons(string) {
    var word = string.charCodeAt(0);
    return !isNaN(word) ? $elm$core$Maybe$Just(0xD800 <= word && word <= 0xDBFF ? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2)) : _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))) : $elm$core$Maybe$Nothing;
  }
  var _String_append = F2(function (a, b) {
    return a + b;
  });
  function _String_length(str) {
    return str.length;
  }
  var _String_map = F2(function (func, string) {
    var len = string.length;
    var array = new Array(len);
    var i = 0;
    while (i < len) {
      var word = string.charCodeAt(i);
      if (0xD800 <= word && word <= 0xDBFF) {
        array[i] = func(_Utils_chr(string[i] + string[i + 1]));
        i += 2;
        continue;
      }
      array[i] = func(_Utils_chr(string[i]));
      i++;
    }
    return array.join('');
  });
  var _String_filter = F2(function (isGood, str) {
    var arr = [];
    var len = str.length;
    var i = 0;
    while (i < len) {
      var char = str[i];
      var word = str.charCodeAt(i);
      i++;
      if (0xD800 <= word && word <= 0xDBFF) {
        char += str[i];
        i++;
      }
      if (isGood(_Utils_chr(char))) {
        arr.push(char);
      }
    }
    return arr.join('');
  });
  function _String_reverse(str) {
    var len = str.length;
    var arr = new Array(len);
    var i = 0;
    while (i < len) {
      var word = str.charCodeAt(i);
      if (0xD800 <= word && word <= 0xDBFF) {
        arr[len - i] = str[i + 1];
        i++;
        arr[len - i] = str[i - 1];
        i++;
      } else {
        arr[len - i] = str[i];
        i++;
      }
    }
    return arr.join('');
  }
  var _String_foldl = F3(function (func, state, string) {
    var len = string.length;
    var i = 0;
    while (i < len) {
      var char = string[i];
      var word = string.charCodeAt(i);
      i++;
      if (0xD800 <= word && word <= 0xDBFF) {
        char += string[i];
        i++;
      }
      state = A2(func, _Utils_chr(char), state);
    }
    return state;
  });
  var _String_foldr = F3(function (func, state, string) {
    var i = string.length;
    while (i--) {
      var char = string[i];
      var word = string.charCodeAt(i);
      if (0xDC00 <= word && word <= 0xDFFF) {
        i--;
        char = string[i] + char;
      }
      state = A2(func, _Utils_chr(char), state);
    }
    return state;
  });
  var _String_split = F2(function (sep, str) {
    return str.split(sep);
  });
  var _String_join = F2(function (sep, strs) {
    return strs.join(sep);
  });
  var _String_slice = F3(function (start, end, str) {
    return str.slice(start, end);
  });
  function _String_trim(str) {
    return str.trim();
  }
  function _String_trimLeft(str) {
    return str.replace(/^\s+/, '');
  }
  function _String_trimRight(str) {
    return str.replace(/\s+$/, '');
  }
  function _String_words(str) {
    return _List_fromArray(str.trim().split(/\s+/g));
  }
  function _String_lines(str) {
    return _List_fromArray(str.split(/\r\n|\r|\n/g));
  }
  function _String_toUpper(str) {
    return str.toUpperCase();
  }
  function _String_toLower(str) {
    return str.toLowerCase();
  }
  var _String_any = F2(function (isGood, string) {
    var i = string.length;
    while (i--) {
      var char = string[i];
      var word = string.charCodeAt(i);
      if (0xDC00 <= word && word <= 0xDFFF) {
        i--;
        char = string[i] + char;
      }
      if (isGood(_Utils_chr(char))) {
        return true;
      }
    }
    return false;
  });
  var _String_all = F2(function (isGood, string) {
    var i = string.length;
    while (i--) {
      var char = string[i];
      var word = string.charCodeAt(i);
      if (0xDC00 <= word && word <= 0xDFFF) {
        i--;
        char = string[i] + char;
      }
      if (!isGood(_Utils_chr(char))) {
        return false;
      }
    }
    return true;
  });
  var _String_contains = F2(function (sub, str) {
    return str.indexOf(sub) > -1;
  });
  var _String_startsWith = F2(function (sub, str) {
    return str.indexOf(sub) === 0;
  });
  var _String_endsWith = F2(function (sub, str) {
    return str.length >= sub.length && str.lastIndexOf(sub) === str.length - sub.length;
  });
  var _String_indexes = F2(function (sub, str) {
    var subLen = sub.length;
    if (subLen < 1) {
      return _List_Nil;
    }
    var i = 0;
    var is = [];
    while ((i = str.indexOf(sub, i)) > -1) {
      is.push(i);
      i = i + subLen;
    }
    return _List_fromArray(is);
  });

  // TO STRING

  function _String_fromNumber(number) {
    return number + '';
  }

  // INT CONVERSIONS

  function _String_toInt(str) {
    var total = 0;
    var code0 = str.charCodeAt(0);
    var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;
    for (var i = start; i < str.length; ++i) {
      var code = str.charCodeAt(i);
      if (code < 0x30 || 0x39 < code) {
        return $elm$core$Maybe$Nothing;
      }
      total = 10 * total + code - 0x30;
    }
    return i == start ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
  }

  // FLOAT CONVERSIONS

  function _String_toFloat(s) {
    // check if it is a hex, octal, or binary number
    if (s.length === 0 || /[\sxbo]/.test(s)) {
      return $elm$core$Maybe$Nothing;
    }
    var n = +s;
    // faster isNaN check
    return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
  }
  function _String_fromList(chars) {
    return _List_toArray(chars).join('');
  }
  function _Char_toCode(char) {
    var code = char.charCodeAt(0);
    if (0xD800 <= code && code <= 0xDBFF) {
      return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000;
    }
    return code;
  }
  function _Char_fromCode(code) {
    return _Utils_chr(code < 0 || 0x10FFFF < code ? '\uFFFD' : code <= 0xFFFF ? String.fromCharCode(code) : (code -= 0x10000, String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)));
  }
  function _Char_toUpper(char) {
    return _Utils_chr(char.toUpperCase());
  }
  function _Char_toLower(char) {
    return _Utils_chr(char.toLowerCase());
  }
  function _Char_toLocaleUpper(char) {
    return _Utils_chr(char.toLocaleUpperCase());
  }
  function _Char_toLocaleLower(char) {
    return _Utils_chr(char.toLocaleLowerCase());
  }

  /**/
  function _Json_errorToString(error) {
    return $elm$json$Json$Decode$errorToString(error);
  }
  //*/

  // CORE DECODERS

  function _Json_succeed(msg) {
    return {
      $: 0,
      a: msg
    };
  }
  function _Json_fail(msg) {
    return {
      $: 1,
      a: msg
    };
  }
  function _Json_decodePrim(decoder) {
    return {
      $: 2,
      b: decoder
    };
  }
  var _Json_decodeInt = _Json_decodePrim(function (value) {
    return typeof value !== 'number' ? _Json_expecting('an INT', value) : -2147483647 < value && value < 2147483647 && (value | 0) === value ? $elm$core$Result$Ok(value) : isFinite(value) && !(value % 1) ? $elm$core$Result$Ok(value) : _Json_expecting('an INT', value);
  });
  var _Json_decodeBool = _Json_decodePrim(function (value) {
    return typeof value === 'boolean' ? $elm$core$Result$Ok(value) : _Json_expecting('a BOOL', value);
  });
  var _Json_decodeFloat = _Json_decodePrim(function (value) {
    return typeof value === 'number' ? $elm$core$Result$Ok(value) : _Json_expecting('a FLOAT', value);
  });
  var _Json_decodeValue = _Json_decodePrim(function (value) {
    return $elm$core$Result$Ok(_Json_wrap(value));
  });
  var _Json_decodeString = _Json_decodePrim(function (value) {
    return typeof value === 'string' ? $elm$core$Result$Ok(value) : value instanceof String ? $elm$core$Result$Ok(value + '') : _Json_expecting('a STRING', value);
  });
  function _Json_decodeList(decoder) {
    return {
      $: 3,
      b: decoder
    };
  }
  function _Json_decodeArray(decoder) {
    return {
      $: 4,
      b: decoder
    };
  }
  function _Json_decodeNull(value) {
    return {
      $: 5,
      c: value
    };
  }
  var _Json_decodeField = F2(function (field, decoder) {
    return {
      $: 6,
      d: field,
      b: decoder
    };
  });
  var _Json_decodeIndex = F2(function (index, decoder) {
    return {
      $: 7,
      e: index,
      b: decoder
    };
  });
  function _Json_decodeKeyValuePairs(decoder) {
    return {
      $: 8,
      b: decoder
    };
  }
  function _Json_mapMany(f, decoders) {
    return {
      $: 9,
      f: f,
      g: decoders
    };
  }
  var _Json_andThen = F2(function (callback, decoder) {
    return {
      $: 10,
      b: decoder,
      h: callback
    };
  });
  function _Json_oneOf(decoders) {
    return {
      $: 11,
      g: decoders
    };
  }

  // DECODING OBJECTS

  var _Json_map1 = F2(function (f, d1) {
    return _Json_mapMany(f, [d1]);
  });
  var _Json_map2 = F3(function (f, d1, d2) {
    return _Json_mapMany(f, [d1, d2]);
  });
  var _Json_map3 = F4(function (f, d1, d2, d3) {
    return _Json_mapMany(f, [d1, d2, d3]);
  });
  var _Json_map4 = F5(function (f, d1, d2, d3, d4) {
    return _Json_mapMany(f, [d1, d2, d3, d4]);
  });
  var _Json_map5 = F6(function (f, d1, d2, d3, d4, d5) {
    return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
  });
  var _Json_map6 = F7(function (f, d1, d2, d3, d4, d5, d6) {
    return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
  });
  var _Json_map7 = F8(function (f, d1, d2, d3, d4, d5, d6, d7) {
    return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
  });
  var _Json_map8 = F9(function (f, d1, d2, d3, d4, d5, d6, d7, d8) {
    return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
  });

  // DECODE

  var _Json_runOnString = F2(function (decoder, string) {
    try {
      var value = JSON.parse(string);
      return _Json_runHelp(decoder, value);
    } catch (e) {
      return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
    }
  });
  var _Json_run = F2(function (decoder, value) {
    return _Json_runHelp(decoder, _Json_unwrap(value));
  });
  function _Json_runHelp(decoder, value) {
    switch (decoder.$) {
      case 2:
        return decoder.b(value);
      case 5:
        return value === null ? $elm$core$Result$Ok(decoder.c) : _Json_expecting('null', value);
      case 3:
        if (!_Json_isArray(value)) {
          return _Json_expecting('a LIST', value);
        }
        return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);
      case 4:
        if (!_Json_isArray(value)) {
          return _Json_expecting('an ARRAY', value);
        }
        return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);
      case 6:
        var field = decoder.d;
        if (typeof value !== 'object' || value === null || !(field in value)) {
          return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
        }
        var result = _Json_runHelp(decoder.b, value[field]);
        return $elm$core$Result$isOk(result) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));
      case 7:
        var index = decoder.e;
        if (!_Json_isArray(value)) {
          return _Json_expecting('an ARRAY', value);
        }
        if (index >= value.length) {
          return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
        }
        var result = _Json_runHelp(decoder.b, value[index]);
        return $elm$core$Result$isOk(result) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));
      case 8:
        if (typeof value !== 'object' || value === null || _Json_isArray(value)) {
          return _Json_expecting('an OBJECT', value);
        }
        var keyValuePairs = _List_Nil;
        // TODO test perf of Object.keys and switch when support is good enough
        for (var key in value) {
          if (value.hasOwnProperty(key)) {
            var result = _Json_runHelp(decoder.b, value[key]);
            if (!$elm$core$Result$isOk(result)) {
              return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
            }
            keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
          }
        }
        return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));
      case 9:
        var answer = decoder.f;
        var decoders = decoder.g;
        for (var i = 0; i < decoders.length; i++) {
          var result = _Json_runHelp(decoders[i], value);
          if (!$elm$core$Result$isOk(result)) {
            return result;
          }
          answer = answer(result.a);
        }
        return $elm$core$Result$Ok(answer);
      case 10:
        var result = _Json_runHelp(decoder.b, value);
        return !$elm$core$Result$isOk(result) ? result : _Json_runHelp(decoder.h(result.a), value);
      case 11:
        var errors = _List_Nil;
        for (var temp = decoder.g; temp.b; temp = temp.b)
        // WHILE_CONS
        {
          var result = _Json_runHelp(temp.a, value);
          if ($elm$core$Result$isOk(result)) {
            return result;
          }
          errors = _List_Cons(result.a, errors);
        }
        return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));
      case 1:
        return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));
      case 0:
        return $elm$core$Result$Ok(decoder.a);
    }
  }
  function _Json_runArrayDecoder(decoder, value, toElmValue) {
    var len = value.length;
    var array = new Array(len);
    for (var i = 0; i < len; i++) {
      var result = _Json_runHelp(decoder, value[i]);
      if (!$elm$core$Result$isOk(result)) {
        return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
      }
      array[i] = result.a;
    }
    return $elm$core$Result$Ok(toElmValue(array));
  }
  function _Json_isArray(value) {
    return Array.isArray(value) || typeof FileList !== 'undefined' && value instanceof FileList;
  }
  function _Json_toElmArray(array) {
    return A2($elm$core$Array$initialize, array.length, function (i) {
      return array[i];
    });
  }
  function _Json_expecting(type, value) {
    return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
  }

  // EQUALITY

  function _Json_equality(x, y) {
    if (x === y) {
      return true;
    }
    if (x.$ !== y.$) {
      return false;
    }
    switch (x.$) {
      case 0:
      case 1:
        return x.a === y.a;
      case 2:
        return x.b === y.b;
      case 5:
        return x.c === y.c;
      case 3:
      case 4:
      case 8:
        return _Json_equality(x.b, y.b);
      case 6:
        return x.d === y.d && _Json_equality(x.b, y.b);
      case 7:
        return x.e === y.e && _Json_equality(x.b, y.b);
      case 9:
        return x.f === y.f && _Json_listEquality(x.g, y.g);
      case 10:
        return x.h === y.h && _Json_equality(x.b, y.b);
      case 11:
        return _Json_listEquality(x.g, y.g);
    }
  }
  function _Json_listEquality(aDecoders, bDecoders) {
    var len = aDecoders.length;
    if (len !== bDecoders.length) {
      return false;
    }
    for (var i = 0; i < len; i++) {
      if (!_Json_equality(aDecoders[i], bDecoders[i])) {
        return false;
      }
    }
    return true;
  }

  // ENCODE

  var _Json_encode = F2(function (indentLevel, value) {
    return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
  });
  function _Json_wrap(value) {
    return {
      $: 0,
      a: value
    };
  }
  function _Json_unwrap(value) {
    return value.a;
  }
  function _Json_wrap_UNUSED(value) {
    return value;
  }
  function _Json_unwrap_UNUSED(value) {
    return value;
  }
  function _Json_emptyArray() {
    return [];
  }
  function _Json_emptyObject() {
    return {};
  }
  var _Json_addField = F3(function (key, value, object) {
    object[key] = _Json_unwrap(value);
    return object;
  });
  function _Json_addEntry(func) {
    return F2(function (entry, array) {
      array.push(_Json_unwrap(func(entry)));
      return array;
    });
  }
  var _Json_encodeNull = _Json_wrap(null);

  // TASKS

  function _Scheduler_succeed(value) {
    return {
      $: 0,
      a: value
    };
  }
  function _Scheduler_fail(error) {
    return {
      $: 1,
      a: error
    };
  }
  function _Scheduler_binding(callback) {
    return {
      $: 2,
      b: callback,
      c: null
    };
  }
  var _Scheduler_andThen = F2(function (callback, task) {
    return {
      $: 3,
      b: callback,
      d: task
    };
  });
  var _Scheduler_onError = F2(function (callback, task) {
    return {
      $: 4,
      b: callback,
      d: task
    };
  });
  function _Scheduler_receive(callback) {
    return {
      $: 5,
      b: callback
    };
  }

  // PROCESSES

  var _Scheduler_guid = 0;
  function _Scheduler_rawSpawn(task) {
    var proc = {
      $: 0,
      e: _Scheduler_guid++,
      f: task,
      g: null,
      h: []
    };
    _Scheduler_enqueue(proc);
    return proc;
  }
  function _Scheduler_spawn(task) {
    return _Scheduler_binding(function (callback) {
      callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
    });
  }
  function _Scheduler_rawSend(proc, msg) {
    proc.h.push(msg);
    _Scheduler_enqueue(proc);
  }
  var _Scheduler_send = F2(function (proc, msg) {
    return _Scheduler_binding(function (callback) {
      _Scheduler_rawSend(proc, msg);
      callback(_Scheduler_succeed(_Utils_Tuple0));
    });
  });
  function _Scheduler_kill(proc) {
    return _Scheduler_binding(function (callback) {
      var task = proc.f;
      if (task.$ === 2 && task.c) {
        task.c();
      }
      proc.f = null;
      callback(_Scheduler_succeed(_Utils_Tuple0));
    });
  }

  /* STEP PROCESSES
  
  type alias Process =
    { $ : tag
    , id : unique_id
    , root : Task
    , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
    , mailbox : [msg]
    }
  
  */

  var _Scheduler_working = false;
  var _Scheduler_queue = [];
  function _Scheduler_enqueue(proc) {
    _Scheduler_queue.push(proc);
    if (_Scheduler_working) {
      return;
    }
    _Scheduler_working = true;
    while (proc = _Scheduler_queue.shift()) {
      _Scheduler_step(proc);
    }
    _Scheduler_working = false;
  }
  function _Scheduler_step(proc) {
    while (proc.f) {
      var rootTag = proc.f.$;
      if (rootTag === 0 || rootTag === 1) {
        while (proc.g && proc.g.$ !== rootTag) {
          proc.g = proc.g.i;
        }
        if (!proc.g) {
          return;
        }
        proc.f = proc.g.b(proc.f.a);
        proc.g = proc.g.i;
      } else if (rootTag === 2) {
        proc.f.c = proc.f.b(function (newRoot) {
          proc.f = newRoot;
          _Scheduler_enqueue(proc);
        });
        return;
      } else if (rootTag === 5) {
        if (proc.h.length === 0) {
          return;
        }
        proc.f = proc.f.b(proc.h.shift());
      } else
        // if (rootTag === 3 || rootTag === 4)
        {
          proc.g = {
            $: rootTag === 3 ? 0 : 1,
            b: proc.f.b,
            i: proc.g
          };
          proc.f = proc.f.d;
        }
    }
  }
  function _Process_sleep(time) {
    return _Scheduler_binding(function (callback) {
      var id = setTimeout(function () {
        callback(_Scheduler_succeed(_Utils_Tuple0));
      }, time);
      return function () {
        clearTimeout(id);
      };
    });
  }

  // PROGRAMS

  var _Platform_worker = F4(function (impl, flagDecoder, debugMetadata, args) {
    return _Platform_initialize(flagDecoder, args, impl.init, impl.update, impl.subscriptions, function () {
      return function () {};
    });
  });

  // INITIALIZE A PROGRAM

  function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder) {
    var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
    $elm$core$Result$isOk(result) || _Debug_crash(2 /**/, _Json_errorToString(result.a) /**/);
    var managers = {};
    var initPair = init(result.a);
    var model = initPair.a;
    var stepper = stepperBuilder(sendToApp, model);
    var ports = _Platform_setupEffects(managers, sendToApp);
    function sendToApp(msg, viewMetadata) {
      var pair = A2(update, msg, model);
      stepper(model = pair.a, viewMetadata);
      _Platform_enqueueEffects(managers, pair.b, subscriptions(model));
    }
    _Platform_enqueueEffects(managers, initPair.b, subscriptions(model));
    return ports ? {
      ports: ports
    } : {};
  }

  // TRACK PRELOADS
  //
  // This is used by code in elm/browser and elm/http
  // to register any HTTP requests that are triggered by init.
  //

  var _Platform_preload;
  function _Platform_registerPreload(url) {
    _Platform_preload.add(url);
  }

  // EFFECT MANAGERS

  var _Platform_effectManagers = {};
  function _Platform_setupEffects(managers, sendToApp) {
    var ports;

    // setup all necessary effect managers
    for (var key in _Platform_effectManagers) {
      var manager = _Platform_effectManagers[key];
      if (manager.a) {
        ports = ports || {};
        ports[key] = manager.a(key, sendToApp);
      }
      managers[key] = _Platform_instantiateManager(manager, sendToApp);
    }
    return ports;
  }
  function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap) {
    return {
      b: init,
      c: onEffects,
      d: onSelfMsg,
      e: cmdMap,
      f: subMap
    };
  }
  function _Platform_instantiateManager(info, sendToApp) {
    var router = {
      g: sendToApp,
      h: undefined
    };
    var onEffects = info.c;
    var onSelfMsg = info.d;
    var cmdMap = info.e;
    var subMap = info.f;
    function loop(state) {
      return A2(_Scheduler_andThen, loop, _Scheduler_receive(function (msg) {
        var value = msg.a;
        if (msg.$ === 0) {
          return A3(onSelfMsg, router, value, state);
        }
        return cmdMap && subMap ? A4(onEffects, router, value.i, value.j, state) : A3(onEffects, router, cmdMap ? value.i : value.j, state);
      }));
    }
    return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
  }

  // ROUTING

  var _Platform_sendToApp = F2(function (router, msg) {
    return _Scheduler_binding(function (callback) {
      router.g(msg);
      callback(_Scheduler_succeed(_Utils_Tuple0));
    });
  });
  var _Platform_sendToSelf = F2(function (router, msg) {
    return A2(_Scheduler_send, router.h, {
      $: 0,
      a: msg
    });
  });

  // BAGS

  function _Platform_leaf(home) {
    return function (value) {
      return {
        $: 1,
        k: home,
        l: value
      };
    };
  }
  function _Platform_batch(list) {
    return {
      $: 2,
      m: list
    };
  }
  var _Platform_map = F2(function (tagger, bag) {
    return {
      $: 3,
      n: tagger,
      o: bag
    };
  });

  // PIPE BAGS INTO EFFECT MANAGERS
  //
  // Effects must be queued!
  //
  // Say your init contains a synchronous command, like Time.now or Time.here
  //
  //   - This will produce a batch of effects (FX_1)
  //   - The synchronous task triggers the subsequent `update` call
  //   - This will produce a batch of effects (FX_2)
  //
  // If we just start dispatching FX_2, subscriptions from FX_2 can be processed
  // before subscriptions from FX_1. No good! Earlier versions of this code had
  // this problem, leading to these reports:
  //
  //   https://github.com/elm/core/issues/980
  //   https://github.com/elm/core/pull/981
  //   https://github.com/elm/compiler/issues/1776
  //
  // The queue is necessary to avoid ordering issues for synchronous commands.

  // Why use true/false here? Why not just check the length of the queue?
  // The goal is to detect "are we currently dispatching effects?" If we
  // are, we need to bail and let the ongoing while loop handle things.
  //
  // Now say the queue has 1 element. When we dequeue the final element,
  // the queue will be empty, but we are still actively dispatching effects.
  // So you could get queue jumping in a really tricky category of cases.
  //
  var _Platform_effectsQueue = [];
  var _Platform_effectsActive = false;
  function _Platform_enqueueEffects(managers, cmdBag, subBag) {
    _Platform_effectsQueue.push({
      p: managers,
      q: cmdBag,
      r: subBag
    });
    if (_Platform_effectsActive) return;
    _Platform_effectsActive = true;
    for (var fx; fx = _Platform_effectsQueue.shift();) {
      _Platform_dispatchEffects(fx.p, fx.q, fx.r);
    }
    _Platform_effectsActive = false;
  }
  function _Platform_dispatchEffects(managers, cmdBag, subBag) {
    var effectsDict = {};
    _Platform_gatherEffects(true, cmdBag, effectsDict, null);
    _Platform_gatherEffects(false, subBag, effectsDict, null);
    for (var home in managers) {
      _Scheduler_rawSend(managers[home], {
        $: 'fx',
        a: effectsDict[home] || {
          i: _List_Nil,
          j: _List_Nil
        }
      });
    }
  }
  function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers) {
    switch (bag.$) {
      case 1:
        var home = bag.k;
        var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
        effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
        return;
      case 2:
        for (var list = bag.m; list.b; list = list.b)
        // WHILE_CONS
        {
          _Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
        }
        return;
      case 3:
        _Platform_gatherEffects(isCmd, bag.o, effectsDict, {
          s: bag.n,
          t: taggers
        });
        return;
    }
  }
  function _Platform_toEffect(isCmd, home, taggers, value) {
    function applyTaggers(x) {
      for (var temp = taggers; temp; temp = temp.t) {
        x = temp.s(x);
      }
      return x;
    }
    var map = isCmd ? _Platform_effectManagers[home].e : _Platform_effectManagers[home].f;
    return A2(map, applyTaggers, value);
  }
  function _Platform_insert(isCmd, newEffect, effects) {
    effects = effects || {
      i: _List_Nil,
      j: _List_Nil
    };
    isCmd ? effects.i = _List_Cons(newEffect, effects.i) : effects.j = _List_Cons(newEffect, effects.j);
    return effects;
  }

  // PORTS

  function _Platform_checkPortName(name) {
    if (_Platform_effectManagers[name]) {
      _Debug_crash(3, name);
    }
  }

  // OUTGOING PORTS

  function _Platform_outgoingPort(name, converter) {
    _Platform_checkPortName(name);
    _Platform_effectManagers[name] = {
      e: _Platform_outgoingPortMap,
      u: converter,
      a: _Platform_setupOutgoingPort
    };
    return _Platform_leaf(name);
  }
  var _Platform_outgoingPortMap = F2(function (tagger, value) {
    return value;
  });
  function _Platform_setupOutgoingPort(name) {
    var subs = [];
    var converter = _Platform_effectManagers[name].u;

    // CREATE MANAGER

    var init = _Process_sleep(0);
    _Platform_effectManagers[name].b = init;
    _Platform_effectManagers[name].c = F3(function (router, cmdList, state) {
      for (; cmdList.b; cmdList = cmdList.b)
      // WHILE_CONS
      {
        // grab a separate reference to subs in case unsubscribe is called
        var currentSubs = subs;
        var value = _Json_unwrap(converter(cmdList.a));
        for (var i = 0; i < currentSubs.length; i++) {
          currentSubs[i](value);
        }
      }
      return init;
    });

    // PUBLIC API

    function subscribe(callback) {
      subs.push(callback);
    }
    function unsubscribe(callback) {
      // copy subs into a new array in case unsubscribe is called within a
      // subscribed callback
      subs = subs.slice();
      var index = subs.indexOf(callback);
      if (index >= 0) {
        subs.splice(index, 1);
      }
    }
    return {
      subscribe: subscribe,
      unsubscribe: unsubscribe
    };
  }

  // INCOMING PORTS

  function _Platform_incomingPort(name, converter) {
    _Platform_checkPortName(name);
    _Platform_effectManagers[name] = {
      f: _Platform_incomingPortMap,
      u: converter,
      a: _Platform_setupIncomingPort
    };
    return _Platform_leaf(name);
  }
  var _Platform_incomingPortMap = F2(function (tagger, finalTagger) {
    return function (value) {
      return tagger(finalTagger(value));
    };
  });
  function _Platform_setupIncomingPort(name, sendToApp) {
    var subs = _List_Nil;
    var converter = _Platform_effectManagers[name].u;

    // CREATE MANAGER

    var init = _Scheduler_succeed(null);
    _Platform_effectManagers[name].b = init;
    _Platform_effectManagers[name].c = F3(function (router, subList, state) {
      subs = subList;
      return init;
    });

    // PUBLIC API

    function send(incomingValue) {
      var result = A2(_Json_run, converter, _Json_wrap(incomingValue));
      $elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);
      var value = result.a;
      for (var temp = subs; temp.b; temp = temp.b)
      // WHILE_CONS
      {
        sendToApp(temp.a(value));
      }
    }
    return {
      send: send
    };
  }

  // EXPORT ELM MODULES
  //
  // Have DEBUG and PROD versions so that we can (1) give nicer errors in
  // debug mode and (2) not pay for the bits needed for that in prod mode.
  //

  function _Platform_export_UNUSED(exports) {
    scope['Elm'] ? _Platform_mergeExportsProd(scope['Elm'], exports) : scope['Elm'] = exports;
  }
  function _Platform_mergeExportsProd(obj, exports) {
    for (var name in exports) {
      name in obj ? name == 'init' ? _Debug_crash(6) : _Platform_mergeExportsProd(obj[name], exports[name]) : obj[name] = exports[name];
    }
  }
  function _Platform_export(exports) {
    scope['Elm'] ? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports) : scope['Elm'] = exports;
  }
  function _Platform_mergeExportsDebug(moduleName, obj, exports) {
    for (var name in exports) {
      name in obj ? name == 'init' ? _Debug_crash(6, moduleName) : _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name]) : obj[name] = exports[name];
    }
  }

  // HELPERS

  var _VirtualDom_divertHrefToApp;
  var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};
  function _VirtualDom_appendChild(parent, child) {
    parent.appendChild(child);
  }
  var _VirtualDom_init = F4(function (virtualNode, flagDecoder, debugMetadata, args) {
    // NOTE: this function needs _Platform_export available to work

    /**_UNUSED/
    var node = args['node'];
    //*/
    /**/
    var node = args && args['node'] ? args['node'] : _Debug_crash(0);
    //*/

    node.parentNode.replaceChild(_VirtualDom_render(virtualNode, function () {}), node);
    return {};
  });

  // TEXT

  function _VirtualDom_text(string) {
    return {
      $: 0,
      a: string
    };
  }

  // NODE

  var _VirtualDom_nodeNS = F2(function (namespace, tag) {
    return F2(function (factList, kidList) {
      for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b)
      // WHILE_CONS
      {
        var kid = kidList.a;
        descendantsCount += kid.b || 0;
        kids.push(kid);
      }
      descendantsCount += kids.length;
      return {
        $: 1,
        c: tag,
        d: _VirtualDom_organizeFacts(factList),
        e: kids,
        f: namespace,
        b: descendantsCount
      };
    });
  });
  var _VirtualDom_node = _VirtualDom_nodeNS(undefined);

  // KEYED NODE

  var _VirtualDom_keyedNodeNS = F2(function (namespace, tag) {
    return F2(function (factList, kidList) {
      for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b)
      // WHILE_CONS
      {
        var kid = kidList.a;
        descendantsCount += kid.b.b || 0;
        kids.push(kid);
      }
      descendantsCount += kids.length;
      return {
        $: 2,
        c: tag,
        d: _VirtualDom_organizeFacts(factList),
        e: kids,
        f: namespace,
        b: descendantsCount
      };
    });
  });
  var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);

  // CUSTOM

  function _VirtualDom_custom(factList, model, render, diff) {
    return {
      $: 3,
      d: _VirtualDom_organizeFacts(factList),
      g: model,
      h: render,
      i: diff
    };
  }

  // MAP

  var _VirtualDom_map = F2(function (tagger, node) {
    return {
      $: 4,
      j: tagger,
      k: node,
      b: 1 + (node.b || 0)
    };
  });

  // LAZY

  function _VirtualDom_thunk(refs, thunk) {
    return {
      $: 5,
      l: refs,
      m: thunk,
      k: undefined
    };
  }
  var _VirtualDom_lazy = F2(function (func, a) {
    return _VirtualDom_thunk([func, a], function () {
      return func(a);
    });
  });
  var _VirtualDom_lazy2 = F3(function (func, a, b) {
    return _VirtualDom_thunk([func, a, b], function () {
      return A2(func, a, b);
    });
  });
  var _VirtualDom_lazy3 = F4(function (func, a, b, c) {
    return _VirtualDom_thunk([func, a, b, c], function () {
      return A3(func, a, b, c);
    });
  });
  var _VirtualDom_lazy4 = F5(function (func, a, b, c, d) {
    return _VirtualDom_thunk([func, a, b, c, d], function () {
      return A4(func, a, b, c, d);
    });
  });
  var _VirtualDom_lazy5 = F6(function (func, a, b, c, d, e) {
    return _VirtualDom_thunk([func, a, b, c, d, e], function () {
      return A5(func, a, b, c, d, e);
    });
  });
  var _VirtualDom_lazy6 = F7(function (func, a, b, c, d, e, f) {
    return _VirtualDom_thunk([func, a, b, c, d, e, f], function () {
      return A6(func, a, b, c, d, e, f);
    });
  });
  var _VirtualDom_lazy7 = F8(function (func, a, b, c, d, e, f, g) {
    return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function () {
      return A7(func, a, b, c, d, e, f, g);
    });
  });
  var _VirtualDom_lazy8 = F9(function (func, a, b, c, d, e, f, g, h) {
    return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function () {
      return A8(func, a, b, c, d, e, f, g, h);
    });
  });

  // FACTS

  var _VirtualDom_on = F2(function (key, handler) {
    return {
      $: 'a0',
      n: key,
      o: handler
    };
  });
  var _VirtualDom_style = F2(function (key, value) {
    return {
      $: 'a1',
      n: key,
      o: value
    };
  });
  var _VirtualDom_property = F2(function (key, value) {
    return {
      $: 'a2',
      n: key,
      o: value
    };
  });
  var _VirtualDom_attribute = F2(function (key, value) {
    return {
      $: 'a3',
      n: key,
      o: value
    };
  });
  var _VirtualDom_attributeNS = F3(function (namespace, key, value) {
    return {
      $: 'a4',
      n: key,
      o: {
        f: namespace,
        o: value
      }
    };
  });

  // XSS ATTACK VECTOR CHECKS

  function _VirtualDom_noScript(tag) {
    return tag == 'script' ? 'p' : tag;
  }
  function _VirtualDom_noOnOrFormAction(key) {
    return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
  }
  function _VirtualDom_noInnerHtmlOrFormAction(key) {
    return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
  }
  function _VirtualDom_noJavaScriptUri_UNUSED(value) {
    return /^javascript:/i.test(value.replace(/\s/g, '')) ? '' : value;
  }
  function _VirtualDom_noJavaScriptUri(value) {
    return /^javascript:/i.test(value.replace(/\s/g, '')) ? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")' : value;
  }
  function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value) {
    return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
  }
  function _VirtualDom_noJavaScriptOrHtmlUri(value) {
    return /^\s*(javascript:|data:text\/html)/i.test(value) ? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")' : value;
  }

  // MAP FACTS

  var _VirtualDom_mapAttribute = F2(function (func, attr) {
    return attr.$ === 'a0' ? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o)) : attr;
  });
  function _VirtualDom_mapHandler(func, handler) {
    var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

    // 0 = Normal
    // 1 = MayStopPropagation
    // 2 = MayPreventDefault
    // 3 = Custom

    return {
      $: handler.$,
      a: !tag ? A2($elm$json$Json$Decode$map, func, handler.a) : A3($elm$json$Json$Decode$map2, tag < 3 ? _VirtualDom_mapEventTuple : _VirtualDom_mapEventRecord, $elm$json$Json$Decode$succeed(func), handler.a)
    };
  }
  var _VirtualDom_mapEventTuple = F2(function (func, tuple) {
    return _Utils_Tuple2(func(tuple.a), tuple.b);
  });
  var _VirtualDom_mapEventRecord = F2(function (func, record) {
    return {
      message: func(record.message),
      stopPropagation: record.stopPropagation,
      preventDefault: record.preventDefault
    };
  });

  // ORGANIZE FACTS

  function _VirtualDom_organizeFacts(factList) {
    for (var facts = {}; factList.b; factList = factList.b)
    // WHILE_CONS
    {
      var entry = factList.a;
      var tag = entry.$;
      var key = entry.n;
      var value = entry.o;
      if (tag === 'a2') {
        key === 'className' ? _VirtualDom_addClass(facts, key, _Json_unwrap(value)) : facts[key] = _Json_unwrap(value);
        continue;
      }
      var subFacts = facts[tag] || (facts[tag] = {});
      tag === 'a3' && key === 'class' ? _VirtualDom_addClass(subFacts, key, value) : subFacts[key] = value;
    }
    return facts;
  }
  function _VirtualDom_addClass(object, key, newClass) {
    var classes = object[key];
    object[key] = classes ? classes + ' ' + newClass : newClass;
  }

  // RENDER

  function _VirtualDom_render(vNode, eventNode) {
    var tag = vNode.$;
    if (tag === 5) {
      return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
    }
    if (tag === 0) {
      return _VirtualDom_doc.createTextNode(vNode.a);
    }
    if (tag === 4) {
      var subNode = vNode.k;
      var tagger = vNode.j;
      while (subNode.$ === 4) {
        typeof tagger !== 'object' ? tagger = [tagger, subNode.j] : tagger.push(subNode.j);
        subNode = subNode.k;
      }
      var subEventRoot = {
        j: tagger,
        p: eventNode
      };
      var domNode = _VirtualDom_render(subNode, subEventRoot);
      domNode.elm_event_node_ref = subEventRoot;
      return domNode;
    }
    if (tag === 3) {
      var domNode = vNode.h(vNode.g);
      _VirtualDom_applyFacts(domNode, eventNode, vNode.d);
      return domNode;
    }

    // at this point `tag` must be 1 or 2

    var domNode = vNode.f ? _VirtualDom_doc.createElementNS(vNode.f, vNode.c) : _VirtualDom_doc.createElement(vNode.c);
    if (_VirtualDom_divertHrefToApp && vNode.c == 'a') {
      domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
    }
    _VirtualDom_applyFacts(domNode, eventNode, vNode.d);
    for (var kids = vNode.e, i = 0; i < kids.length; i++) {
      _VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
    }
    return domNode;
  }

  // APPLY FACTS

  function _VirtualDom_applyFacts(domNode, eventNode, facts) {
    for (var key in facts) {
      var value = facts[key];
      key === 'a1' ? _VirtualDom_applyStyles(domNode, value) : key === 'a0' ? _VirtualDom_applyEvents(domNode, eventNode, value) : key === 'a3' ? _VirtualDom_applyAttrs(domNode, value) : key === 'a4' ? _VirtualDom_applyAttrsNS(domNode, value) : (key !== 'value' && key !== 'checked' || domNode[key] !== value) && (domNode[key] = value);
    }
  }

  // APPLY STYLES

  function _VirtualDom_applyStyles(domNode, styles) {
    var domNodeStyle = domNode.style;
    for (var key in styles) {
      domNodeStyle[key] = styles[key];
    }
  }

  // APPLY ATTRS

  function _VirtualDom_applyAttrs(domNode, attrs) {
    for (var key in attrs) {
      var value = attrs[key];
      typeof value !== 'undefined' ? domNode.setAttribute(key, value) : domNode.removeAttribute(key);
    }
  }

  // APPLY NAMESPACED ATTRS

  function _VirtualDom_applyAttrsNS(domNode, nsAttrs) {
    for (var key in nsAttrs) {
      var pair = nsAttrs[key];
      var namespace = pair.f;
      var value = pair.o;
      typeof value !== 'undefined' ? domNode.setAttributeNS(namespace, key, value) : domNode.removeAttributeNS(namespace, key);
    }
  }

  // APPLY EVENTS

  function _VirtualDom_applyEvents(domNode, eventNode, events) {
    var allCallbacks = domNode.elmFs || (domNode.elmFs = {});
    for (var key in events) {
      var newHandler = events[key];
      var oldCallback = allCallbacks[key];
      if (!newHandler) {
        domNode.removeEventListener(key, oldCallback);
        allCallbacks[key] = undefined;
        continue;
      }
      if (oldCallback) {
        var oldHandler = oldCallback.q;
        if (oldHandler.$ === newHandler.$) {
          oldCallback.q = newHandler;
          continue;
        }
        domNode.removeEventListener(key, oldCallback);
      }
      oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
      domNode.addEventListener(key, oldCallback, _VirtualDom_passiveSupported && {
        passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2
      });
      allCallbacks[key] = oldCallback;
    }
  }

  // PASSIVE EVENTS

  var _VirtualDom_passiveSupported;
  try {
    window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
      get: function () {
        _VirtualDom_passiveSupported = true;
      }
    }));
  } catch (e) {}

  // EVENT HANDLERS

  function _VirtualDom_makeCallback(eventNode, initialHandler) {
    function callback(event) {
      var handler = callback.q;
      var result = _Json_runHelp(handler.a, event);
      if (!$elm$core$Result$isOk(result)) {
        return;
      }
      var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

      // 0 = Normal
      // 1 = MayStopPropagation
      // 2 = MayPreventDefault
      // 3 = Custom

      var value = result.a;
      var message = !tag ? value : tag < 3 ? value.a : value.message;
      var stopPropagation = tag == 1 ? value.b : tag == 3 && value.stopPropagation;
      var currentEventNode = (stopPropagation && event.stopPropagation(), (tag == 2 ? value.b : tag == 3 && value.preventDefault) && event.preventDefault(), eventNode);
      var tagger;
      var i;
      while (tagger = currentEventNode.j) {
        if (typeof tagger == 'function') {
          message = tagger(message);
        } else {
          for (var i = tagger.length; i--;) {
            message = tagger[i](message);
          }
        }
        currentEventNode = currentEventNode.p;
      }
      currentEventNode(message, stopPropagation); // stopPropagation implies isSync
    }
    callback.q = initialHandler;
    return callback;
  }
  function _VirtualDom_equalEvents(x, y) {
    return x.$ == y.$ && _Json_equality(x.a, y.a);
  }

  // DIFF

  // TODO: Should we do patches like in iOS?
  //
  // type Patch
  //   = At Int Patch
  //   | Batch (List Patch)
  //   | Change ...
  //
  // How could it not be better?
  //
  function _VirtualDom_diff(x, y) {
    var patches = [];
    _VirtualDom_diffHelp(x, y, patches, 0);
    return patches;
  }
  function _VirtualDom_pushPatch(patches, type, index, data) {
    var patch = {
      $: type,
      r: index,
      s: data,
      t: undefined,
      u: undefined
    };
    patches.push(patch);
    return patch;
  }
  function _VirtualDom_diffHelp(x, y, patches, index) {
    if (x === y) {
      return;
    }
    var xType = x.$;
    var yType = y.$;

    // Bail if you run into different types of nodes. Implies that the
    // structure has changed significantly and it's not worth a diff.
    if (xType !== yType) {
      if (xType === 1 && yType === 2) {
        y = _VirtualDom_dekey(y);
        yType = 1;
      } else {
        _VirtualDom_pushPatch(patches, 0, index, y);
        return;
      }
    }

    // Now we know that both nodes are the same $.
    switch (yType) {
      case 5:
        var xRefs = x.l;
        var yRefs = y.l;
        var i = xRefs.length;
        var same = i === yRefs.length;
        while (same && i--) {
          same = xRefs[i] === yRefs[i];
        }
        if (same) {
          y.k = x.k;
          return;
        }
        y.k = y.m();
        var subPatches = [];
        _VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
        subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
        return;
      case 4:
        // gather nested taggers
        var xTaggers = x.j;
        var yTaggers = y.j;
        var nesting = false;
        var xSubNode = x.k;
        while (xSubNode.$ === 4) {
          nesting = true;
          typeof xTaggers !== 'object' ? xTaggers = [xTaggers, xSubNode.j] : xTaggers.push(xSubNode.j);
          xSubNode = xSubNode.k;
        }
        var ySubNode = y.k;
        while (ySubNode.$ === 4) {
          nesting = true;
          typeof yTaggers !== 'object' ? yTaggers = [yTaggers, ySubNode.j] : yTaggers.push(ySubNode.j);
          ySubNode = ySubNode.k;
        }

        // Just bail if different numbers of taggers. This implies the
        // structure of the virtual DOM has changed.
        if (nesting && xTaggers.length !== yTaggers.length) {
          _VirtualDom_pushPatch(patches, 0, index, y);
          return;
        }

        // check if taggers are "the same"
        if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers) {
          _VirtualDom_pushPatch(patches, 2, index, yTaggers);
        }

        // diff everything below the taggers
        _VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
        return;
      case 0:
        if (x.a !== y.a) {
          _VirtualDom_pushPatch(patches, 3, index, y.a);
        }
        return;
      case 1:
        _VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
        return;
      case 2:
        _VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
        return;
      case 3:
        if (x.h !== y.h) {
          _VirtualDom_pushPatch(patches, 0, index, y);
          return;
        }
        var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
        factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
        var patch = y.i(x.g, y.g);
        patch && _VirtualDom_pushPatch(patches, 5, index, patch);
        return;
    }
  }

  // assumes the incoming arrays are the same length
  function _VirtualDom_pairwiseRefEqual(as, bs) {
    for (var i = 0; i < as.length; i++) {
      if (as[i] !== bs[i]) {
        return false;
      }
    }
    return true;
  }
  function _VirtualDom_diffNodes(x, y, patches, index, diffKids) {
    // Bail if obvious indicators have changed. Implies more serious
    // structural changes such that it's not worth it to diff.
    if (x.c !== y.c || x.f !== y.f) {
      _VirtualDom_pushPatch(patches, 0, index, y);
      return;
    }
    var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
    factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
    diffKids(x, y, patches, index);
  }

  // DIFF FACTS

  // TODO Instead of creating a new diff object, it's possible to just test if
  // there *is* a diff. During the actual patch, do the diff again and make the
  // modifications directly. This way, there's no new allocations. Worth it?
  function _VirtualDom_diffFacts(x, y, category) {
    var diff;

    // look for changes and removals
    for (var xKey in x) {
      if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4') {
        var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
        if (subDiff) {
          diff = diff || {};
          diff[xKey] = subDiff;
        }
        continue;
      }

      // remove if not in the new facts
      if (!(xKey in y)) {
        diff = diff || {};
        diff[xKey] = !category ? typeof x[xKey] === 'string' ? '' : null : category === 'a1' ? '' : category === 'a0' || category === 'a3' ? undefined : {
          f: x[xKey].f,
          o: undefined
        };
        continue;
      }
      var xValue = x[xKey];
      var yValue = y[xKey];

      // reference equal, so don't worry about it
      if (xValue === yValue && xKey !== 'value' && xKey !== 'checked' || category === 'a0' && _VirtualDom_equalEvents(xValue, yValue)) {
        continue;
      }
      diff = diff || {};
      diff[xKey] = yValue;
    }

    // add new stuff
    for (var yKey in y) {
      if (!(yKey in x)) {
        diff = diff || {};
        diff[yKey] = y[yKey];
      }
    }
    return diff;
  }

  // DIFF KIDS

  function _VirtualDom_diffKids(xParent, yParent, patches, index) {
    var xKids = xParent.e;
    var yKids = yParent.e;
    var xLen = xKids.length;
    var yLen = yKids.length;

    // FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

    if (xLen > yLen) {
      _VirtualDom_pushPatch(patches, 6, index, {
        v: yLen,
        i: xLen - yLen
      });
    } else if (xLen < yLen) {
      _VirtualDom_pushPatch(patches, 7, index, {
        v: xLen,
        e: yKids
      });
    }

    // PAIRWISE DIFF EVERYTHING ELSE

    for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++) {
      var xKid = xKids[i];
      _VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
      index += xKid.b || 0;
    }
  }

  // KEYED DIFF

  function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex) {
    var localPatches = [];
    var changes = {}; // Dict String Entry
    var inserts = []; // Array { index : Int, entry : Entry }
    // type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

    var xKids = xParent.e;
    var yKids = yParent.e;
    var xLen = xKids.length;
    var yLen = yKids.length;
    var xIndex = 0;
    var yIndex = 0;
    var index = rootIndex;
    while (xIndex < xLen && yIndex < yLen) {
      var x = xKids[xIndex];
      var y = yKids[yIndex];
      var xKey = x.a;
      var yKey = y.a;
      var xNode = x.b;
      var yNode = y.b;
      var newMatch = undefined;
      var oldMatch = undefined;

      // check if keys match

      if (xKey === yKey) {
        index++;
        _VirtualDom_diffHelp(xNode, yNode, localPatches, index);
        index += xNode.b || 0;
        xIndex++;
        yIndex++;
        continue;
      }

      // look ahead 1 to detect insertions and removals.

      var xNext = xKids[xIndex + 1];
      var yNext = yKids[yIndex + 1];
      if (xNext) {
        var xNextKey = xNext.a;
        var xNextNode = xNext.b;
        oldMatch = yKey === xNextKey;
      }
      if (yNext) {
        var yNextKey = yNext.a;
        var yNextNode = yNext.b;
        newMatch = xKey === yNextKey;
      }

      // swap x and y
      if (newMatch && oldMatch) {
        index++;
        _VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
        _VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
        index += xNode.b || 0;
        index++;
        _VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
        index += xNextNode.b || 0;
        xIndex += 2;
        yIndex += 2;
        continue;
      }

      // insert y
      if (newMatch) {
        index++;
        _VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
        _VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
        index += xNode.b || 0;
        xIndex += 1;
        yIndex += 2;
        continue;
      }

      // remove x
      if (oldMatch) {
        index++;
        _VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
        index += xNode.b || 0;
        index++;
        _VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
        index += xNextNode.b || 0;
        xIndex += 2;
        yIndex += 1;
        continue;
      }

      // remove x, insert y
      if (xNext && xNextKey === yNextKey) {
        index++;
        _VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
        _VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
        index += xNode.b || 0;
        index++;
        _VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
        index += xNextNode.b || 0;
        xIndex += 2;
        yIndex += 2;
        continue;
      }
      break;
    }

    // eat up any remaining nodes with removeNode and insertNode

    while (xIndex < xLen) {
      index++;
      var x = xKids[xIndex];
      var xNode = x.b;
      _VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
      index += xNode.b || 0;
      xIndex++;
    }
    while (yIndex < yLen) {
      var endInserts = endInserts || [];
      var y = yKids[yIndex];
      _VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
      yIndex++;
    }
    if (localPatches.length > 0 || inserts.length > 0 || endInserts) {
      _VirtualDom_pushPatch(patches, 8, rootIndex, {
        w: localPatches,
        x: inserts,
        y: endInserts
      });
    }
  }

  // CHANGES FROM KEYED DIFF

  var _VirtualDom_POSTFIX = '_elmW6BL';
  function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts) {
    var entry = changes[key];

    // never seen this key before
    if (!entry) {
      entry = {
        c: 0,
        z: vnode,
        r: yIndex,
        s: undefined
      };
      inserts.push({
        r: yIndex,
        A: entry
      });
      changes[key] = entry;
      return;
    }

    // this key was removed earlier, a match!
    if (entry.c === 1) {
      inserts.push({
        r: yIndex,
        A: entry
      });
      entry.c = 2;
      var subPatches = [];
      _VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
      entry.r = yIndex;
      entry.s.s = {
        w: subPatches,
        A: entry
      };
      return;
    }

    // this key has already been inserted or moved, a duplicate!
    _VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
  }
  function _VirtualDom_removeNode(changes, localPatches, key, vnode, index) {
    var entry = changes[key];

    // never seen this key before
    if (!entry) {
      var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);
      changes[key] = {
        c: 1,
        z: vnode,
        r: index,
        s: patch
      };
      return;
    }

    // this key was inserted earlier, a match!
    if (entry.c === 0) {
      entry.c = 2;
      var subPatches = [];
      _VirtualDom_diffHelp(vnode, entry.z, subPatches, index);
      _VirtualDom_pushPatch(localPatches, 9, index, {
        w: subPatches,
        A: entry
      });
      return;
    }

    // this key has already been removed or moved, a duplicate!
    _VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
  }

  // ADD DOM NODES
  //
  // Each DOM node has an "index" assigned in order of traversal. It is important
  // to minimize our crawl over the actual DOM, so these indexes (along with the
  // descendantsCount of virtual nodes) let us skip touching entire subtrees of
  // the DOM if we know there are no patches there.

  function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode) {
    _VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
  }

  // assumes `patches` is non-empty and indexes increase monotonically.
  function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode) {
    var patch = patches[i];
    var index = patch.r;
    while (index === low) {
      var patchType = patch.$;
      if (patchType === 1) {
        _VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
      } else if (patchType === 8) {
        patch.t = domNode;
        patch.u = eventNode;
        var subPatches = patch.s.w;
        if (subPatches.length > 0) {
          _VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
        }
      } else if (patchType === 9) {
        patch.t = domNode;
        patch.u = eventNode;
        var data = patch.s;
        if (data) {
          data.A.s = domNode;
          var subPatches = data.w;
          if (subPatches.length > 0) {
            _VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
          }
        }
      } else {
        patch.t = domNode;
        patch.u = eventNode;
      }
      i++;
      if (!(patch = patches[i]) || (index = patch.r) > high) {
        return i;
      }
    }
    var tag = vNode.$;
    if (tag === 4) {
      var subNode = vNode.k;
      while (subNode.$ === 4) {
        subNode = subNode.k;
      }
      return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
    }

    // tag must be 1 or 2 at this point

    var vKids = vNode.e;
    var childNodes = domNode.childNodes;
    for (var j = 0; j < vKids.length; j++) {
      low++;
      var vKid = tag === 1 ? vKids[j] : vKids[j].b;
      var nextLow = low + (vKid.b || 0);
      if (low <= index && index <= nextLow) {
        i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
        if (!(patch = patches[i]) || (index = patch.r) > high) {
          return i;
        }
      }
      low = nextLow;
    }
    return i;
  }

  // APPLY PATCHES

  function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode) {
    if (patches.length === 0) {
      return rootDomNode;
    }
    _VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
    return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
  }
  function _VirtualDom_applyPatchesHelp(rootDomNode, patches) {
    for (var i = 0; i < patches.length; i++) {
      var patch = patches[i];
      var localDomNode = patch.t;
      var newNode = _VirtualDom_applyPatch(localDomNode, patch);
      if (localDomNode === rootDomNode) {
        rootDomNode = newNode;
      }
    }
    return rootDomNode;
  }
  function _VirtualDom_applyPatch(domNode, patch) {
    switch (patch.$) {
      case 0:
        return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);
      case 4:
        _VirtualDom_applyFacts(domNode, patch.u, patch.s);
        return domNode;
      case 3:
        domNode.replaceData(0, domNode.length, patch.s);
        return domNode;
      case 1:
        return _VirtualDom_applyPatchesHelp(domNode, patch.s);
      case 2:
        if (domNode.elm_event_node_ref) {
          domNode.elm_event_node_ref.j = patch.s;
        } else {
          domNode.elm_event_node_ref = {
            j: patch.s,
            p: patch.u
          };
        }
        return domNode;
      case 6:
        var data = patch.s;
        for (var i = 0; i < data.i; i++) {
          domNode.removeChild(domNode.childNodes[data.v]);
        }
        return domNode;
      case 7:
        var data = patch.s;
        var kids = data.e;
        var i = data.v;
        var theEnd = domNode.childNodes[i];
        for (; i < kids.length; i++) {
          domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
        }
        return domNode;
      case 9:
        var data = patch.s;
        if (!data) {
          domNode.parentNode.removeChild(domNode);
          return domNode;
        }
        var entry = data.A;
        if (typeof entry.r !== 'undefined') {
          domNode.parentNode.removeChild(domNode);
        }
        entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
        return domNode;
      case 8:
        return _VirtualDom_applyPatchReorder(domNode, patch);
      case 5:
        return patch.s(domNode);
      default:
        _Debug_crash(10);
      // 'Ran into an unknown patch!'
    }
  }
  function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode) {
    var parentNode = domNode.parentNode;
    var newNode = _VirtualDom_render(vNode, eventNode);
    if (!newNode.elm_event_node_ref) {
      newNode.elm_event_node_ref = domNode.elm_event_node_ref;
    }
    if (parentNode && newNode !== domNode) {
      parentNode.replaceChild(newNode, domNode);
    }
    return newNode;
  }
  function _VirtualDom_applyPatchReorder(domNode, patch) {
    var data = patch.s;

    // remove end inserts
    var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

    // removals
    domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

    // inserts
    var inserts = data.x;
    for (var i = 0; i < inserts.length; i++) {
      var insert = inserts[i];
      var entry = insert.A;
      var node = entry.c === 2 ? entry.s : _VirtualDom_render(entry.z, patch.u);
      domNode.insertBefore(node, domNode.childNodes[insert.r]);
    }

    // add end inserts
    if (frag) {
      _VirtualDom_appendChild(domNode, frag);
    }
    return domNode;
  }
  function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch) {
    if (!endInserts) {
      return;
    }
    var frag = _VirtualDom_doc.createDocumentFragment();
    for (var i = 0; i < endInserts.length; i++) {
      var insert = endInserts[i];
      var entry = insert.A;
      _VirtualDom_appendChild(frag, entry.c === 2 ? entry.s : _VirtualDom_render(entry.z, patch.u));
    }
    return frag;
  }
  function _VirtualDom_virtualize(node) {
    // TEXT NODES

    if (node.nodeType === 3) {
      return _VirtualDom_text(node.textContent);
    }

    // WEIRD NODES

    if (node.nodeType !== 1) {
      return _VirtualDom_text('');
    }

    // ELEMENT NODES

    var attrList = _List_Nil;
    var attrs = node.attributes;
    for (var i = attrs.length; i--;) {
      var attr = attrs[i];
      var name = attr.name;
      var value = attr.value;
      attrList = _List_Cons(A2(_VirtualDom_attribute, name, value), attrList);
    }
    var tag = node.tagName.toLowerCase();
    var kidList = _List_Nil;
    var kids = node.childNodes;
    for (var i = kids.length; i--;) {
      kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
    }
    return A3(_VirtualDom_node, tag, attrList, kidList);
  }
  function _VirtualDom_dekey(keyedNode) {
    var keyedKids = keyedNode.e;
    var len = keyedKids.length;
    var kids = new Array(len);
    for (var i = 0; i < len; i++) {
      kids[i] = keyedKids[i].b;
    }
    return {
      $: 1,
      c: keyedNode.c,
      d: keyedNode.d,
      e: kids,
      f: keyedNode.f,
      b: keyedNode.b
    };
  }

  // ELEMENT

  var _Debugger_element;
  var _Browser_element = _Debugger_element || F4(function (impl, flagDecoder, debugMetadata, args) {
    return _Platform_initialize(flagDecoder, args, impl.init, impl.update, impl.subscriptions, function (sendToApp, initialModel) {
      var view = impl.view;
      /**_UNUSED/
      var domNode = args['node'];
      //*/
      /**/
      var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
      //*/
      var currNode = _VirtualDom_virtualize(domNode);
      return _Browser_makeAnimator(initialModel, function (model) {
        var nextNode = view(model);
        var patches = _VirtualDom_diff(currNode, nextNode);
        domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
        currNode = nextNode;
      });
    });
  });

  // DOCUMENT

  var _Debugger_document;
  var _Browser_document = _Debugger_document || F4(function (impl, flagDecoder, debugMetadata, args) {
    return _Platform_initialize(flagDecoder, args, impl.init, impl.update, impl.subscriptions, function (sendToApp, initialModel) {
      var divertHrefToApp = impl.setup && impl.setup(sendToApp);
      var view = impl.view;
      var title = _VirtualDom_doc.title;
      var bodyNode = _VirtualDom_doc.body;
      var currNode = _VirtualDom_virtualize(bodyNode);
      return _Browser_makeAnimator(initialModel, function (model) {
        _VirtualDom_divertHrefToApp = divertHrefToApp;
        var doc = view(model);
        var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.body);
        var patches = _VirtualDom_diff(currNode, nextNode);
        bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
        currNode = nextNode;
        _VirtualDom_divertHrefToApp = 0;
        title !== doc.title && (_VirtualDom_doc.title = title = doc.title);
      });
    });
  });

  // ANIMATION

  var _Browser_cancelAnimationFrame = typeof cancelAnimationFrame !== 'undefined' ? cancelAnimationFrame : function (id) {
    clearTimeout(id);
  };
  var _Browser_requestAnimationFrame = typeof requestAnimationFrame !== 'undefined' ? requestAnimationFrame : function (callback) {
    return setTimeout(callback, 1000 / 60);
  };
  function _Browser_makeAnimator(model, draw) {
    draw(model);
    var state = 0;
    function updateIfNeeded() {
      state = state === 1 ? 0 : (_Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1);
    }
    return function (nextModel, isSync) {
      model = nextModel;
      isSync ? (draw(model), state === 2 && (state = 1)) : (state === 0 && _Browser_requestAnimationFrame(updateIfNeeded), state = 2);
    };
  }

  // APPLICATION

  function _Browser_application(impl) {
    var onUrlChange = impl.onUrlChange;
    var onUrlRequest = impl.onUrlRequest;
    var key = function () {
      key.a(onUrlChange(_Browser_getUrl()));
    };
    return _Browser_document({
      setup: function (sendToApp) {
        key.a = sendToApp;
        _Browser_window.addEventListener('popstate', key);
        _Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);
        return F2(function (domNode, event) {
          if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download')) {
            event.preventDefault();
            var href = domNode.href;
            var curr = _Browser_getUrl();
            var next = $elm$url$Url$fromString(href).a;
            sendToApp(onUrlRequest(next && curr.protocol === next.protocol && curr.host === next.host && curr.port_.a === next.port_.a ? $elm$browser$Browser$Internal(next) : $elm$browser$Browser$External(href)));
          }
        });
      },
      init: function (flags) {
        return A3(impl.init, flags, _Browser_getUrl(), key);
      },
      view: impl.view,
      update: impl.update,
      subscriptions: impl.subscriptions
    });
  }
  function _Browser_getUrl() {
    return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
  }
  var _Browser_go = F2(function (key, n) {
    return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function () {
      n && history.go(n);
      key();
    }));
  });
  var _Browser_pushUrl = F2(function (key, url) {
    return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function () {
      history.pushState({}, '', url);
      key();
    }));
  });
  var _Browser_replaceUrl = F2(function (key, url) {
    return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function () {
      history.replaceState({}, '', url);
      key();
    }));
  });

  // GLOBAL EVENTS

  var _Browser_fakeNode = {
    addEventListener: function () {},
    removeEventListener: function () {}
  };
  var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
  var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;
  var _Browser_on = F3(function (node, eventName, sendToSelf) {
    return _Scheduler_spawn(_Scheduler_binding(function (callback) {
      function handler(event) {
        _Scheduler_rawSpawn(sendToSelf(event));
      }
      node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && {
        passive: true
      });
      return function () {
        node.removeEventListener(eventName, handler);
      };
    }));
  });
  var _Browser_decodeEvent = F2(function (decoder, event) {
    var result = _Json_runHelp(decoder, event);
    return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
  });

  // PAGE VISIBILITY

  function _Browser_visibilityInfo() {
    return typeof _VirtualDom_doc.hidden !== 'undefined' ? {
      hidden: 'hidden',
      change: 'visibilitychange'
    } : typeof _VirtualDom_doc.mozHidden !== 'undefined' ? {
      hidden: 'mozHidden',
      change: 'mozvisibilitychange'
    } : typeof _VirtualDom_doc.msHidden !== 'undefined' ? {
      hidden: 'msHidden',
      change: 'msvisibilitychange'
    } : typeof _VirtualDom_doc.webkitHidden !== 'undefined' ? {
      hidden: 'webkitHidden',
      change: 'webkitvisibilitychange'
    } : {
      hidden: 'hidden',
      change: 'visibilitychange'
    };
  }

  // ANIMATION FRAMES

  function _Browser_rAF() {
    return _Scheduler_binding(function (callback) {
      var id = _Browser_requestAnimationFrame(function () {
        callback(_Scheduler_succeed(Date.now()));
      });
      return function () {
        _Browser_cancelAnimationFrame(id);
      };
    });
  }
  function _Browser_now() {
    return _Scheduler_binding(function (callback) {
      callback(_Scheduler_succeed(Date.now()));
    });
  }

  // DOM STUFF

  function _Browser_withNode(id, doStuff) {
    return _Scheduler_binding(function (callback) {
      _Browser_requestAnimationFrame(function () {
        var node = document.getElementById(id);
        callback(node ? _Scheduler_succeed(doStuff(node)) : _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id)));
      });
    });
  }
  function _Browser_withWindow(doStuff) {
    return _Scheduler_binding(function (callback) {
      _Browser_requestAnimationFrame(function () {
        callback(_Scheduler_succeed(doStuff()));
      });
    });
  }

  // FOCUS and BLUR

  var _Browser_call = F2(function (functionName, id) {
    return _Browser_withNode(id, function (node) {
      node[functionName]();
      return _Utils_Tuple0;
    });
  });

  // WINDOW VIEWPORT

  function _Browser_getViewport() {
    return {
      scene: _Browser_getScene(),
      viewport: {
        x: _Browser_window.pageXOffset,
        y: _Browser_window.pageYOffset,
        width: _Browser_doc.documentElement.clientWidth,
        height: _Browser_doc.documentElement.clientHeight
      }
    };
  }
  function _Browser_getScene() {
    var body = _Browser_doc.body;
    var elem = _Browser_doc.documentElement;
    return {
      width: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
      height: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
    };
  }
  var _Browser_setViewport = F2(function (x, y) {
    return _Browser_withWindow(function () {
      _Browser_window.scroll(x, y);
      return _Utils_Tuple0;
    });
  });

  // ELEMENT VIEWPORT

  function _Browser_getViewportOf(id) {
    return _Browser_withNode(id, function (node) {
      return {
        scene: {
          width: node.scrollWidth,
          height: node.scrollHeight
        },
        viewport: {
          x: node.scrollLeft,
          y: node.scrollTop,
          width: node.clientWidth,
          height: node.clientHeight
        }
      };
    });
  }
  var _Browser_setViewportOf = F3(function (id, x, y) {
    return _Browser_withNode(id, function (node) {
      node.scrollLeft = x;
      node.scrollTop = y;
      return _Utils_Tuple0;
    });
  });

  // ELEMENT

  function _Browser_getElement(id) {
    return _Browser_withNode(id, function (node) {
      var rect = node.getBoundingClientRect();
      var x = _Browser_window.pageXOffset;
      var y = _Browser_window.pageYOffset;
      return {
        scene: _Browser_getScene(),
        viewport: {
          x: x,
          y: y,
          width: _Browser_doc.documentElement.clientWidth,
          height: _Browser_doc.documentElement.clientHeight
        },
        element: {
          x: x + rect.left,
          y: y + rect.top,
          width: rect.width,
          height: rect.height
        }
      };
    });
  }

  // LOAD and RELOAD

  function _Browser_reload(skipCache) {
    return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function (callback) {
      _VirtualDom_doc.location.reload(skipCache);
    }));
  }
  function _Browser_load(url) {
    return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function (callback) {
      try {
        _Browser_window.location = url;
      } catch (err) {
        // Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
        // Other browsers reload the page, so let's be consistent about that.
        _VirtualDom_doc.location.reload(false);
      }
    }));
  }

  // CREATE

  var _Regex_never = /.^/;
  var _Regex_fromStringWith = F2(function (options, string) {
    var flags = 'g';
    if (options.multiline) {
      flags += 'm';
    }
    if (options.caseInsensitive) {
      flags += 'i';
    }
    try {
      return $elm$core$Maybe$Just(new RegExp(string, flags));
    } catch (error) {
      return $elm$core$Maybe$Nothing;
    }
  });

  // USE

  var _Regex_contains = F2(function (re, string) {
    return string.match(re) !== null;
  });
  var _Regex_findAtMost = F3(function (n, re, str) {
    var out = [];
    var number = 0;
    var string = str;
    var lastIndex = re.lastIndex;
    var prevLastIndex = -1;
    var result;
    while (number++ < n && (result = re.exec(string))) {
      if (prevLastIndex == re.lastIndex) break;
      var i = result.length - 1;
      var subs = new Array(i);
      while (i > 0) {
        var submatch = result[i];
        subs[--i] = submatch ? $elm$core$Maybe$Just(submatch) : $elm$core$Maybe$Nothing;
      }
      out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
      prevLastIndex = re.lastIndex;
    }
    re.lastIndex = lastIndex;
    return _List_fromArray(out);
  });
  var _Regex_replaceAtMost = F4(function (n, re, replacer, string) {
    var count = 0;
    function jsReplacer(match) {
      if (count++ >= n) {
        return match;
      }
      var i = arguments.length - 3;
      var submatches = new Array(i);
      while (i > 0) {
        var submatch = arguments[i];
        submatches[--i] = submatch ? $elm$core$Maybe$Just(submatch) : $elm$core$Maybe$Nothing;
      }
      return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
    }
    return string.replace(re, jsReplacer);
  });
  var _Regex_splitAtMost = F3(function (n, re, str) {
    var string = str;
    var out = [];
    var start = re.lastIndex;
    var restoreLastIndex = re.lastIndex;
    while (n--) {
      var result = re.exec(string);
      if (!result) break;
      out.push(string.slice(start, result.index));
      start = re.lastIndex;
    }
    out.push(string.slice(start));
    re.lastIndex = restoreLastIndex;
    return _List_fromArray(out);
  });
  var _Regex_infinity = Infinity;

  // SEND REQUEST

  var _Http_toTask = F3(function (router, toTask, request) {
    return _Scheduler_binding(function (callback) {
      function done(response) {
        callback(toTask(request.expect.a(response)));
      }
      var xhr = new XMLHttpRequest();
      xhr.addEventListener('error', function () {
        done($elm$http$Http$NetworkError_);
      });
      xhr.addEventListener('timeout', function () {
        done($elm$http$Http$Timeout_);
      });
      xhr.addEventListener('load', function () {
        done(_Http_toResponse(request.expect.b, xhr));
      });
      $elm$core$Maybe$isJust(request.tracker) && _Http_track(router, xhr, request.tracker.a);
      try {
        xhr.open(request.method, request.url, true);
      } catch (e) {
        return done($elm$http$Http$BadUrl_(request.url));
      }
      _Http_configureRequest(xhr, request);
      request.body.a && xhr.setRequestHeader('Content-Type', request.body.a);
      xhr.send(request.body.b);
      return function () {
        xhr.c = true;
        xhr.abort();
      };
    });
  });

  // CONFIGURE

  function _Http_configureRequest(xhr, request) {
    for (var headers = request.headers; headers.b; headers = headers.b)
    // WHILE_CONS
    {
      xhr.setRequestHeader(headers.a.a, headers.a.b);
    }
    xhr.timeout = request.timeout.a || 0;
    xhr.responseType = request.expect.d;
    xhr.withCredentials = request.allowCookiesFromOtherDomains;
  }

  // RESPONSES

  function _Http_toResponse(toBody, xhr) {
    return A2(200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_, _Http_toMetadata(xhr), toBody(xhr.response));
  }

  // METADATA

  function _Http_toMetadata(xhr) {
    return {
      url: xhr.responseURL,
      statusCode: xhr.status,
      statusText: xhr.statusText,
      headers: _Http_parseHeaders(xhr.getAllResponseHeaders())
    };
  }

  // HEADERS

  function _Http_parseHeaders(rawHeaders) {
    if (!rawHeaders) {
      return $elm$core$Dict$empty;
    }
    var headers = $elm$core$Dict$empty;
    var headerPairs = rawHeaders.split('\r\n');
    for (var i = headerPairs.length; i--;) {
      var headerPair = headerPairs[i];
      var index = headerPair.indexOf(': ');
      if (index > 0) {
        var key = headerPair.substring(0, index);
        var value = headerPair.substring(index + 2);
        headers = A3($elm$core$Dict$update, key, function (oldValue) {
          return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue) ? value + ', ' + oldValue.a : value);
        }, headers);
      }
    }
    return headers;
  }

  // EXPECT

  var _Http_expect = F3(function (type, toBody, toValue) {
    return {
      $: 0,
      d: type,
      b: toBody,
      a: toValue
    };
  });
  var _Http_mapExpect = F2(function (func, expect) {
    return {
      $: 0,
      d: expect.d,
      b: expect.b,
      a: function (x) {
        return func(expect.a(x));
      }
    };
  });
  function _Http_toDataView(arrayBuffer) {
    return new DataView(arrayBuffer);
  }

  // BODY and PARTS

  var _Http_emptyBody = {
    $: 0
  };
  var _Http_pair = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  function _Http_toFormData(parts) {
    for (var formData = new FormData(); parts.b; parts = parts.b)
    // WHILE_CONS
    {
      var part = parts.a;
      formData.append(part.a, part.b);
    }
    return formData;
  }
  var _Http_bytesToBlob = F2(function (mime, bytes) {
    return new Blob([bytes], {
      type: mime
    });
  });

  // PROGRESS

  function _Http_track(router, xhr, tracker) {
    // TODO check out lengthComputable on loadstart event

    xhr.upload.addEventListener('progress', function (event) {
      if (xhr.c) {
        return;
      }
      _Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
        sent: event.loaded,
        size: event.total
      }))));
    });
    xhr.addEventListener('progress', function (event) {
      if (xhr.c) {
        return;
      }
      _Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
        received: event.loaded,
        size: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
      }))));
    });
  }
  function _Time_now(millisToPosix) {
    return _Scheduler_binding(function (callback) {
      callback(_Scheduler_succeed(millisToPosix(Date.now())));
    });
  }
  var _Time_setInterval = F2(function (interval, task) {
    return _Scheduler_binding(function (callback) {
      var id = setInterval(function () {
        _Scheduler_rawSpawn(task);
      }, interval);
      return function () {
        clearInterval(id);
      };
    });
  });
  function _Time_here() {
    return _Scheduler_binding(function (callback) {
      callback(_Scheduler_succeed(A2($elm$time$Time$customZone, -new Date().getTimezoneOffset(), _List_Nil)));
    });
  }
  function _Time_getZoneName() {
    return _Scheduler_binding(function (callback) {
      try {
        var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
      } catch (e) {
        var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
      }
      callback(_Scheduler_succeed(name));
    });
  }
  var $elm$core$Basics$EQ = {
    $: 'EQ'
  };
  var $elm$core$Basics$GT = {
    $: 'GT'
  };
  var $elm$core$Basics$LT = {
    $: 'LT'
  };
  var $elm$core$List$cons = _List_cons;
  var $elm$core$Dict$foldr = F3(function (func, acc, t) {
    foldr: while (true) {
      if (t.$ === 'RBEmpty_elm_builtin') {
        return acc;
      } else {
        var key = t.b;
        var value = t.c;
        var left = t.d;
        var right = t.e;
        var $temp$func = func,
          $temp$acc = A3(func, key, value, A3($elm$core$Dict$foldr, func, acc, right)),
          $temp$t = left;
        func = $temp$func;
        acc = $temp$acc;
        t = $temp$t;
        continue foldr;
      }
    }
  });
  var $elm$core$Dict$toList = function (dict) {
    return A3($elm$core$Dict$foldr, F3(function (key, value, list) {
      return A2($elm$core$List$cons, _Utils_Tuple2(key, value), list);
    }), _List_Nil, dict);
  };
  var $elm$core$Dict$keys = function (dict) {
    return A3($elm$core$Dict$foldr, F3(function (key, value, keyList) {
      return A2($elm$core$List$cons, key, keyList);
    }), _List_Nil, dict);
  };
  var $elm$core$Set$toList = function (_v0) {
    var dict = _v0.a;
    return $elm$core$Dict$keys(dict);
  };
  var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
  var $elm$core$Array$foldr = F3(function (func, baseCase, _v0) {
    var tree = _v0.c;
    var tail = _v0.d;
    var helper = F2(function (node, acc) {
      if (node.$ === 'SubTree') {
        var subTree = node.a;
        return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
      } else {
        var values = node.a;
        return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
      }
    });
    return A3($elm$core$Elm$JsArray$foldr, helper, A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail), tree);
  });
  var $elm$core$Array$toList = function (array) {
    return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
  };
  var $elm$core$Result$Err = function (a) {
    return {
      $: 'Err',
      a: a
    };
  };
  var $elm$json$Json$Decode$Failure = F2(function (a, b) {
    return {
      $: 'Failure',
      a: a,
      b: b
    };
  });
  var $elm$json$Json$Decode$Field = F2(function (a, b) {
    return {
      $: 'Field',
      a: a,
      b: b
    };
  });
  var $elm$json$Json$Decode$Index = F2(function (a, b) {
    return {
      $: 'Index',
      a: a,
      b: b
    };
  });
  var $elm$core$Result$Ok = function (a) {
    return {
      $: 'Ok',
      a: a
    };
  };
  var $elm$json$Json$Decode$OneOf = function (a) {
    return {
      $: 'OneOf',
      a: a
    };
  };
  var $elm$core$Basics$False = {
    $: 'False'
  };
  var $elm$core$Basics$add = _Basics_add;
  var $elm$core$Maybe$Just = function (a) {
    return {
      $: 'Just',
      a: a
    };
  };
  var $elm$core$Maybe$Nothing = {
    $: 'Nothing'
  };
  var $elm$core$String$all = _String_all;
  var $elm$core$Basics$and = _Basics_and;
  var $elm$core$Basics$append = _Utils_append;
  var $elm$json$Json$Encode$encode = _Json_encode;
  var $elm$core$String$fromInt = _String_fromNumber;
  var $elm$core$String$join = F2(function (sep, chunks) {
    return A2(_String_join, sep, _List_toArray(chunks));
  });
  var $elm$core$String$split = F2(function (sep, string) {
    return _List_fromArray(A2(_String_split, sep, string));
  });
  var $elm$json$Json$Decode$indent = function (str) {
    return A2($elm$core$String$join, '\n    ', A2($elm$core$String$split, '\n', str));
  };
  var $elm$core$List$foldl = F3(function (func, acc, list) {
    foldl: while (true) {
      if (!list.b) {
        return acc;
      } else {
        var x = list.a;
        var xs = list.b;
        var $temp$func = func,
          $temp$acc = A2(func, x, acc),
          $temp$list = xs;
        func = $temp$func;
        acc = $temp$acc;
        list = $temp$list;
        continue foldl;
      }
    }
  });
  var $elm$core$List$length = function (xs) {
    return A3($elm$core$List$foldl, F2(function (_v0, i) {
      return i + 1;
    }), 0, xs);
  };
  var $elm$core$List$map2 = _List_map2;
  var $elm$core$Basics$le = _Utils_le;
  var $elm$core$Basics$sub = _Basics_sub;
  var $elm$core$List$rangeHelp = F3(function (lo, hi, list) {
    rangeHelp: while (true) {
      if (_Utils_cmp(lo, hi) < 1) {
        var $temp$lo = lo,
          $temp$hi = hi - 1,
          $temp$list = A2($elm$core$List$cons, hi, list);
        lo = $temp$lo;
        hi = $temp$hi;
        list = $temp$list;
        continue rangeHelp;
      } else {
        return list;
      }
    }
  });
  var $elm$core$List$range = F2(function (lo, hi) {
    return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
  });
  var $elm$core$List$indexedMap = F2(function (f, xs) {
    return A3($elm$core$List$map2, f, A2($elm$core$List$range, 0, $elm$core$List$length(xs) - 1), xs);
  });
  var $elm$core$Char$toCode = _Char_toCode;
  var $elm$core$Char$isLower = function (_char) {
    var code = $elm$core$Char$toCode(_char);
    return 97 <= code && code <= 122;
  };
  var $elm$core$Char$isUpper = function (_char) {
    var code = $elm$core$Char$toCode(_char);
    return code <= 90 && 65 <= code;
  };
  var $elm$core$Basics$or = _Basics_or;
  var $elm$core$Char$isAlpha = function (_char) {
    return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
  };
  var $elm$core$Char$isDigit = function (_char) {
    var code = $elm$core$Char$toCode(_char);
    return code <= 57 && 48 <= code;
  };
  var $elm$core$Char$isAlphaNum = function (_char) {
    return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char);
  };
  var $elm$core$List$reverse = function (list) {
    return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
  };
  var $elm$core$String$uncons = _String_uncons;
  var $elm$json$Json$Decode$errorOneOf = F2(function (i, error) {
    return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent($elm$json$Json$Decode$errorToString(error))));
  });
  var $elm$json$Json$Decode$errorToString = function (error) {
    return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
  };
  var $elm$json$Json$Decode$errorToStringHelp = F2(function (error, context) {
    errorToStringHelp: while (true) {
      switch (error.$) {
        case 'Field':
          var f = error.a;
          var err = error.b;
          var isSimple = function () {
            var _v1 = $elm$core$String$uncons(f);
            if (_v1.$ === 'Nothing') {
              return false;
            } else {
              var _v2 = _v1.a;
              var _char = _v2.a;
              var rest = _v2.b;
              return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
            }
          }();
          var fieldName = isSimple ? '.' + f : '[\'' + (f + '\']');
          var $temp$error = err,
            $temp$context = A2($elm$core$List$cons, fieldName, context);
          error = $temp$error;
          context = $temp$context;
          continue errorToStringHelp;
        case 'Index':
          var i = error.a;
          var err = error.b;
          var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
          var $temp$error = err,
            $temp$context = A2($elm$core$List$cons, indexName, context);
          error = $temp$error;
          context = $temp$context;
          continue errorToStringHelp;
        case 'OneOf':
          var errors = error.a;
          if (!errors.b) {
            return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
              if (!context.b) {
                return '!';
              } else {
                return ' at json' + A2($elm$core$String$join, '', $elm$core$List$reverse(context));
              }
            }();
          } else {
            if (!errors.b.b) {
              var err = errors.a;
              var $temp$error = err,
                $temp$context = context;
              error = $temp$error;
              context = $temp$context;
              continue errorToStringHelp;
            } else {
              var starter = function () {
                if (!context.b) {
                  return 'Json.Decode.oneOf';
                } else {
                  return 'The Json.Decode.oneOf at json' + A2($elm$core$String$join, '', $elm$core$List$reverse(context));
                }
              }();
              var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt($elm$core$List$length(errors)) + ' ways:'));
              return A2($elm$core$String$join, '\n\n', A2($elm$core$List$cons, introduction, A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
            }
          }
        default:
          var msg = error.a;
          var json = error.b;
          var introduction = function () {
            if (!context.b) {
              return 'Problem with the given value:\n\n';
            } else {
              return 'Problem with the value at json' + (A2($elm$core$String$join, '', $elm$core$List$reverse(context)) + ':\n\n    ');
            }
          }();
          return introduction + ($elm$json$Json$Decode$indent(A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
      }
    }
  });
  var $elm$core$Array$branchFactor = 32;
  var $elm$core$Array$Array_elm_builtin = F4(function (a, b, c, d) {
    return {
      $: 'Array_elm_builtin',
      a: a,
      b: b,
      c: c,
      d: d
    };
  });
  var $elm$core$Elm$JsArray$empty = _JsArray_empty;
  var $elm$core$Basics$ceiling = _Basics_ceiling;
  var $elm$core$Basics$fdiv = _Basics_fdiv;
  var $elm$core$Basics$logBase = F2(function (base, number) {
    return _Basics_log(number) / _Basics_log(base);
  });
  var $elm$core$Basics$toFloat = _Basics_toFloat;
  var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
  var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
  var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
  var $elm$core$Array$Leaf = function (a) {
    return {
      $: 'Leaf',
      a: a
    };
  };
  var $elm$core$Basics$apL = F2(function (f, x) {
    return f(x);
  });
  var $elm$core$Basics$apR = F2(function (x, f) {
    return f(x);
  });
  var $elm$core$Basics$eq = _Utils_equal;
  var $elm$core$Basics$floor = _Basics_floor;
  var $elm$core$Elm$JsArray$length = _JsArray_length;
  var $elm$core$Basics$gt = _Utils_gt;
  var $elm$core$Basics$max = F2(function (x, y) {
    return _Utils_cmp(x, y) > 0 ? x : y;
  });
  var $elm$core$Basics$mul = _Basics_mul;
  var $elm$core$Array$SubTree = function (a) {
    return {
      $: 'SubTree',
      a: a
    };
  };
  var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
  var $elm$core$Array$compressNodes = F2(function (nodes, acc) {
    compressNodes: while (true) {
      var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
      var node = _v0.a;
      var remainingNodes = _v0.b;
      var newAcc = A2($elm$core$List$cons, $elm$core$Array$SubTree(node), acc);
      if (!remainingNodes.b) {
        return $elm$core$List$reverse(newAcc);
      } else {
        var $temp$nodes = remainingNodes,
          $temp$acc = newAcc;
        nodes = $temp$nodes;
        acc = $temp$acc;
        continue compressNodes;
      }
    }
  });
  var $elm$core$Tuple$first = function (_v0) {
    var x = _v0.a;
    return x;
  };
  var $elm$core$Array$treeFromBuilder = F2(function (nodeList, nodeListSize) {
    treeFromBuilder: while (true) {
      var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
      if (newNodeSize === 1) {
        return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
      } else {
        var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
          $temp$nodeListSize = newNodeSize;
        nodeList = $temp$nodeList;
        nodeListSize = $temp$nodeListSize;
        continue treeFromBuilder;
      }
    }
  });
  var $elm$core$Array$builderToArray = F2(function (reverseNodeList, builder) {
    if (!builder.nodeListSize) {
      return A4($elm$core$Array$Array_elm_builtin, $elm$core$Elm$JsArray$length(builder.tail), $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, builder.tail);
    } else {
      var treeLen = builder.nodeListSize * $elm$core$Array$branchFactor;
      var depth = $elm$core$Basics$floor(A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
      var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.nodeList) : builder.nodeList;
      var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.nodeListSize);
      return A4($elm$core$Array$Array_elm_builtin, $elm$core$Elm$JsArray$length(builder.tail) + treeLen, A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep), tree, builder.tail);
    }
  });
  var $elm$core$Basics$idiv = _Basics_idiv;
  var $elm$core$Basics$lt = _Utils_lt;
  var $elm$core$Array$initializeHelp = F5(function (fn, fromIndex, len, nodeList, tail) {
    initializeHelp: while (true) {
      if (fromIndex < 0) {
        return A2($elm$core$Array$builderToArray, false, {
          nodeList: nodeList,
          nodeListSize: len / $elm$core$Array$branchFactor | 0,
          tail: tail
        });
      } else {
        var leaf = $elm$core$Array$Leaf(A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
        var $temp$fn = fn,
          $temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
          $temp$len = len,
          $temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
          $temp$tail = tail;
        fn = $temp$fn;
        fromIndex = $temp$fromIndex;
        len = $temp$len;
        nodeList = $temp$nodeList;
        tail = $temp$tail;
        continue initializeHelp;
      }
    }
  });
  var $elm$core$Basics$remainderBy = _Basics_remainderBy;
  var $elm$core$Array$initialize = F2(function (len, fn) {
    if (len <= 0) {
      return $elm$core$Array$empty;
    } else {
      var tailLen = len % $elm$core$Array$branchFactor;
      var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
      var initialFromIndex = len - tailLen - $elm$core$Array$branchFactor;
      return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
    }
  });
  var $elm$core$Basics$True = {
    $: 'True'
  };
  var $elm$core$Result$isOk = function (result) {
    if (result.$ === 'Ok') {
      return true;
    } else {
      return false;
    }
  };
  var $elm$json$Json$Decode$map = _Json_map1;
  var $elm$json$Json$Decode$map2 = _Json_map2;
  var $elm$json$Json$Decode$succeed = _Json_succeed;
  var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
    switch (handler.$) {
      case 'Normal':
        return 0;
      case 'MayStopPropagation':
        return 1;
      case 'MayPreventDefault':
        return 2;
      default:
        return 3;
    }
  };
  var $elm$browser$Browser$External = function (a) {
    return {
      $: 'External',
      a: a
    };
  };
  var $elm$browser$Browser$Internal = function (a) {
    return {
      $: 'Internal',
      a: a
    };
  };
  var $elm$core$Basics$identity = function (x) {
    return x;
  };
  var $elm$browser$Browser$Dom$NotFound = function (a) {
    return {
      $: 'NotFound',
      a: a
    };
  };
  var $elm$url$Url$Http = {
    $: 'Http'
  };
  var $elm$url$Url$Https = {
    $: 'Https'
  };
  var $elm$url$Url$Url = F6(function (protocol, host, port_, path, query, fragment) {
    return {
      fragment: fragment,
      host: host,
      path: path,
      port_: port_,
      protocol: protocol,
      query: query
    };
  });
  var $elm$core$String$contains = _String_contains;
  var $elm$core$String$length = _String_length;
  var $elm$core$String$slice = _String_slice;
  var $elm$core$String$dropLeft = F2(function (n, string) {
    return n < 1 ? string : A3($elm$core$String$slice, n, $elm$core$String$length(string), string);
  });
  var $elm$core$String$indexes = _String_indexes;
  var $elm$core$String$isEmpty = function (string) {
    return string === '';
  };
  var $elm$core$String$left = F2(function (n, string) {
    return n < 1 ? '' : A3($elm$core$String$slice, 0, n, string);
  });
  var $elm$core$String$toInt = _String_toInt;
  var $elm$url$Url$chompBeforePath = F5(function (protocol, path, params, frag, str) {
    if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
      return $elm$core$Maybe$Nothing;
    } else {
      var _v0 = A2($elm$core$String$indexes, ':', str);
      if (!_v0.b) {
        return $elm$core$Maybe$Just(A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
      } else {
        if (!_v0.b.b) {
          var i = _v0.a;
          var _v1 = $elm$core$String$toInt(A2($elm$core$String$dropLeft, i + 1, str));
          if (_v1.$ === 'Nothing') {
            return $elm$core$Maybe$Nothing;
          } else {
            var port_ = _v1;
            return $elm$core$Maybe$Just(A6($elm$url$Url$Url, protocol, A2($elm$core$String$left, i, str), port_, path, params, frag));
          }
        } else {
          return $elm$core$Maybe$Nothing;
        }
      }
    }
  });
  var $elm$url$Url$chompBeforeQuery = F4(function (protocol, params, frag, str) {
    if ($elm$core$String$isEmpty(str)) {
      return $elm$core$Maybe$Nothing;
    } else {
      var _v0 = A2($elm$core$String$indexes, '/', str);
      if (!_v0.b) {
        return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
      } else {
        var i = _v0.a;
        return A5($elm$url$Url$chompBeforePath, protocol, A2($elm$core$String$dropLeft, i, str), params, frag, A2($elm$core$String$left, i, str));
      }
    }
  });
  var $elm$url$Url$chompBeforeFragment = F3(function (protocol, frag, str) {
    if ($elm$core$String$isEmpty(str)) {
      return $elm$core$Maybe$Nothing;
    } else {
      var _v0 = A2($elm$core$String$indexes, '?', str);
      if (!_v0.b) {
        return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
      } else {
        var i = _v0.a;
        return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Just(A2($elm$core$String$dropLeft, i + 1, str)), frag, A2($elm$core$String$left, i, str));
      }
    }
  });
  var $elm$url$Url$chompAfterProtocol = F2(function (protocol, str) {
    if ($elm$core$String$isEmpty(str)) {
      return $elm$core$Maybe$Nothing;
    } else {
      var _v0 = A2($elm$core$String$indexes, '#', str);
      if (!_v0.b) {
        return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
      } else {
        var i = _v0.a;
        return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Just(A2($elm$core$String$dropLeft, i + 1, str)), A2($elm$core$String$left, i, str));
      }
    }
  });
  var $elm$core$String$startsWith = _String_startsWith;
  var $elm$url$Url$fromString = function (str) {
    return A2($elm$core$String$startsWith, 'http://', str) ? A2($elm$url$Url$chompAfterProtocol, $elm$url$Url$Http, A2($elm$core$String$dropLeft, 7, str)) : A2($elm$core$String$startsWith, 'https://', str) ? A2($elm$url$Url$chompAfterProtocol, $elm$url$Url$Https, A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing;
  };
  var $elm$core$Basics$never = function (_v0) {
    never: while (true) {
      var nvr = _v0.a;
      var $temp$_v0 = nvr;
      _v0 = $temp$_v0;
      continue never;
    }
  };
  var $elm$core$Task$Perform = function (a) {
    return {
      $: 'Perform',
      a: a
    };
  };
  var $elm$core$Task$succeed = _Scheduler_succeed;
  var $elm$core$Task$init = $elm$core$Task$succeed(_Utils_Tuple0);
  var $elm$core$List$foldrHelper = F4(function (fn, acc, ctr, ls) {
    if (!ls.b) {
      return acc;
    } else {
      var a = ls.a;
      var r1 = ls.b;
      if (!r1.b) {
        return A2(fn, a, acc);
      } else {
        var b = r1.a;
        var r2 = r1.b;
        if (!r2.b) {
          return A2(fn, a, A2(fn, b, acc));
        } else {
          var c = r2.a;
          var r3 = r2.b;
          if (!r3.b) {
            return A2(fn, a, A2(fn, b, A2(fn, c, acc)));
          } else {
            var d = r3.a;
            var r4 = r3.b;
            var res = ctr > 500 ? A3($elm$core$List$foldl, fn, acc, $elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
            return A2(fn, a, A2(fn, b, A2(fn, c, A2(fn, d, res))));
          }
        }
      }
    }
  });
  var $elm$core$List$foldr = F3(function (fn, acc, ls) {
    return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
  });
  var $elm$core$List$map = F2(function (f, xs) {
    return A3($elm$core$List$foldr, F2(function (x, acc) {
      return A2($elm$core$List$cons, f(x), acc);
    }), _List_Nil, xs);
  });
  var $elm$core$Task$andThen = _Scheduler_andThen;
  var $elm$core$Task$map = F2(function (func, taskA) {
    return A2($elm$core$Task$andThen, function (a) {
      return $elm$core$Task$succeed(func(a));
    }, taskA);
  });
  var $elm$core$Task$map2 = F3(function (func, taskA, taskB) {
    return A2($elm$core$Task$andThen, function (a) {
      return A2($elm$core$Task$andThen, function (b) {
        return $elm$core$Task$succeed(A2(func, a, b));
      }, taskB);
    }, taskA);
  });
  var $elm$core$Task$sequence = function (tasks) {
    return A3($elm$core$List$foldr, $elm$core$Task$map2($elm$core$List$cons), $elm$core$Task$succeed(_List_Nil), tasks);
  };
  var $elm$core$Platform$sendToApp = _Platform_sendToApp;
  var $elm$core$Task$spawnCmd = F2(function (router, _v0) {
    var task = _v0.a;
    return _Scheduler_spawn(A2($elm$core$Task$andThen, $elm$core$Platform$sendToApp(router), task));
  });
  var $elm$core$Task$onEffects = F3(function (router, commands, state) {
    return A2($elm$core$Task$map, function (_v0) {
      return _Utils_Tuple0;
    }, $elm$core$Task$sequence(A2($elm$core$List$map, $elm$core$Task$spawnCmd(router), commands)));
  });
  var $elm$core$Task$onSelfMsg = F3(function (_v0, _v1, _v2) {
    return $elm$core$Task$succeed(_Utils_Tuple0);
  });
  var $elm$core$Task$cmdMap = F2(function (tagger, _v0) {
    var task = _v0.a;
    return $elm$core$Task$Perform(A2($elm$core$Task$map, tagger, task));
  });
  _Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
  var $elm$core$Task$command = _Platform_leaf('Task');
  var $elm$core$Task$perform = F2(function (toMessage, task) {
    return $elm$core$Task$command($elm$core$Task$Perform(A2($elm$core$Task$map, toMessage, task)));
  });
  var $elm$browser$Browser$element = _Browser_element;
  var $author$project$ResponsePreviewSetup$Types$AppError = {
    $: 'AppError'
  };
  var $author$project$ResponsePreviewSetup$Types$AppOk = function (a) {
    return {
      $: 'AppOk',
      a: a
    };
  };
  var $elm$json$Json$Decode$decodeValue = _Json_run;
  var $elm$core$Platform$Cmd$batch = _Platform_batch;
  var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
  var $author$project$ResponsePreviewSetup$Decoders$Types$ResponsePreviewSetupData = F3(function (accountDemographics, demographicValueAssignments, appContext) {
    return {
      accountDemographics: accountDemographics,
      appContext: appContext,
      demographicValueAssignments: demographicValueAssignments
    };
  });
  var $author$project$ResponsePreviewSetup$Decoders$Types$AccountDemographicData = F3(function (id, name, selectOptions) {
    return {
      id: id,
      name: name,
      selectOptions: selectOptions
    };
  });
  var $author$project$ResponsePreviewSetup$Common$Types$DemographicId = function (a) {
    return {
      $: 'DemographicId',
      a: a
    };
  };
  var $elm$json$Json$Decode$andThen = _Json_andThen;
  var $elm$json$Json$Decode$fail = _Json_fail;
  var $author$project$SurveyBuilderCommon$Uuid$Uuid = function (a) {
    return {
      $: 'Uuid',
      a: a
    };
  };
  var $elm$regex$Regex$Match = F4(function (match, index, number, submatches) {
    return {
      index: index,
      match: match,
      number: number,
      submatches: submatches
    };
  });
  var $elm$regex$Regex$contains = _Regex_contains;
  var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
  var $elm$regex$Regex$fromString = function (string) {
    return A2($elm$regex$Regex$fromStringWith, {
      caseInsensitive: false,
      multiline: false
    }, string);
  };
  var $elm$regex$Regex$never = _Regex_never;
  var $elm$core$Maybe$withDefault = F2(function (_default, maybe) {
    if (maybe.$ === 'Just') {
      var value = maybe.a;
      return value;
    } else {
      return _default;
    }
  });
  var $author$project$SurveyBuilderCommon$Uuid$murmurCorruptedUuid = function () {
    var regex = $elm$regex$Regex$fromString('^[0-9A-Fa-f]{8,8}-[0-9A-Fa-f]{4,4}-[0-9A-Fa-f]{4,4}-[0-9A-Fa-f]{4,4}-[0-9A-Fa-f]{12,12}$');
    return A2($elm$core$Maybe$withDefault, $elm$regex$Regex$never, regex);
  }();
  var $author$project$SurveyBuilderCommon$Uuid$isValidUuid = function (uuidAsString) {
    return A2($elm$regex$Regex$contains, $author$project$SurveyBuilderCommon$Uuid$murmurCorruptedUuid, uuidAsString);
  };
  var $elm$core$String$toLower = _String_toLower;
  var $author$project$SurveyBuilderCommon$Uuid$fromString = function (text) {
    return $author$project$SurveyBuilderCommon$Uuid$isValidUuid(text) ? $elm$core$Maybe$Just($author$project$SurveyBuilderCommon$Uuid$Uuid($elm$core$String$toLower(text))) : $elm$core$Maybe$Nothing;
  };
  var $elm$json$Json$Decode$string = _Json_decodeString;
  var $author$project$SurveyBuilderCommon$Uuid$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    var _v0 = $author$project$SurveyBuilderCommon$Uuid$fromString(string);
    if (_v0.$ === 'Just') {
      var uuid = _v0.a;
      return $elm$json$Json$Decode$succeed(uuid);
    } else {
      return $elm$json$Json$Decode$fail('Not a valid UUID');
    }
  }, $elm$json$Json$Decode$string);
  var $elm$json$Json$Decode$list = _Json_decodeList;
  var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
  var $elm$json$Json$Decode$field = _Json_decodeField;
  var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(function (key, valDecoder, decoder) {
    return A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, A2($elm$json$Json$Decode$field, key, valDecoder), decoder);
  });
  var $author$project$ResponsePreviewSetup$Common$Types$DemographicValueId = function (a) {
    return {
      $: 'DemographicValueId',
      a: a
    };
  };
  var $author$project$ResponsePreviewSetup$Decoders$Types$SelectOptionData = F2(function (id, shortLabel) {
    return {
      id: id,
      shortLabel: shortLabel
    };
  });
  var $elm$core$Dict$RBEmpty_elm_builtin = {
    $: 'RBEmpty_elm_builtin'
  };
  var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
  var $elm$core$Dict$Black = {
    $: 'Black'
  };
  var $elm$core$Dict$RBNode_elm_builtin = F5(function (a, b, c, d, e) {
    return {
      $: 'RBNode_elm_builtin',
      a: a,
      b: b,
      c: c,
      d: d,
      e: e
    };
  });
  var $elm$core$Dict$Red = {
    $: 'Red'
  };
  var $elm$core$Dict$balance = F5(function (color, key, value, left, right) {
    if (right.$ === 'RBNode_elm_builtin' && right.a.$ === 'Red') {
      var _v1 = right.a;
      var rK = right.b;
      var rV = right.c;
      var rLeft = right.d;
      var rRight = right.e;
      if (left.$ === 'RBNode_elm_builtin' && left.a.$ === 'Red') {
        var _v3 = left.a;
        var lK = left.b;
        var lV = left.c;
        var lLeft = left.d;
        var lRight = left.e;
        return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, lK, lV, lLeft, lRight), A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, rK, rV, rLeft, rRight));
      } else {
        return A5($elm$core$Dict$RBNode_elm_builtin, color, rK, rV, A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, left, rLeft), rRight);
      }
    } else {
      if (left.$ === 'RBNode_elm_builtin' && left.a.$ === 'Red' && left.d.$ === 'RBNode_elm_builtin' && left.d.a.$ === 'Red') {
        var _v5 = left.a;
        var lK = left.b;
        var lV = left.c;
        var _v6 = left.d;
        var _v7 = _v6.a;
        var llK = _v6.b;
        var llV = _v6.c;
        var llLeft = _v6.d;
        var llRight = _v6.e;
        var lRight = left.e;
        return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, llK, llV, llLeft, llRight), A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, key, value, lRight, right));
      } else {
        return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
      }
    }
  });
  var $elm$core$Basics$compare = _Utils_compare;
  var $elm$core$Dict$insertHelp = F3(function (key, value, dict) {
    if (dict.$ === 'RBEmpty_elm_builtin') {
      return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
    } else {
      var nColor = dict.a;
      var nKey = dict.b;
      var nValue = dict.c;
      var nLeft = dict.d;
      var nRight = dict.e;
      var _v1 = A2($elm$core$Basics$compare, key, nKey);
      switch (_v1.$) {
        case 'LT':
          return A5($elm$core$Dict$balance, nColor, nKey, nValue, A3($elm$core$Dict$insertHelp, key, value, nLeft), nRight);
        case 'EQ':
          return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
        default:
          return A5($elm$core$Dict$balance, nColor, nKey, nValue, nLeft, A3($elm$core$Dict$insertHelp, key, value, nRight));
      }
    }
  });
  var $elm$core$Dict$insert = F3(function (key, value, dict) {
    var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
    if (_v0.$ === 'RBNode_elm_builtin' && _v0.a.$ === 'Red') {
      var _v1 = _v0.a;
      var k = _v0.b;
      var v = _v0.c;
      var l = _v0.d;
      var r = _v0.e;
      return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, l, r);
    } else {
      var x = _v0;
      return x;
    }
  });
  var $elm$core$Dict$fromList = function (assocs) {
    return A3($elm$core$List$foldl, F2(function (_v0, dict) {
      var key = _v0.a;
      var value = _v0.b;
      return A3($elm$core$Dict$insert, key, value, dict);
    }), $elm$core$Dict$empty, assocs);
  };
  var $author$project$SurveyBuilderCommon$Translations$recordToTuple = function (_v0) {
    var locale = _v0.locale;
    var value = _v0.value;
    return _Utils_Tuple2(locale, value);
  };
  var $author$project$SurveyBuilderCommon$Translations$dictFromList = function (listOfTranslatableElements) {
    return $elm$core$Dict$fromList(A2($elm$core$List$map, $author$project$SurveyBuilderCommon$Translations$recordToTuple, listOfTranslatableElements));
  };
  var $author$project$SurveyBuilderCommon$Translations$TranslatableElement = F2(function (locale, value) {
    return {
      locale: locale,
      value: value
    };
  });
  var $author$project$SurveyBuilderCommon$Translations$translatableElementDecoder = function (valueDecoder) {
    return A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'value', valueDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'locale', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$SurveyBuilderCommon$Translations$TranslatableElement)));
  };
  var $author$project$SurveyBuilderCommon$Translations$translatableDecoder = function (valueDecoder) {
    return A2($elm$json$Json$Decode$map, $author$project$SurveyBuilderCommon$Translations$dictFromList, $elm$json$Json$Decode$list($author$project$SurveyBuilderCommon$Translations$translatableElementDecoder(valueDecoder)));
  };
  var $author$project$SurveyBuilderCommon$Translations$translatableStringDecoder = $author$project$SurveyBuilderCommon$Translations$translatableDecoder($elm$json$Json$Decode$string);
  var $author$project$ResponsePreviewSetup$Decoders$Decoders$selectOptionDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'value', $author$project$SurveyBuilderCommon$Translations$translatableStringDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'demographic_value_id', A2($elm$json$Json$Decode$map, $author$project$ResponsePreviewSetup$Common$Types$DemographicValueId, $author$project$SurveyBuilderCommon$Uuid$decoder), $elm$json$Json$Decode$succeed($author$project$ResponsePreviewSetup$Decoders$Types$SelectOptionData)));
  var $author$project$ResponsePreviewSetup$Decoders$Decoders$accountDemographicDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'select_options', $elm$json$Json$Decode$list($author$project$ResponsePreviewSetup$Decoders$Decoders$selectOptionDecoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $author$project$SurveyBuilderCommon$Translations$translatableStringDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', A2($elm$json$Json$Decode$map, $author$project$ResponsePreviewSetup$Common$Types$DemographicId, $author$project$SurveyBuilderCommon$Uuid$decoder), $elm$json$Json$Decode$succeed($author$project$ResponsePreviewSetup$Decoders$Types$AccountDemographicData))));
  var $author$project$ResponsePreviewSetup$Common$AppContext$AppContext = F3(function (securityToken, secret, actions) {
    return {
      actions: actions,
      secret: secret,
      securityToken: securityToken
    };
  });
  var $author$project$ResponsePreviewSetup$Common$AppContext$Secret = function (a) {
    return {
      $: 'Secret',
      a: a
    };
  };
  var $author$project$SurveyDesigner$Common$AppContext$SecurityToken = function (a) {
    return {
      $: 'SecurityToken',
      a: a
    };
  };
  var $author$project$ResponsePreviewSetup$Common$AppContext$Actions = F2(function (setupPreviewAction, demographicSelectOptionsAction) {
    return {
      demographicSelectOptionsAction: demographicSelectOptionsAction,
      setupPreviewAction: setupPreviewAction
    };
  });
  var $author$project$ResponsePreviewSetup$Decoders$Decoders$actionsDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'demographic_select_options_action', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'setup_preview_action', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$ResponsePreviewSetup$Common$AppContext$Actions)));
  var $elm$json$Json$Decode$at = F2(function (fields, decoder) {
    return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
  });
  var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(function (path, valDecoder, decoder) {
    return A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, A2($elm$json$Json$Decode$at, path, valDecoder), decoder);
  });
  var $author$project$ResponsePreviewSetup$Decoders$Decoders$appContextDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt, _List_Nil, $author$project$ResponsePreviewSetup$Decoders$Decoders$actionsDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'secret', A2($elm$json$Json$Decode$map, $author$project$ResponsePreviewSetup$Common$AppContext$Secret, $elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'securityToken', A2($elm$json$Json$Decode$map, $author$project$SurveyDesigner$Common$AppContext$SecurityToken, $elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$ResponsePreviewSetup$Common$AppContext$AppContext))));
  var $author$project$ResponsePreviewSetup$Decoders$Types$DemographicAssignmentData = F2(function (demographicId, demographicValueId) {
    return {
      demographicId: demographicId,
      demographicValueId: demographicValueId
    };
  });
  var $author$project$ResponsePreviewSetup$Decoders$Decoders$demographicAssignmentDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'demographic_value_id', A2($elm$json$Json$Decode$map, $author$project$ResponsePreviewSetup$Common$Types$DemographicValueId, $author$project$SurveyBuilderCommon$Uuid$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'demographic_id', A2($elm$json$Json$Decode$map, $author$project$ResponsePreviewSetup$Common$Types$DemographicId, $author$project$SurveyBuilderCommon$Uuid$decoder), $elm$json$Json$Decode$succeed($author$project$ResponsePreviewSetup$Decoders$Types$DemographicAssignmentData)));
  var $author$project$ResponsePreviewSetup$Decoders$Decoders$responsePreviewSetupDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt, _List_Nil, $author$project$ResponsePreviewSetup$Decoders$Decoders$appContextDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt, _List_fromArray(['data', 'demographic_value_assignments']), $elm$json$Json$Decode$list($author$project$ResponsePreviewSetup$Decoders$Decoders$demographicAssignmentDecoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt, _List_fromArray(['data', 'account_demographics']), $elm$json$Json$Decode$list($author$project$ResponsePreviewSetup$Decoders$Decoders$accountDemographicDecoder), $elm$json$Json$Decode$succeed($author$project$ResponsePreviewSetup$Decoders$Types$ResponsePreviewSetupData))));
  var $author$project$ResponsePreviewSetup$Common$Types$NoData = {
    $: 'NoData'
  };
  var $elm$core$Basics$round = _Basics_round;
  var $Gizra$elm_debouncer$Debouncer$Internal$fromSeconds = function (s) {
    return $elm$core$Basics$round(s * 1000);
  };
  var $Gizra$elm_debouncer$Debouncer$Basic$fromSeconds = $Gizra$elm_debouncer$Debouncer$Internal$fromSeconds;
  var $author$project$KaizenDraft$Select$Select$Mouse = {
    $: 'Mouse'
  };
  var $author$project$KaizenDraft$Select$Select$NothingMousedown = {
    $: 'NothingMousedown'
  };
  var $author$project$KaizenDraft$Select$Select$State = function (a) {
    return {
      $: 'State',
      a: a
    };
  };
  var $author$project$KaizenDraft$Select$Select$initState = $author$project$KaizenDraft$Select$Select$State({
    activeTargetIndex: 0,
    controlFocused: false,
    initialMousedown: $author$project$KaizenDraft$Select$Select$NothingMousedown,
    inputValue: $elm$core$Maybe$Nothing,
    menuListScrollTop: 0,
    menuNavigation: $author$project$KaizenDraft$Select$Select$Mouse,
    menuOpen: false,
    menuViewportFocusNodes: $elm$core$Maybe$Nothing,
    usePorts: false
  });
  var $Gizra$elm_debouncer$Debouncer$Internal$Config = function (a) {
    return {
      $: 'Config',
      a: a
    };
  };
  var $Gizra$elm_debouncer$Debouncer$Internal$lastInput = F2(function (i, o) {
    return $elm$core$Maybe$Just(i);
  });
  var $Gizra$elm_debouncer$Debouncer$Internal$manual = $Gizra$elm_debouncer$Debouncer$Internal$Config({
    accumulator: $Gizra$elm_debouncer$Debouncer$Internal$lastInput,
    emitWhenUnsettled: $elm$core$Maybe$Nothing,
    emitWhileUnsettled: $elm$core$Maybe$Nothing,
    settleWhenQuietFor: $elm$core$Maybe$Nothing
  });
  var $Gizra$elm_debouncer$Debouncer$Basic$manual = $Gizra$elm_debouncer$Debouncer$Internal$manual;
  var $author$project$ResponsePreviewSetup$Mappers$selectOptionMapper = function (selectOptionData) {
    return {
      id: selectOptionData.id,
      name: selectOptionData.shortLabel
    };
  };
  var $elm$core$Maybe$andThen = F2(function (callback, maybeValue) {
    if (maybeValue.$ === 'Just') {
      var value = maybeValue.a;
      return callback(value);
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });
  var $author$project$SurveyBuilderCommon$Uuid$toString = function (_v0) {
    var internalString = _v0.a;
    return internalString;
  };
  var $author$project$ResponsePreviewSetup$Common$Types$demographicIdToString = function (_v0) {
    var demographicId = _v0.a;
    return $author$project$SurveyBuilderCommon$Uuid$toString(demographicId);
  };
  var $elm_community$list_extra$List$Extra$find = F2(function (predicate, list) {
    find: while (true) {
      if (!list.b) {
        return $elm$core$Maybe$Nothing;
      } else {
        var first = list.a;
        var rest = list.b;
        if (predicate(first)) {
          return $elm$core$Maybe$Just(first);
        } else {
          var $temp$predicate = predicate,
            $temp$list = rest;
          predicate = $temp$predicate;
          list = $temp$list;
          continue find;
        }
      }
    }
  });
  var $elm$core$Dict$get = F2(function (targetKey, dict) {
    get: while (true) {
      if (dict.$ === 'RBEmpty_elm_builtin') {
        return $elm$core$Maybe$Nothing;
      } else {
        var key = dict.b;
        var value = dict.c;
        var left = dict.d;
        var right = dict.e;
        var _v1 = A2($elm$core$Basics$compare, targetKey, key);
        switch (_v1.$) {
          case 'LT':
            var $temp$targetKey = targetKey,
              $temp$dict = left;
            targetKey = $temp$targetKey;
            dict = $temp$dict;
            continue get;
          case 'EQ':
            return $elm$core$Maybe$Just(value);
          default:
            var $temp$targetKey = targetKey,
              $temp$dict = right;
            targetKey = $temp$targetKey;
            dict = $temp$dict;
            continue get;
        }
      }
    }
  });
  var $author$project$ResponsePreviewSetup$Mappers$selectedDemographicValueMapper = F3(function (accountDemographicId, selectOptions, demographicAssignments) {
    var assignmentLookup = $elm$core$Dict$fromList(A3($elm$core$List$foldl, F2(function (ass, acc) {
      return A2($elm$core$List$cons, _Utils_Tuple2($author$project$ResponsePreviewSetup$Common$Types$demographicIdToString(ass.demographicId), ass.demographicValueId), acc);
    }), _List_Nil, demographicAssignments));
    return A2($elm$core$Maybe$andThen, function (demoValueId) {
      return A2($elm_community$list_extra$List$Extra$find, function (so) {
        return _Utils_eq(demoValueId, so.id);
      }, selectOptions);
    }, A2($elm$core$Dict$get, $author$project$ResponsePreviewSetup$Common$Types$demographicIdToString(accountDemographicId), assignmentLookup));
  });
  var $Gizra$elm_debouncer$Debouncer$Internal$settleWhenQuietFor = F2(function (time, _v0) {
    var config = _v0.a;
    return $Gizra$elm_debouncer$Debouncer$Internal$Config(_Utils_update(config, {
      settleWhenQuietFor: time
    }));
  });
  var $Gizra$elm_debouncer$Debouncer$Basic$settleWhenQuietFor = $Gizra$elm_debouncer$Debouncer$Internal$settleWhenQuietFor;
  var $Gizra$elm_debouncer$Debouncer$Internal$Debouncer = F2(function (a, b) {
    return {
      $: 'Debouncer',
      a: a,
      b: b
    };
  });
  var $Gizra$elm_debouncer$Debouncer$Internal$Settled = {
    $: 'Settled'
  };
  var $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative = $elm$core$Maybe$andThen(function (num) {
    return num < 0 ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(num);
  });
  var $Gizra$elm_debouncer$Debouncer$Internal$sanitizeConfig = function (_v0) {
    var config = _v0.a;
    return $Gizra$elm_debouncer$Debouncer$Internal$Config({
      accumulator: config.accumulator,
      emitWhenUnsettled: $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative(config.emitWhenUnsettled),
      emitWhileUnsettled: $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative(config.emitWhileUnsettled),
      settleWhenQuietFor: $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative(config.settleWhenQuietFor)
    });
  };
  var $Gizra$elm_debouncer$Debouncer$Internal$toDebouncer = function (config) {
    return A2($Gizra$elm_debouncer$Debouncer$Internal$Debouncer, $Gizra$elm_debouncer$Debouncer$Internal$sanitizeConfig(config), $Gizra$elm_debouncer$Debouncer$Internal$Settled);
  };
  var $Gizra$elm_debouncer$Debouncer$Basic$toDebouncer = $Gizra$elm_debouncer$Debouncer$Internal$toDebouncer;
  var $author$project$ResponsePreviewSetup$Mappers$accountDemographicMapper = F2(function (demographicAssignments, accountDemoData) {
    var mappedSelectOptions = A2($elm$core$List$map, $author$project$ResponsePreviewSetup$Mappers$selectOptionMapper, accountDemoData.selectOptions);
    return {
      debouncer: $Gizra$elm_debouncer$Debouncer$Basic$toDebouncer(A2($Gizra$elm_debouncer$Debouncer$Basic$settleWhenQuietFor, $elm$core$Maybe$Just($Gizra$elm_debouncer$Debouncer$Basic$fromSeconds(1)), $Gizra$elm_debouncer$Debouncer$Basic$manual)),
      id: accountDemoData.id,
      name: accountDemoData.name,
      selectOptions: mappedSelectOptions,
      uiDemographicValueSelect: $author$project$KaizenDraft$Select$Select$initState,
      uiQueriedSelectOptions: $author$project$ResponsePreviewSetup$Common$Types$NoData,
      uiSelectedDemographicValue: A3($author$project$ResponsePreviewSetup$Mappers$selectedDemographicValueMapper, accountDemoData.id, mappedSelectOptions, demographicAssignments)
    };
  });
  var $author$project$ResponsePreviewSetup$Mappers$stateMapper = function (data) {
    return {
      accountDemographics: A2($elm$core$List$map, $author$project$ResponsePreviewSetup$Mappers$accountDemographicMapper(data.demographicValueAssignments), data.accountDemographics),
      appContext: data.appContext,
      appVisible: false,
      demographicAssignments: data.demographicValueAssignments
    };
  };
  var $author$project$ResponsePreviewSetup$State$init = function (entryData) {
    var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$ResponsePreviewSetup$Decoders$Decoders$responsePreviewSetupDecoder, entryData);
    if (_v0.$ === 'Ok') {
      var state = _v0.a;
      return _Utils_Tuple2($author$project$ResponsePreviewSetup$Types$AppOk($author$project$ResponsePreviewSetup$Mappers$stateMapper(state)), $elm$core$Platform$Cmd$none);
    } else {
      return _Utils_Tuple2($author$project$ResponsePreviewSetup$Types$AppError, $elm$core$Platform$Cmd$none);
    }
  };
  var $author$project$ResponsePreviewSetup$Types$DisplayApp = function (a) {
    return {
      $: 'DisplayApp',
      a: a
    };
  };
  var $elm$core$Platform$Sub$batch = _Platform_batch;
  var $elm$json$Json$Decode$null = _Json_decodeNull;
  var $author$project$ResponsePreviewSetup$Ports$displayApp = _Platform_incomingPort('displayApp', $elm$json$Json$Decode$null(_Utils_Tuple0));
  var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
  var $author$project$ResponsePreviewSetup$State$subscriptions = function (appState) {
    if (appState.$ === 'AppOk') {
      return $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$ResponsePreviewSetup$Ports$displayApp($author$project$ResponsePreviewSetup$Types$DisplayApp)]));
    } else {
      return $elm$core$Platform$Sub$none;
    }
  };
  var $elm$core$Tuple$mapFirst = F2(function (func, _v0) {
    var x = _v0.a;
    var y = _v0.b;
    return _Utils_Tuple2(func(x), y);
  });
  var $author$project$ResponsePreviewSetup$Types$AccountDemographics = function (a) {
    return {
      $: 'AccountDemographics',
      a: a
    };
  };
  var $elm$json$Json$Encode$null = _Json_encodeNull;
  var $author$project$ResponsePreviewSetup$Ports$closeApp = _Platform_outgoingPort('closeApp', function ($) {
    return $elm$json$Json$Encode$null;
  });
  var $author$project$ResponsePreviewSetup$Common$Types$demographicValueIdToString = function (_v0) {
    var demographicValueId = _v0.a;
    return $author$project$SurveyBuilderCommon$Uuid$toString(demographicValueId);
  };
  var $elm$json$Json$Encode$object = function (pairs) {
    return _Json_wrap(A3($elm$core$List$foldl, F2(function (_v0, obj) {
      var k = _v0.a;
      var v = _v0.b;
      return A3(_Json_addField, k, v, obj);
    }), _Json_emptyObject(_Utils_Tuple0), pairs));
  };
  var $elm$json$Json$Encode$string = _Json_wrap;
  var $author$project$ResponsePreviewSetup$Requests$SelectedDemographicValues$encodeSelectedDemographicValueParam = function (param) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('demographic_id', $elm$json$Json$Encode$string($author$project$ResponsePreviewSetup$Common$Types$demographicIdToString(param.id))), _Utils_Tuple2('demographic_value_id', $elm$json$Json$Encode$string($author$project$ResponsePreviewSetup$Common$Types$demographicValueIdToString(param.selectedDemographicValue.id)))]));
  };
  var $elm$json$Json$Encode$list = F2(function (func, entries) {
    return _Json_wrap(A3($elm$core$List$foldl, _Json_addEntry(func), _Json_emptyArray(_Utils_Tuple0), entries));
  });
  var $author$project$ResponsePreviewSetup$Requests$SelectedDemographicValues$encode = function (params) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('demographics', A2($elm$json$Json$Encode$list, $author$project$ResponsePreviewSetup$Requests$SelectedDemographicValues$encodeSelectedDemographicValueParam, params.demographics))]));
  };
  var $elm$browser$Browser$Navigation$load = _Browser_load;
  var $elm$core$Platform$Cmd$map = _Platform_map;
  var $author$project$ResponsePreviewSetup$Types$UpdateResponse = function (a) {
    return {
      $: 'UpdateResponse',
      a: a
    };
  };
  var $elm$http$Http$BadStatus_ = F2(function (a, b) {
    return {
      $: 'BadStatus_',
      a: a,
      b: b
    };
  });
  var $elm$http$Http$BadUrl_ = function (a) {
    return {
      $: 'BadUrl_',
      a: a
    };
  };
  var $elm$http$Http$GoodStatus_ = F2(function (a, b) {
    return {
      $: 'GoodStatus_',
      a: a,
      b: b
    };
  });
  var $elm$http$Http$NetworkError_ = {
    $: 'NetworkError_'
  };
  var $elm$http$Http$Receiving = function (a) {
    return {
      $: 'Receiving',
      a: a
    };
  };
  var $elm$http$Http$Sending = function (a) {
    return {
      $: 'Sending',
      a: a
    };
  };
  var $elm$http$Http$Timeout_ = {
    $: 'Timeout_'
  };
  var $elm$core$Maybe$isJust = function (maybe) {
    if (maybe.$ === 'Just') {
      return true;
    } else {
      return false;
    }
  };
  var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
  var $elm$core$Dict$getMin = function (dict) {
    getMin: while (true) {
      if (dict.$ === 'RBNode_elm_builtin' && dict.d.$ === 'RBNode_elm_builtin') {
        var left = dict.d;
        var $temp$dict = left;
        dict = $temp$dict;
        continue getMin;
      } else {
        return dict;
      }
    }
  };
  var $elm$core$Dict$moveRedLeft = function (dict) {
    if (dict.$ === 'RBNode_elm_builtin' && dict.d.$ === 'RBNode_elm_builtin' && dict.e.$ === 'RBNode_elm_builtin') {
      if (dict.e.d.$ === 'RBNode_elm_builtin' && dict.e.d.a.$ === 'Red') {
        var clr = dict.a;
        var k = dict.b;
        var v = dict.c;
        var _v1 = dict.d;
        var lClr = _v1.a;
        var lK = _v1.b;
        var lV = _v1.c;
        var lLeft = _v1.d;
        var lRight = _v1.e;
        var _v2 = dict.e;
        var rClr = _v2.a;
        var rK = _v2.b;
        var rV = _v2.c;
        var rLeft = _v2.d;
        var _v3 = rLeft.a;
        var rlK = rLeft.b;
        var rlV = rLeft.c;
        var rlL = rLeft.d;
        var rlR = rLeft.e;
        var rRight = _v2.e;
        return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rlK, rlV, A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight), rlL), A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, rK, rV, rlR, rRight));
      } else {
        var clr = dict.a;
        var k = dict.b;
        var v = dict.c;
        var _v4 = dict.d;
        var lClr = _v4.a;
        var lK = _v4.b;
        var lV = _v4.c;
        var lLeft = _v4.d;
        var lRight = _v4.e;
        var _v5 = dict.e;
        var rClr = _v5.a;
        var rK = _v5.b;
        var rV = _v5.c;
        var rLeft = _v5.d;
        var rRight = _v5.e;
        if (clr.$ === 'Black') {
          return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight), A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
        } else {
          return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight), A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
        }
      }
    } else {
      return dict;
    }
  };
  var $elm$core$Dict$moveRedRight = function (dict) {
    if (dict.$ === 'RBNode_elm_builtin' && dict.d.$ === 'RBNode_elm_builtin' && dict.e.$ === 'RBNode_elm_builtin') {
      if (dict.d.d.$ === 'RBNode_elm_builtin' && dict.d.d.a.$ === 'Red') {
        var clr = dict.a;
        var k = dict.b;
        var v = dict.c;
        var _v1 = dict.d;
        var lClr = _v1.a;
        var lK = _v1.b;
        var lV = _v1.c;
        var _v2 = _v1.d;
        var _v3 = _v2.a;
        var llK = _v2.b;
        var llV = _v2.c;
        var llLeft = _v2.d;
        var llRight = _v2.e;
        var lRight = _v1.e;
        var _v4 = dict.e;
        var rClr = _v4.a;
        var rK = _v4.b;
        var rV = _v4.c;
        var rLeft = _v4.d;
        var rRight = _v4.e;
        return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, llK, llV, llLeft, llRight), A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, lRight, A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight)));
      } else {
        var clr = dict.a;
        var k = dict.b;
        var v = dict.c;
        var _v5 = dict.d;
        var lClr = _v5.a;
        var lK = _v5.b;
        var lV = _v5.c;
        var lLeft = _v5.d;
        var lRight = _v5.e;
        var _v6 = dict.e;
        var rClr = _v6.a;
        var rK = _v6.b;
        var rV = _v6.c;
        var rLeft = _v6.d;
        var rRight = _v6.e;
        if (clr.$ === 'Black') {
          return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight), A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
        } else {
          return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight), A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
        }
      }
    } else {
      return dict;
    }
  };
  var $elm$core$Dict$removeHelpPrepEQGT = F7(function (targetKey, dict, color, key, value, left, right) {
    if (left.$ === 'RBNode_elm_builtin' && left.a.$ === 'Red') {
      var _v1 = left.a;
      var lK = left.b;
      var lV = left.c;
      var lLeft = left.d;
      var lRight = left.e;
      return A5($elm$core$Dict$RBNode_elm_builtin, color, lK, lV, lLeft, A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, lRight, right));
    } else {
      _v2$2: while (true) {
        if (right.$ === 'RBNode_elm_builtin' && right.a.$ === 'Black') {
          if (right.d.$ === 'RBNode_elm_builtin') {
            if (right.d.a.$ === 'Black') {
              var _v3 = right.a;
              var _v4 = right.d;
              var _v5 = _v4.a;
              return $elm$core$Dict$moveRedRight(dict);
            } else {
              break _v2$2;
            }
          } else {
            var _v6 = right.a;
            var _v7 = right.d;
            return $elm$core$Dict$moveRedRight(dict);
          }
        } else {
          break _v2$2;
        }
      }
      return dict;
    }
  });
  var $elm$core$Dict$removeMin = function (dict) {
    if (dict.$ === 'RBNode_elm_builtin' && dict.d.$ === 'RBNode_elm_builtin') {
      var color = dict.a;
      var key = dict.b;
      var value = dict.c;
      var left = dict.d;
      var lColor = left.a;
      var lLeft = left.d;
      var right = dict.e;
      if (lColor.$ === 'Black') {
        if (lLeft.$ === 'RBNode_elm_builtin' && lLeft.a.$ === 'Red') {
          var _v3 = lLeft.a;
          return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, $elm$core$Dict$removeMin(left), right);
        } else {
          var _v4 = $elm$core$Dict$moveRedLeft(dict);
          if (_v4.$ === 'RBNode_elm_builtin') {
            var nColor = _v4.a;
            var nKey = _v4.b;
            var nValue = _v4.c;
            var nLeft = _v4.d;
            var nRight = _v4.e;
            return A5($elm$core$Dict$balance, nColor, nKey, nValue, $elm$core$Dict$removeMin(nLeft), nRight);
          } else {
            return $elm$core$Dict$RBEmpty_elm_builtin;
          }
        }
      } else {
        return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, $elm$core$Dict$removeMin(left), right);
      }
    } else {
      return $elm$core$Dict$RBEmpty_elm_builtin;
    }
  };
  var $elm$core$Dict$removeHelp = F2(function (targetKey, dict) {
    if (dict.$ === 'RBEmpty_elm_builtin') {
      return $elm$core$Dict$RBEmpty_elm_builtin;
    } else {
      var color = dict.a;
      var key = dict.b;
      var value = dict.c;
      var left = dict.d;
      var right = dict.e;
      if (_Utils_cmp(targetKey, key) < 0) {
        if (left.$ === 'RBNode_elm_builtin' && left.a.$ === 'Black') {
          var _v4 = left.a;
          var lLeft = left.d;
          if (lLeft.$ === 'RBNode_elm_builtin' && lLeft.a.$ === 'Red') {
            var _v6 = lLeft.a;
            return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, A2($elm$core$Dict$removeHelp, targetKey, left), right);
          } else {
            var _v7 = $elm$core$Dict$moveRedLeft(dict);
            if (_v7.$ === 'RBNode_elm_builtin') {
              var nColor = _v7.a;
              var nKey = _v7.b;
              var nValue = _v7.c;
              var nLeft = _v7.d;
              var nRight = _v7.e;
              return A5($elm$core$Dict$balance, nColor, nKey, nValue, A2($elm$core$Dict$removeHelp, targetKey, nLeft), nRight);
            } else {
              return $elm$core$Dict$RBEmpty_elm_builtin;
            }
          }
        } else {
          return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, A2($elm$core$Dict$removeHelp, targetKey, left), right);
        }
      } else {
        return A2($elm$core$Dict$removeHelpEQGT, targetKey, A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
      }
    }
  });
  var $elm$core$Dict$removeHelpEQGT = F2(function (targetKey, dict) {
    if (dict.$ === 'RBNode_elm_builtin') {
      var color = dict.a;
      var key = dict.b;
      var value = dict.c;
      var left = dict.d;
      var right = dict.e;
      if (_Utils_eq(targetKey, key)) {
        var _v1 = $elm$core$Dict$getMin(right);
        if (_v1.$ === 'RBNode_elm_builtin') {
          var minKey = _v1.b;
          var minValue = _v1.c;
          return A5($elm$core$Dict$balance, color, minKey, minValue, left, $elm$core$Dict$removeMin(right));
        } else {
          return $elm$core$Dict$RBEmpty_elm_builtin;
        }
      } else {
        return A5($elm$core$Dict$balance, color, key, value, left, A2($elm$core$Dict$removeHelp, targetKey, right));
      }
    } else {
      return $elm$core$Dict$RBEmpty_elm_builtin;
    }
  });
  var $elm$core$Dict$remove = F2(function (key, dict) {
    var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
    if (_v0.$ === 'RBNode_elm_builtin' && _v0.a.$ === 'Red') {
      var _v1 = _v0.a;
      var k = _v0.b;
      var v = _v0.c;
      var l = _v0.d;
      var r = _v0.e;
      return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, l, r);
    } else {
      var x = _v0;
      return x;
    }
  });
  var $elm$core$Dict$update = F3(function (targetKey, alter, dictionary) {
    var _v0 = alter(A2($elm$core$Dict$get, targetKey, dictionary));
    if (_v0.$ === 'Just') {
      var value = _v0.a;
      return A3($elm$core$Dict$insert, targetKey, value, dictionary);
    } else {
      return A2($elm$core$Dict$remove, targetKey, dictionary);
    }
  });
  var $elm$core$Basics$composeR = F3(function (f, g, x) {
    return g(f(x));
  });
  var $elm$http$Http$expectStringResponse = F2(function (toMsg, toResult) {
    return A3(_Http_expect, '', $elm$core$Basics$identity, A2($elm$core$Basics$composeR, toResult, toMsg));
  });
  var $elm$http$Http$Header = F2(function (a, b) {
    return {
      $: 'Header',
      a: a,
      b: b
    };
  });
  var $elm$http$Http$header = $elm$http$Http$Header;
  var $elm$http$Http$jsonBody = function (value) {
    return A2(_Http_pair, 'application/json', A2($elm$json$Json$Encode$encode, 0, value));
  };
  var $elm$http$Http$Request = function (a) {
    return {
      $: 'Request',
      a: a
    };
  };
  var $elm$http$Http$State = F2(function (reqs, subs) {
    return {
      reqs: reqs,
      subs: subs
    };
  });
  var $elm$http$Http$init = $elm$core$Task$succeed(A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
  var $elm$core$Process$kill = _Scheduler_kill;
  var $elm$core$Process$spawn = _Scheduler_spawn;
  var $elm$http$Http$updateReqs = F3(function (router, cmds, reqs) {
    updateReqs: while (true) {
      if (!cmds.b) {
        return $elm$core$Task$succeed(reqs);
      } else {
        var cmd = cmds.a;
        var otherCmds = cmds.b;
        if (cmd.$ === 'Cancel') {
          var tracker = cmd.a;
          var _v2 = A2($elm$core$Dict$get, tracker, reqs);
          if (_v2.$ === 'Nothing') {
            var $temp$router = router,
              $temp$cmds = otherCmds,
              $temp$reqs = reqs;
            router = $temp$router;
            cmds = $temp$cmds;
            reqs = $temp$reqs;
            continue updateReqs;
          } else {
            var pid = _v2.a;
            return A2($elm$core$Task$andThen, function (_v3) {
              return A3($elm$http$Http$updateReqs, router, otherCmds, A2($elm$core$Dict$remove, tracker, reqs));
            }, $elm$core$Process$kill(pid));
          }
        } else {
          var req = cmd.a;
          return A2($elm$core$Task$andThen, function (pid) {
            var _v4 = req.tracker;
            if (_v4.$ === 'Nothing') {
              return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
            } else {
              var tracker = _v4.a;
              return A3($elm$http$Http$updateReqs, router, otherCmds, A3($elm$core$Dict$insert, tracker, pid, reqs));
            }
          }, $elm$core$Process$spawn(A3(_Http_toTask, router, $elm$core$Platform$sendToApp(router), req)));
        }
      }
    }
  });
  var $elm$http$Http$onEffects = F4(function (router, cmds, subs, state) {
    return A2($elm$core$Task$andThen, function (reqs) {
      return $elm$core$Task$succeed(A2($elm$http$Http$State, reqs, subs));
    }, A3($elm$http$Http$updateReqs, router, cmds, state.reqs));
  });
  var $elm$core$List$maybeCons = F3(function (f, mx, xs) {
    var _v0 = f(mx);
    if (_v0.$ === 'Just') {
      var x = _v0.a;
      return A2($elm$core$List$cons, x, xs);
    } else {
      return xs;
    }
  });
  var $elm$core$List$filterMap = F2(function (f, xs) {
    return A3($elm$core$List$foldr, $elm$core$List$maybeCons(f), _List_Nil, xs);
  });
  var $elm$http$Http$maybeSend = F4(function (router, desiredTracker, progress, _v0) {
    var actualTracker = _v0.a;
    var toMsg = _v0.b;
    return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(A2($elm$core$Platform$sendToApp, router, toMsg(progress))) : $elm$core$Maybe$Nothing;
  });
  var $elm$http$Http$onSelfMsg = F3(function (router, _v0, state) {
    var tracker = _v0.a;
    var progress = _v0.b;
    return A2($elm$core$Task$andThen, function (_v1) {
      return $elm$core$Task$succeed(state);
    }, $elm$core$Task$sequence(A2($elm$core$List$filterMap, A3($elm$http$Http$maybeSend, router, tracker, progress), state.subs)));
  });
  var $elm$http$Http$Cancel = function (a) {
    return {
      $: 'Cancel',
      a: a
    };
  };
  var $elm$http$Http$cmdMap = F2(function (func, cmd) {
    if (cmd.$ === 'Cancel') {
      var tracker = cmd.a;
      return $elm$http$Http$Cancel(tracker);
    } else {
      var r = cmd.a;
      return $elm$http$Http$Request({
        allowCookiesFromOtherDomains: r.allowCookiesFromOtherDomains,
        body: r.body,
        expect: A2(_Http_mapExpect, func, r.expect),
        headers: r.headers,
        method: r.method,
        timeout: r.timeout,
        tracker: r.tracker,
        url: r.url
      });
    }
  });
  var $elm$http$Http$MySub = F2(function (a, b) {
    return {
      $: 'MySub',
      a: a,
      b: b
    };
  });
  var $elm$http$Http$subMap = F2(function (func, _v0) {
    var tracker = _v0.a;
    var toMsg = _v0.b;
    return A2($elm$http$Http$MySub, tracker, A2($elm$core$Basics$composeR, toMsg, func));
  });
  _Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
  var $elm$http$Http$command = _Platform_leaf('Http');
  var $elm$http$Http$subscription = _Platform_leaf('Http');
  var $elm$http$Http$request = function (r) {
    return $elm$http$Http$command($elm$http$Http$Request({
      allowCookiesFromOtherDomains: false,
      body: r.body,
      expect: r.expect,
      headers: r.headers,
      method: r.method,
      timeout: r.timeout,
      tracker: r.tracker,
      url: r.url
    }));
  };
  var $elm$http$Http$BadStatus = function (a) {
    return {
      $: 'BadStatus',
      a: a
    };
  };
  var $elm$http$Http$BadUrl = function (a) {
    return {
      $: 'BadUrl',
      a: a
    };
  };
  var $elm$http$Http$NetworkError = {
    $: 'NetworkError'
  };
  var $elm$http$Http$Timeout = {
    $: 'Timeout'
  };
  var $author$project$ResponsePreviewSetup$Requests$Request$resolveResponse = function (response) {
    switch (response.$) {
      case 'BadUrl_':
        var url = response.a;
        return $elm$core$Result$Err($elm$http$Http$BadUrl(url));
      case 'Timeout_':
        return $elm$core$Result$Err($elm$http$Http$Timeout);
      case 'NetworkError_':
        return $elm$core$Result$Err($elm$http$Http$NetworkError);
      case 'BadStatus_':
        var metadata = response.a;
        return $elm$core$Result$Err($elm$http$Http$BadStatus(metadata.statusCode));
      default:
        var metadata = response.a;
        return $elm$core$Result$Ok(metadata.url);
    }
  };
  var $author$project$ResponsePreviewSetup$Requests$Request$send = F3(function (_v0, url, params) {
    var securityToken = _v0.a;
    return $elm$http$Http$request({
      body: $elm$http$Http$jsonBody(params),
      expect: A2($elm$http$Http$expectStringResponse, $author$project$ResponsePreviewSetup$Types$UpdateResponse, $author$project$ResponsePreviewSetup$Requests$Request$resolveResponse),
      headers: _List_fromArray([A2($elm$http$Http$header, 'X-CSRF-Token', securityToken)]),
      method: 'POST',
      timeout: $elm$core$Maybe$Nothing,
      tracker: $elm$core$Maybe$Nothing,
      url: url
    });
  });
  var $author$project$ResponsePreviewSetup$Containers$AccountDemographics$Types$AccountDemographicMsg = F2(function (a, b) {
    return {
      $: 'AccountDemographicMsg',
      a: a,
      b: b
    };
  });
  var $elm$core$Tuple$mapSecond = F2(function (func, _v0) {
    var x = _v0.a;
    var y = _v0.b;
    return _Utils_Tuple2(x, func(y));
  });
  var $elm$core$Tuple$second = function (_v0) {
    var y = _v0.b;
    return y;
  };
  var $author$project$ResponsePreviewSetup$Containers$AccountDemographics$Types$DebounceMsg = function (a) {
    return {
      $: 'DebounceMsg',
      a: a
    };
  };
  var $author$project$ResponsePreviewSetup$Common$Types$Debouncing = {
    $: 'Debouncing'
  };
  var $author$project$ResponsePreviewSetup$Containers$AccountDemographics$Types$DemographicValueQuery = function (a) {
    return {
      $: 'DemographicValueQuery',
      a: a
    };
  };
  var $author$project$ResponsePreviewSetup$Common$Types$Error = {
    $: 'Error'
  };
  var $author$project$ResponsePreviewSetup$Common$Types$Resolved = function (a) {
    return {
      $: 'Resolved',
      a: a
    };
  };
  var $author$project$ResponsePreviewSetup$Common$Types$Resolving = {
    $: 'Resolving'
  };
  var $author$project$ResponsePreviewSetup$Containers$AccountDemographics$Types$SelectMsg = function (a) {
    return {
      $: 'SelectMsg',
      a: a
    };
  };
  var $author$project$ResponsePreviewSetup$Containers$AccountDemographics$Types$UpdateDemographics = function (a) {
    return {
      $: 'UpdateDemographics',
      a: a
    };
  };
  var $elm$core$List$any = F2(function (isOkay, list) {
    any: while (true) {
      if (!list.b) {
        return false;
      } else {
        var x = list.a;
        var xs = list.b;
        if (isOkay(x)) {
          return true;
        } else {
          var $temp$isOkay = isOkay,
            $temp$list = xs;
          isOkay = $temp$isOkay;
          list = $temp$list;
          continue any;
        }
      }
    }
  });
  var $author$project$ResponsePreviewSetup$Requests$DemographicValues$buildUrl = F2(function (path, params) {
    var searchTermParam = 'search_term=' + params.text;
    var localeParam = 'locale=' + params.locale;
    var limitParam = 'limit=' + $elm$core$String$fromInt(params.limit);
    var demographicIdParam = 'question_id=' + $author$project$ResponsePreviewSetup$Common$Types$demographicIdToString(params.demographicId);
    return path + ('?' + (demographicIdParam + ('&' + (searchTermParam + ('&' + (localeParam + ('&' + limitParam)))))));
  });
  var $author$project$ResponsePreviewSetup$Requests$DemographicValues$decoder = $elm$json$Json$Decode$list($author$project$ResponsePreviewSetup$Decoders$Decoders$selectOptionDecoder);
  var $Gizra$elm_debouncer$Debouncer$Basic$ProvideInput = function (a) {
    return {
      $: 'ProvideInput',
      a: a
    };
  };
  var $Gizra$elm_debouncer$Debouncer$Basic$provideInput = $Gizra$elm_debouncer$Debouncer$Basic$ProvideInput;
  var $elm$http$Http$emptyBody = _Http_emptyBody;
  var $elm$json$Json$Decode$decodeString = _Json_runOnString;
  var $elm$core$Result$mapError = F2(function (f, result) {
    if (result.$ === 'Ok') {
      var v = result.a;
      return $elm$core$Result$Ok(v);
    } else {
      var e = result.a;
      return $elm$core$Result$Err(f(e));
    }
  });
  var $elm$http$Http$BadBody = function (a) {
    return {
      $: 'BadBody',
      a: a
    };
  };
  var $elm$http$Http$resolve = F2(function (toResult, response) {
    switch (response.$) {
      case 'BadUrl_':
        var url = response.a;
        return $elm$core$Result$Err($elm$http$Http$BadUrl(url));
      case 'Timeout_':
        return $elm$core$Result$Err($elm$http$Http$Timeout);
      case 'NetworkError_':
        return $elm$core$Result$Err($elm$http$Http$NetworkError);
      case 'BadStatus_':
        var metadata = response.a;
        return $elm$core$Result$Err($elm$http$Http$BadStatus(metadata.statusCode));
      default:
        var body = response.b;
        return A2($elm$core$Result$mapError, $elm$http$Http$BadBody, toResult(body));
    }
  });
  var $elm$http$Http$expectJson = F2(function (toMsg, decoder) {
    return A2($elm$http$Http$expectStringResponse, toMsg, $elm$http$Http$resolve(function (string) {
      return A2($elm$core$Result$mapError, $elm$json$Json$Decode$errorToString, A2($elm$json$Json$Decode$decodeString, decoder, string));
    }));
  });
  var $author$project$SurveyDesigner$Common$Decoders$queryDecoder = function (decoder) {
    return A2($elm$json$Json$Decode$at, _List_fromArray(['data']), decoder);
  };
  var $author$project$ResponsePreviewSetup$Requests$Request$queryRequest = F4(function (_v0, url, toMsg, decoder) {
    var securityToken = _v0.a;
    return $elm$http$Http$request({
      body: $elm$http$Http$emptyBody,
      expect: A2($elm$http$Http$expectJson, toMsg, $author$project$SurveyDesigner$Common$Decoders$queryDecoder(decoder)),
      headers: _List_fromArray([A2($elm$http$Http$header, 'X-CSRF-Token', securityToken)]),
      method: 'GET',
      timeout: $elm$core$Maybe$Nothing,
      tracker: $elm$core$Maybe$Nothing,
      url: url
    });
  });
  var $Gizra$elm_debouncer$Debouncer$Internal$Check = function (a) {
    return {
      $: 'Check',
      a: a
    };
  };
  var $Gizra$elm_debouncer$Debouncer$Internal$InputProvidedAt = F2(function (a, b) {
    return {
      $: 'InputProvidedAt',
      a: a,
      b: b
    };
  });
  var $Gizra$elm_debouncer$Debouncer$Internal$ManualEmitAt = function (a) {
    return {
      $: 'ManualEmitAt',
      a: a
    };
  };
  var $Gizra$elm_debouncer$Debouncer$Basic$MsgInternal = function (a) {
    return {
      $: 'MsgInternal',
      a: a
    };
  };
  var $elm$core$Basics$always = F2(function (a, _v0) {
    return a;
  });
  var $elm$core$Basics$composeL = F3(function (g, f, x) {
    return g(f(x));
  });
  var $elm$time$Time$Name = function (a) {
    return {
      $: 'Name',
      a: a
    };
  };
  var $elm$time$Time$Offset = function (a) {
    return {
      $: 'Offset',
      a: a
    };
  };
  var $elm$time$Time$Zone = F2(function (a, b) {
    return {
      $: 'Zone',
      a: a,
      b: b
    };
  });
  var $elm$time$Time$customZone = $elm$time$Time$Zone;
  var $elm$time$Time$Posix = function (a) {
    return {
      $: 'Posix',
      a: a
    };
  };
  var $elm$time$Time$millisToPosix = $elm$time$Time$Posix;
  var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
  var $elm$time$Time$posixToMillis = function (_v0) {
    var millis = _v0.a;
    return millis;
  };
  var $elm$core$Process$sleep = _Process_sleep;
  var $Gizra$elm_debouncer$Debouncer$Internal$Unsettled = function (a) {
    return {
      $: 'Unsettled',
      a: a
    };
  };
  var $Gizra$elm_debouncer$Debouncer$Internal$cancel = function (_v0) {
    var config = _v0.a;
    var state = _v0.b;
    return A2($Gizra$elm_debouncer$Debouncer$Internal$Debouncer, config, $Gizra$elm_debouncer$Debouncer$Internal$Settled);
  };
  var $elm$core$List$isEmpty = function (xs) {
    if (!xs.b) {
      return true;
    } else {
      return false;
    }
  };
  var $elm$core$Maybe$map = F2(function (f, maybe) {
    if (maybe.$ === 'Just') {
      var value = maybe.a;
      return $elm$core$Maybe$Just(f(value));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });
  var $elm$core$Basics$neq = _Utils_notEqual;
  var $elm$core$Basics$not = _Basics_not;
  var $elm$core$List$partition = F2(function (pred, list) {
    var step = F2(function (x, _v0) {
      var trues = _v0.a;
      var falses = _v0.b;
      return pred(x) ? _Utils_Tuple2(A2($elm$core$List$cons, x, trues), falses) : _Utils_Tuple2(trues, A2($elm$core$List$cons, x, falses));
    });
    return A3($elm$core$List$foldr, step, _Utils_Tuple2(_List_Nil, _List_Nil), list);
  });
  var $elm$core$Set$Set_elm_builtin = function (a) {
    return {
      $: 'Set_elm_builtin',
      a: a
    };
  };
  var $elm$core$Set$empty = $elm$core$Set$Set_elm_builtin($elm$core$Dict$empty);
  var $elm$core$Set$insert = F2(function (key, _v0) {
    var dict = _v0.a;
    return $elm$core$Set$Set_elm_builtin(A3($elm$core$Dict$insert, key, _Utils_Tuple0, dict));
  });
  var $elm$core$Dict$member = F2(function (key, dict) {
    var _v0 = A2($elm$core$Dict$get, key, dict);
    if (_v0.$ === 'Just') {
      return true;
    } else {
      return false;
    }
  });
  var $elm$core$Set$member = F2(function (key, _v0) {
    var dict = _v0.a;
    return A2($elm$core$Dict$member, key, dict);
  });
  var $elm_community$list_extra$List$Extra$uniqueHelp = F4(function (f, existing, remaining, accumulator) {
    uniqueHelp: while (true) {
      if (!remaining.b) {
        return $elm$core$List$reverse(accumulator);
      } else {
        var first = remaining.a;
        var rest = remaining.b;
        var computedFirst = f(first);
        if (A2($elm$core$Set$member, computedFirst, existing)) {
          var $temp$f = f,
            $temp$existing = existing,
            $temp$remaining = rest,
            $temp$accumulator = accumulator;
          f = $temp$f;
          existing = $temp$existing;
          remaining = $temp$remaining;
          accumulator = $temp$accumulator;
          continue uniqueHelp;
        } else {
          var $temp$f = f,
            $temp$existing = A2($elm$core$Set$insert, computedFirst, existing),
            $temp$remaining = rest,
            $temp$accumulator = A2($elm$core$List$cons, first, accumulator);
          f = $temp$f;
          existing = $temp$existing;
          remaining = $temp$remaining;
          accumulator = $temp$accumulator;
          continue uniqueHelp;
        }
      }
    }
  });
  var $elm_community$list_extra$List$Extra$unique = function (list) {
    return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, $elm$core$Set$empty, list, _List_Nil);
  };
  var $Gizra$elm_debouncer$Debouncer$Internal$update = F2(function (msg, debouncer) {
    var wrappedConfig = debouncer.a;
    var config = wrappedConfig.a;
    var state = debouncer.b;
    switch (msg.$) {
      case 'InputProvidedAt':
        var input = msg.a;
        var time = msg.b;
        var newState = function () {
          if (state.$ === 'Settled') {
            return $Gizra$elm_debouncer$Debouncer$Internal$Unsettled({
              lastEmittedAt: $elm$core$Maybe$Nothing,
              lastInputProvidedAt: time,
              output: A2(config.accumulator, input, $elm$core$Maybe$Nothing),
              unsettledAt: time
            });
          } else {
            var unsettled = state.a;
            return $Gizra$elm_debouncer$Debouncer$Internal$Unsettled(_Utils_update(unsettled, {
              lastInputProvidedAt: time,
              output: A2(config.accumulator, input, unsettled.output)
            }));
          }
        }();
        var newDebouncer = A2($Gizra$elm_debouncer$Debouncer$Internal$Debouncer, wrappedConfig, newState);
        var checks = function () {
          if (state.$ === 'Settled') {
            return $elm_community$list_extra$List$Extra$unique(A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([config.emitWhenUnsettled, config.emitWhileUnsettled, config.settleWhenQuietFor])));
          } else {
            return A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([config.settleWhenQuietFor]));
          }
        }();
        var _v1 = A2($elm$core$Tuple$mapFirst, A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty), A2($elm$core$List$partition, function (interval) {
          return interval <= 0;
        }, checks));
        var checkNow = _v1.a;
        var checkLater = _v1.b;
        var _v2 = checkNow ? A2($Gizra$elm_debouncer$Debouncer$Internal$update, $Gizra$elm_debouncer$Debouncer$Internal$Check(time), newDebouncer) : _Utils_Tuple3(newDebouncer, _List_Nil, $elm$core$Maybe$Nothing);
        var checkedDebouncer = _v2.a;
        var checkedIntervals = _v2.b;
        var emit = _v2.c;
        return _Utils_Tuple3(checkedDebouncer, _Utils_ap(checkedIntervals, checkLater), emit);
      case 'ManualCancel':
        return _Utils_Tuple3($Gizra$elm_debouncer$Debouncer$Internal$cancel(debouncer), _List_Nil, $elm$core$Maybe$Nothing);
      case 'ManualSettle':
        var emit = function () {
          if (state.$ === 'Settled') {
            return $elm$core$Maybe$Nothing;
          } else {
            var unsettled = state.a;
            return unsettled.output;
          }
        }();
        return _Utils_Tuple3($Gizra$elm_debouncer$Debouncer$Internal$cancel(debouncer), _List_Nil, emit);
      case 'ManualEmitAt':
        var time = msg.a;
        if (state.$ === 'Settled') {
          return _Utils_Tuple3(debouncer, _List_Nil, $elm$core$Maybe$Nothing);
        } else {
          var unsettled = state.a;
          var _v7 = unsettled.output;
          if (_v7.$ === 'Just') {
            var newState = $Gizra$elm_debouncer$Debouncer$Internal$Unsettled(_Utils_update(unsettled, {
              lastEmittedAt: $elm$core$Maybe$Just(time),
              output: $elm$core$Maybe$Nothing
            }));
            var intervals = function () {
              var _v8 = config.emitWhenUnsettled;
              if (_v8.$ === 'Just') {
                var emit = _v8.a;
                return _List_fromArray([emit]);
              } else {
                return _List_Nil;
              }
            }();
            return _Utils_Tuple3(A2($Gizra$elm_debouncer$Debouncer$Internal$Debouncer, wrappedConfig, newState), intervals, unsettled.output);
          } else {
            return _Utils_Tuple3(debouncer, _List_Nil, $elm$core$Maybe$Nothing);
          }
        }
      default:
        var time = msg.a;
        if (state.$ === 'Settled') {
          return _Utils_Tuple3(debouncer, _List_Nil, $elm$core$Maybe$Nothing);
        } else {
          var unsettled = state.a;
          var shouldSettle = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function (interval) {
            return _Utils_cmp(unsettled.lastInputProvidedAt + interval, time) < 1;
          }, config.settleWhenQuietFor));
          var becauseEmitWhileUnsettled = function () {
            var _v13 = config.emitWhileUnsettled;
            if (_v13.$ === 'Just') {
              var interval = _v13.a;
              var _v14 = unsettled.lastEmittedAt;
              if (_v14.$ === 'Just') {
                var lastEmittedAt = _v14.a;
                return _Utils_cmp(lastEmittedAt + interval, time) < 1;
              } else {
                return _Utils_cmp(unsettled.unsettledAt + interval, time) < 1;
              }
            } else {
              return false;
            }
          }();
          var becauseEmitWhenUnsettled = function () {
            var _v11 = config.emitWhenUnsettled;
            if (_v11.$ === 'Just') {
              var interval = _v11.a;
              var _v12 = unsettled.lastEmittedAt;
              if (_v12.$ === 'Just') {
                return false;
              } else {
                return _Utils_cmp(unsettled.unsettledAt + interval, time) < 1;
              }
            } else {
              return false;
            }
          }();
          var shouldEmit = !_Utils_eq(unsettled.output, $elm$core$Maybe$Nothing) && (shouldSettle || becauseEmitWhenUnsettled || becauseEmitWhileUnsettled);
          var emit = shouldEmit ? unsettled.output : $elm$core$Maybe$Nothing;
          var intervals = function () {
            if (shouldEmit && !shouldSettle) {
              var _v10 = config.emitWhileUnsettled;
              if (_v10.$ === 'Just') {
                var interval = _v10.a;
                return _List_fromArray([interval]);
              } else {
                return _List_Nil;
              }
            } else {
              return _List_Nil;
            }
          }();
          var newState = shouldSettle ? $Gizra$elm_debouncer$Debouncer$Internal$Settled : shouldEmit ? $Gizra$elm_debouncer$Debouncer$Internal$Unsettled(_Utils_update(unsettled, {
            lastEmittedAt: $elm$core$Maybe$Just(time),
            output: $elm$core$Maybe$Nothing
          })) : state;
          return _Utils_Tuple3(A2($Gizra$elm_debouncer$Debouncer$Internal$Debouncer, wrappedConfig, newState), intervals, emit);
        }
    }
  });
  var $Gizra$elm_debouncer$Debouncer$Basic$update = F2(function (msg, debouncer) {
    switch (msg.$) {
      case 'ProvideInput':
        var input = msg.a;
        return _Utils_Tuple3(debouncer, A2($elm$core$Task$perform, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $Gizra$elm_debouncer$Debouncer$Basic$MsgInternal, $Gizra$elm_debouncer$Debouncer$Internal$InputProvidedAt(input)), $elm$time$Time$posixToMillis), $elm$time$Time$now), $elm$core$Maybe$Nothing);
      case 'EmitNow':
        return _Utils_Tuple3(debouncer, A2($elm$core$Task$perform, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $Gizra$elm_debouncer$Debouncer$Basic$MsgInternal, $Gizra$elm_debouncer$Debouncer$Internal$ManualEmitAt), $elm$time$Time$posixToMillis), $elm$time$Time$now), $elm$core$Maybe$Nothing);
      default:
        var subMsg = msg.a;
        var _v1 = A2($Gizra$elm_debouncer$Debouncer$Internal$update, subMsg, debouncer);
        var updatedDebouncer = _v1.a;
        var intervals = _v1.b;
        var output = _v1.c;
        var cmds = $elm$core$Platform$Cmd$batch(A2($elm$core$List$map, function (interval) {
          return A2($elm$core$Task$perform, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $Gizra$elm_debouncer$Debouncer$Basic$MsgInternal, $Gizra$elm_debouncer$Debouncer$Internal$Check), $elm$time$Time$posixToMillis), A2($elm$core$Task$andThen, $elm$core$Basics$always($elm$time$Time$now), $elm$core$Process$sleep(interval)));
        }, intervals));
        return _Utils_Tuple3(updatedDebouncer, cmds, output);
    }
  });
  var $author$project$KaizenDraft$Select$Select$CloseMenu = {
    $: 'CloseMenu'
  };
  var $author$project$KaizenDraft$Select$Select$ContainerMousedown = {
    $: 'ContainerMousedown'
  };
  var $author$project$KaizenDraft$Select$Select$Deselect = function (a) {
    return {
      $: 'Deselect',
      a: a
    };
  };
  var $author$project$KaizenDraft$Select$Select$DeselectSingleSelectItem = {
    $: 'DeselectSingleSelectItem'
  };
  var $author$project$KaizenDraft$Select$Select$Down = {
    $: 'Down'
  };
  var $author$project$KaizenDraft$Select$Select$InputChange = function (a) {
    return {
      $: 'InputChange',
      a: a
    };
  };
  var $author$project$KaizenDraft$Select$Select$InputMousedown = {
    $: 'InputMousedown'
  };
  var $author$project$KaizenDraft$Select$Select$Internal = {
    $: 'Internal'
  };
  var $author$project$KaizenDraft$Select$Select$Keyboard = {
    $: 'Keyboard'
  };
  var $author$project$KaizenDraft$Select$Select$MenuItemMousedown = function (a) {
    return {
      $: 'MenuItemMousedown',
      a: a
    };
  };
  var $author$project$KaizenDraft$Select$Select$MultiItemMousedown = function (a) {
    return {
      $: 'MultiItemMousedown',
      a: a
    };
  };
  var $author$project$KaizenDraft$Select$Select$OnInputFocused = function (a) {
    return {
      $: 'OnInputFocused',
      a: a
    };
  };
  var $author$project$KaizenDraft$Select$Select$OpenMenu = {
    $: 'OpenMenu'
  };
  var $author$project$KaizenDraft$Select$Select$Select = function (a) {
    return {
      $: 'Select',
      a: a
    };
  };
  var $author$project$KaizenDraft$Select$Select$SelectId = function (a) {
    return {
      $: 'SelectId',
      a: a
    };
  };
  var $author$project$KaizenDraft$Select$Select$Up = {
    $: 'Up'
  };
  var $elm$core$Task$onError = _Scheduler_onError;
  var $elm$core$Task$attempt = F2(function (resultToMessage, task) {
    return $elm$core$Task$command($elm$core$Task$Perform(A2($elm$core$Task$onError, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage), $elm$core$Result$Err), A2($elm$core$Task$andThen, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage), $elm$core$Result$Ok), task))));
  });
  var $author$project$KaizenDraft$Select$SelectInput$defaultWidth = 2;
  var $author$project$KaizenDraft$Select$SelectInput$inputId = function (iid) {
    return 'kaizen-select-input-target-' + iid;
  };
  var $elm$json$Json$Encode$int = _Json_wrap;
  var $author$project$KaizenDraft$Select$SelectInput$sizerId = function (sid) {
    return 'kaizen-select-input-sizer-target-' + sid;
  };
  var $author$project$KaizenDraft$Select$Select$buildEncodedValueForPorts = function (_v0) {
    var id_ = _v0.a;
    var _v1 = _Utils_Tuple2($author$project$KaizenDraft$Select$SelectInput$sizerId(id_), $author$project$KaizenDraft$Select$SelectInput$inputId(id_));
    var sizerId = _v1.a;
    var inputId = _v1.b;
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('sizerId', $elm$json$Json$Encode$string(sizerId)), _Utils_Tuple2('inputId', $elm$json$Json$Encode$string(inputId)), _Utils_Tuple2('defaultInputWidth', $elm$json$Json$Encode$int($author$project$KaizenDraft$Select$SelectInput$defaultWidth))]));
  };
  var $author$project$KaizenDraft$Select$Select$calculateNextActiveTarget = F3(function (currentTargetIndex, totalTargetCount, direction) {
    if (direction.$ === 'Up') {
      return !currentTargetIndex ? 0 : _Utils_cmp(totalTargetCount, currentTargetIndex + 1) < 0 ? 0 : currentTargetIndex - 1;
    } else {
      return _Utils_eq(currentTargetIndex + 1, totalTargetCount) ? currentTargetIndex : _Utils_cmp(totalTargetCount, currentTargetIndex + 1) < 0 ? 0 : currentTargetIndex + 1;
    }
  });
  var $author$project$KaizenDraft$Select$Select$dummyInputIdPrefix = 'dummy-input-';
  var $author$project$KaizenDraft$Select$Select$getSelectId = function (_v0) {
    var id_ = _v0.a;
    return id_;
  };
  var $author$project$KaizenDraft$Select$Select$dummyInputId = function (selectId) {
    return _Utils_ap($author$project$KaizenDraft$Select$Select$dummyInputIdPrefix, $author$project$KaizenDraft$Select$Select$getSelectId(selectId));
  };
  var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
  var $author$project$KaizenDraft$Select$Ports$kaizenConnectSelectInputDynamicWidth = _Platform_outgoingPort('kaizenConnectSelectInputDynamicWidth', $elm$core$Basics$identity);
  var $author$project$KaizenDraft$Select$Ports$kaizenDisconnectSelectInputDynamicWidth = _Platform_outgoingPort('kaizenDisconnectSelectInputDynamicWidth', $elm$core$Basics$identity);
  var $author$project$KaizenDraft$Select$Select$Above = {
    $: 'Above'
  };
  var $author$project$KaizenDraft$Select$Select$Below = {
    $: 'Below'
  };
  var $author$project$KaizenDraft$Select$Select$Both = {
    $: 'Both'
  };
  var $author$project$KaizenDraft$Select$Select$Within = {
    $: 'Within'
  };
  var $author$project$KaizenDraft$Select$Select$calculateMenuBoundaries = function (_v0) {
    var menuListElem = _v0.a;
    return _Utils_Tuple2(menuListElem.element.y, menuListElem.element.y + menuListElem.element.height);
  };
  var $author$project$KaizenDraft$Select$Select$isMenuItemWithinBottomBoundary = F2(function (_v0, bottomBoundary) {
    var menuItemElement = _v0.a;
    return _Utils_cmp(menuItemElement.element.y + menuItemElement.element.height, bottomBoundary) < 1;
  });
  var $author$project$KaizenDraft$Select$Select$isMenuItemWithinTopBoundary = F2(function (_v0, topBoundary) {
    var menuItemElement = _v0.a;
    return _Utils_cmp(topBoundary, menuItemElement.element.y) < 1;
  });
  var $author$project$KaizenDraft$Select$Select$menuItemOrientationInViewport = F2(function (menuListElem, menuItemElem) {
    var _v0 = $author$project$KaizenDraft$Select$Select$calculateMenuBoundaries(menuListElem);
    var topBoundary = _v0.a;
    var bottomBoundary = _v0.b;
    var _v1 = _Utils_Tuple2(A2($author$project$KaizenDraft$Select$Select$isMenuItemWithinTopBoundary, menuItemElem, topBoundary), A2($author$project$KaizenDraft$Select$Select$isMenuItemWithinBottomBoundary, menuItemElem, bottomBoundary));
    if (_v1.a) {
      if (_v1.b) {
        return $author$project$KaizenDraft$Select$Select$Within;
      } else {
        return $author$project$KaizenDraft$Select$Select$Below;
      }
    } else {
      if (_v1.b) {
        return $author$project$KaizenDraft$Select$Select$Above;
      } else {
        return $author$project$KaizenDraft$Select$Select$Both;
      }
    }
  });
  var $author$project$KaizenDraft$Select$Select$FocusMenuViewport = F2(function (a, b) {
    return {
      $: 'FocusMenuViewport',
      a: a,
      b: b
    };
  });
  var $author$project$KaizenDraft$Select$Select$MenuItemElement = function (a) {
    return {
      $: 'MenuItemElement',
      a: a
    };
  };
  var $author$project$KaizenDraft$Select$Select$MenuListElement = function (a) {
    return {
      $: 'MenuListElement',
      a: a
    };
  };
  var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
  var $author$project$KaizenDraft$Select$Select$menuItemId = F2(function (selectId, index) {
    return 'select-menu-item-' + ($elm$core$String$fromInt(index) + ('-' + $author$project$KaizenDraft$Select$Select$getSelectId(selectId)));
  });
  var $author$project$KaizenDraft$Select$Select$queryActiveTargetElement = F2(function (selectId, index) {
    return $elm$browser$Browser$Dom$getElement(A2($author$project$KaizenDraft$Select$Select$menuItemId, selectId, index));
  });
  var $author$project$KaizenDraft$Select$Select$menuListId = function (selectId) {
    return 'select-menu-list-' + $author$project$KaizenDraft$Select$Select$getSelectId(selectId);
  };
  var $author$project$KaizenDraft$Select$Select$queryMenuListElement = function (selectId) {
    return $elm$browser$Browser$Dom$getElement($author$project$KaizenDraft$Select$Select$menuListId(selectId));
  };
  var $author$project$KaizenDraft$Select$Select$queryNodesForViewportFocus = F2(function (selectId, menuItemIndex) {
    return A2($elm$core$Task$attempt, $author$project$KaizenDraft$Select$Select$FocusMenuViewport(selectId), A3($elm$core$Task$map2, F2(function (menuListElem, menuItemElem) {
      return _Utils_Tuple2($author$project$KaizenDraft$Select$Select$MenuListElement(menuListElem), $author$project$KaizenDraft$Select$Select$MenuItemElement(menuItemElem));
    }), $author$project$KaizenDraft$Select$Select$queryMenuListElement(selectId), A2($author$project$KaizenDraft$Select$Select$queryActiveTargetElement, selectId, menuItemIndex)));
  });
  var $author$project$KaizenDraft$Select$Select$DoNothing = {
    $: 'DoNothing'
  };
  var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
  var $author$project$KaizenDraft$Select$Select$setMenuViewportPosition = F5(function (selectId, menuListViewport, _v0, _v1, menuItemVisibility) {
    var menuListElem = _v0.a;
    var menuItemElem = _v1.a;
    switch (menuItemVisibility.$) {
      case 'Within':
        return _Utils_Tuple2($elm$core$Platform$Cmd$none, menuListViewport);
      case 'Above':
        var menuItemDistanceAbove = menuListElem.element.y - menuItemElem.element.y;
        return _Utils_Tuple2(A2($elm$core$Task$attempt, function (_v3) {
          return $author$project$KaizenDraft$Select$Select$DoNothing;
        }, A3($elm$browser$Browser$Dom$setViewportOf, $author$project$KaizenDraft$Select$Select$menuListId(selectId), 0, menuListViewport - menuItemDistanceAbove)), menuListViewport - menuItemDistanceAbove);
      case 'Below':
        var menuItemDistanceBelow = menuItemElem.element.y + menuItemElem.element.height - (menuListElem.element.y + menuListElem.element.height);
        return _Utils_Tuple2(A2($elm$core$Task$attempt, function (_v4) {
          return $author$project$KaizenDraft$Select$Select$DoNothing;
        }, A3($elm$browser$Browser$Dom$setViewportOf, $author$project$KaizenDraft$Select$Select$menuListId(selectId), 0, menuListViewport + menuItemDistanceBelow)), menuListViewport + menuItemDistanceBelow);
      default:
        var menuItemDistanceAbove = menuListElem.element.y - menuItemElem.element.y;
        return _Utils_Tuple2(A2($elm$core$Task$attempt, function (_v5) {
          return $author$project$KaizenDraft$Select$Select$DoNothing;
        }, A3($elm$browser$Browser$Dom$setViewportOf, $author$project$KaizenDraft$Select$Select$menuListId(selectId), 0, menuListViewport - menuItemDistanceAbove)), menuListViewport - menuItemDistanceAbove);
    }
  });
  var $author$project$KaizenDraft$Select$Select$shouldQueryNextTargetElement = F2(function (nextTargetIndex, state_) {
    return !_Utils_eq(nextTargetIndex, state_.activeTargetIndex);
  });
  var $author$project$KaizenDraft$Select$Select$update = F2(function (msg, _v0) {
    var state_ = _v0.a;
    switch (msg.$) {
      case 'EnterSelect':
        var item = msg.a;
        var _v2 = A2($author$project$KaizenDraft$Select$Select$update, $author$project$KaizenDraft$Select$Select$CloseMenu, $author$project$KaizenDraft$Select$Select$State(state_));
        var stateWithClosedMenu = _v2.b.a;
        var cmdWithClosedMenu = _v2.c;
        return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Select(item), $author$project$KaizenDraft$Select$Select$State(_Utils_update(stateWithClosedMenu, {
          initialMousedown: $author$project$KaizenDraft$Select$Select$NothingMousedown,
          inputValue: $elm$core$Maybe$Nothing
        })), cmdWithClosedMenu);
      case 'HoverFocused':
        var i = msg.a;
        return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(_Utils_update(state_, {
          activeTargetIndex: i
        })), $elm$core$Platform$Cmd$none);
      case 'InputChanged':
        var selectId = msg.a;
        var inputValue = msg.b;
        var _v3 = A2($author$project$KaizenDraft$Select$Select$update, $author$project$KaizenDraft$Select$Select$OpenMenu, $author$project$KaizenDraft$Select$Select$State(state_));
        var stateWithOpenMenu = _v3.b.a;
        var cmdWithOpenMenu = _v3.c;
        return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$InputChange(inputValue), $author$project$KaizenDraft$Select$Select$State(_Utils_update(stateWithOpenMenu, {
          inputValue: $elm$core$Maybe$Just(inputValue)
        })), cmdWithOpenMenu);
      case 'InputReceivedFocused':
        var maybeSelectId = msg.a;
        if (maybeSelectId.$ === 'Just') {
          var selectId = maybeSelectId.a;
          var ports = state_.usePorts ? $author$project$KaizenDraft$Select$Ports$kaizenConnectSelectInputDynamicWidth($author$project$KaizenDraft$Select$Select$buildEncodedValueForPorts(selectId)) : $elm$core$Platform$Cmd$none;
          return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(_Utils_update(state_, {
            controlFocused: true
          })), ports);
        } else {
          return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(_Utils_update(state_, {
            controlFocused: true
          })), $elm$core$Platform$Cmd$none);
        }
      case 'SelectedItem':
        var item = msg.a;
        var _v5 = A2($author$project$KaizenDraft$Select$Select$update, $author$project$KaizenDraft$Select$Select$CloseMenu, $author$project$KaizenDraft$Select$Select$State(state_));
        var stateWithClosedMenu = _v5.b.a;
        var cmdWithClosedMenu = _v5.c;
        return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Select(item), $author$project$KaizenDraft$Select$Select$State(_Utils_update(stateWithClosedMenu, {
          initialMousedown: $author$project$KaizenDraft$Select$Select$NothingMousedown,
          inputValue: $elm$core$Maybe$Nothing
        })), cmdWithClosedMenu);
      case 'DeselectedMultiItem':
        var deselectedItem = msg.a;
        return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Deselect(deselectedItem), $author$project$KaizenDraft$Select$Select$State(_Utils_update(state_, {
          initialMousedown: $author$project$KaizenDraft$Select$Select$NothingMousedown
        })), $elm$core$Platform$Cmd$none);
      case 'OnInputFocused':
        var focusResult = msg.a;
        if (focusResult.$ === 'Ok') {
          return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(_Utils_update(state_, {
            initialMousedown: $author$project$KaizenDraft$Select$Select$NothingMousedown
          })), $elm$core$Platform$Cmd$none);
        } else {
          return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(state_), $elm$core$Platform$Cmd$none);
        }
      case 'FocusMenuViewport':
        if (msg.b.$ === 'Ok') {
          var selectId = msg.a;
          var _v7 = msg.b.a;
          var menuListElem = _v7.a;
          var menuItemElem = _v7.b;
          var _v8 = A5($author$project$KaizenDraft$Select$Select$setMenuViewportPosition, selectId, state_.menuListScrollTop, menuListElem, menuItemElem, A2($author$project$KaizenDraft$Select$Select$menuItemOrientationInViewport, menuListElem, menuItemElem));
          var viewportFocusCmd = _v8.a;
          var newViewportY = _v8.b;
          return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(_Utils_update(state_, {
            menuListScrollTop: newViewportY,
            menuViewportFocusNodes: $elm$core$Maybe$Just(_Utils_Tuple2(menuListElem, menuItemElem))
          })), viewportFocusCmd);
        } else {
          return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(_Utils_update(state_, {
            menuViewportFocusNodes: $elm$core$Maybe$Nothing
          })), $elm$core$Platform$Cmd$none);
        }
      case 'DoNothing':
        return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(state_), $elm$core$Platform$Cmd$none);
      case 'OnInputBlurred':
        var maybeSelectId = msg.a;
        var ports = function () {
          if (maybeSelectId.$ === 'Just') {
            var id_ = maybeSelectId.a;
            return state_.usePorts ? $author$project$KaizenDraft$Select$Ports$kaizenDisconnectSelectInputDynamicWidth($author$project$KaizenDraft$Select$Select$buildEncodedValueForPorts(id_)) : $elm$core$Platform$Cmd$none;
          } else {
            return $elm$core$Platform$Cmd$none;
          }
        }();
        var _v9 = A2($author$project$KaizenDraft$Select$Select$update, $author$project$KaizenDraft$Select$Select$CloseMenu, $author$project$KaizenDraft$Select$Select$State(state_));
        var stateWithClosedMenu = _v9.b.a;
        var cmdWithClosedMenu = _v9.c;
        var _v10 = function () {
          var _v11 = state_.initialMousedown;
          switch (_v11.$) {
            case 'ContainerMousedown':
              return _Utils_Tuple2(_Utils_update(state_, {
                inputValue: $elm$core$Maybe$Nothing
              }), ports);
            case 'MultiItemMousedown':
              return _Utils_Tuple2(state_, $elm$core$Platform$Cmd$none);
            default:
              return _Utils_Tuple2(_Utils_update(stateWithClosedMenu, {
                controlFocused: false,
                initialMousedown: $author$project$KaizenDraft$Select$Select$NothingMousedown,
                inputValue: $elm$core$Maybe$Nothing
              }), $elm$core$Platform$Cmd$batch(_List_fromArray([cmdWithClosedMenu, ports])));
          }
        }();
        var updatedState = _v10.a;
        var updatedCmds = _v10.b;
        return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(updatedState), updatedCmds);
      case 'MenuItemClickFocus':
        var i = msg.a;
        return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(_Utils_update(state_, {
          initialMousedown: $author$project$KaizenDraft$Select$Select$MenuItemMousedown(i)
        })), $elm$core$Platform$Cmd$none);
      case 'MultiItemFocus':
        var index = msg.a;
        return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(_Utils_update(state_, {
          initialMousedown: $author$project$KaizenDraft$Select$Select$MultiItemMousedown(index)
        })), $elm$core$Platform$Cmd$none);
      case 'InputMousedowned':
        return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(_Utils_update(state_, {
          initialMousedown: $author$project$KaizenDraft$Select$Select$InputMousedown
        })), $elm$core$Platform$Cmd$none);
      case 'ClearFocusedItem':
        return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(_Utils_update(state_, {
          initialMousedown: $author$project$KaizenDraft$Select$Select$NothingMousedown
        })), $elm$core$Platform$Cmd$none);
      case 'SearchableSelectContainerClicked':
        var id = msg.a.a;
        var inputId = $author$project$KaizenDraft$Select$SelectInput$inputId(id);
        var _v13 = A2($author$project$KaizenDraft$Select$Select$update, $author$project$KaizenDraft$Select$Select$OpenMenu, $author$project$KaizenDraft$Select$Select$State(state_));
        var stateWithOpenMenu = _v13.b.a;
        var cmdWithOpenMenu = _v13.c;
        var _v14 = A2($author$project$KaizenDraft$Select$Select$update, $author$project$KaizenDraft$Select$Select$CloseMenu, $author$project$KaizenDraft$Select$Select$State(state_));
        var stateWithClosedMenu = _v14.b.a;
        var cmdWithClosedMenu = _v14.c;
        var _v15 = function () {
          var _v16 = state_.initialMousedown;
          switch (_v16.$) {
            case 'MultiItemMousedown':
              return _Utils_Tuple2(state_, $elm$core$Platform$Cmd$none);
            case 'InputMousedown':
              return _Utils_Tuple2(_Utils_update(stateWithOpenMenu, {
                initialMousedown: $author$project$KaizenDraft$Select$Select$NothingMousedown
              }), cmdWithOpenMenu);
            case 'NothingMousedown':
              return state_.menuOpen ? _Utils_Tuple2(_Utils_update(stateWithClosedMenu, {
                initialMousedown: $author$project$KaizenDraft$Select$Select$ContainerMousedown
              }), cmdWithClosedMenu) : _Utils_Tuple2(_Utils_update(stateWithOpenMenu, {
                initialMousedown: $author$project$KaizenDraft$Select$Select$ContainerMousedown
              }), cmdWithOpenMenu);
            case 'ContainerMousedown':
              return state_.menuOpen ? _Utils_Tuple2(_Utils_update(stateWithClosedMenu, {
                initialMousedown: $author$project$KaizenDraft$Select$Select$NothingMousedown
              }), cmdWithClosedMenu) : _Utils_Tuple2(_Utils_update(stateWithOpenMenu, {
                initialMousedown: $author$project$KaizenDraft$Select$Select$NothingMousedown
              }), cmdWithOpenMenu);
            default:
              return state_.menuOpen ? _Utils_Tuple2(stateWithClosedMenu, cmdWithClosedMenu) : _Utils_Tuple2(stateWithOpenMenu, cmdWithOpenMenu);
          }
        }();
        var updatedState = _v15.a;
        var updatedCmds = _v15.b;
        return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(_Utils_update(updatedState, {
          controlFocused: true
        })), $elm$core$Platform$Cmd$batch(_List_fromArray([updatedCmds, A2($elm$core$Task$attempt, $author$project$KaizenDraft$Select$Select$OnInputFocused, $elm$browser$Browser$Dom$focus(inputId))])));
      case 'UnsearchableSelectContainerClicked':
        var id = msg.a.a;
        var _v17 = A2($author$project$KaizenDraft$Select$Select$update, $author$project$KaizenDraft$Select$Select$OpenMenu, $author$project$KaizenDraft$Select$Select$State(state_));
        var stateWithOpenMenu = _v17.b.a;
        var cmdWithOpenMenu = _v17.c;
        var _v18 = A2($author$project$KaizenDraft$Select$Select$update, $author$project$KaizenDraft$Select$Select$CloseMenu, $author$project$KaizenDraft$Select$Select$State(state_));
        var stateWithClosedMenu = _v18.b.a;
        var cmdWithClosedMenu = _v18.c;
        var _v19 = state_.menuOpen ? _Utils_Tuple2(stateWithClosedMenu, cmdWithClosedMenu) : _Utils_Tuple2(stateWithOpenMenu, cmdWithOpenMenu);
        var updatedState = _v19.a;
        var updatedCmd = _v19.b;
        return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(_Utils_update(updatedState, {
          controlFocused: true
        })), $elm$core$Platform$Cmd$batch(_List_fromArray([updatedCmd, A2($elm$core$Task$attempt, $author$project$KaizenDraft$Select$Select$OnInputFocused, $elm$browser$Browser$Dom$focus($author$project$KaizenDraft$Select$Select$dummyInputId($author$project$KaizenDraft$Select$Select$SelectId(id))))])));
      case 'ToggleMenuAtKey':
        var selectId = msg.a;
        var _v20 = A2($author$project$KaizenDraft$Select$Select$update, $author$project$KaizenDraft$Select$Select$OpenMenu, $author$project$KaizenDraft$Select$Select$State(state_));
        var stateWithOpenMenu = _v20.b.a;
        var cmdWithOpenMenu = _v20.c;
        var _v21 = A2($author$project$KaizenDraft$Select$Select$update, $author$project$KaizenDraft$Select$Select$CloseMenu, $author$project$KaizenDraft$Select$Select$State(state_));
        var stateWithClosedMenu = _v21.b.a;
        var cmdWithClosedMenu = _v21.c;
        var _v22 = state_.menuOpen ? _Utils_Tuple2(stateWithClosedMenu, cmdWithClosedMenu) : _Utils_Tuple2(stateWithOpenMenu, cmdWithOpenMenu);
        var updatedState = _v22.a;
        var updatedCmd = _v22.b;
        return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(_Utils_update(updatedState, {
          controlFocused: true
        })), updatedCmd);
      case 'KeyboardDown':
        var selectId = msg.a;
        var totalTargetCount = msg.b;
        var nextActiveTargetIndex = A3($author$project$KaizenDraft$Select$Select$calculateNextActiveTarget, state_.activeTargetIndex, totalTargetCount, $author$project$KaizenDraft$Select$Select$Down);
        var nodeQueryForViewportFocus = A2($author$project$KaizenDraft$Select$Select$shouldQueryNextTargetElement, nextActiveTargetIndex, state_) ? A2($author$project$KaizenDraft$Select$Select$queryNodesForViewportFocus, selectId, nextActiveTargetIndex) : $elm$core$Platform$Cmd$none;
        var _v23 = A2($author$project$KaizenDraft$Select$Select$update, $author$project$KaizenDraft$Select$Select$OpenMenu, $author$project$KaizenDraft$Select$Select$State(state_));
        var stateWithOpenMenu = _v23.b.a;
        var cmdWithOpenMenu = _v23.c;
        var _v24 = state_.menuOpen ? _Utils_Tuple2(_Utils_update(state_, {
          activeTargetIndex: nextActiveTargetIndex,
          menuNavigation: $author$project$KaizenDraft$Select$Select$Keyboard
        }), nodeQueryForViewportFocus) : _Utils_Tuple2(_Utils_update(stateWithOpenMenu, {
          menuNavigation: $author$project$KaizenDraft$Select$Select$Keyboard
        }), cmdWithOpenMenu);
        var updatedState = _v24.a;
        var updatedCmd = _v24.b;
        return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(updatedState), updatedCmd);
      case 'KeyboardUp':
        var selectId = msg.a;
        var totalTargetCount = msg.b;
        var nextActiveTargetIndex = A3($author$project$KaizenDraft$Select$Select$calculateNextActiveTarget, state_.activeTargetIndex, totalTargetCount, $author$project$KaizenDraft$Select$Select$Up);
        var nodeQueryForViewportFocus = A2($author$project$KaizenDraft$Select$Select$shouldQueryNextTargetElement, nextActiveTargetIndex, state_) ? A2($author$project$KaizenDraft$Select$Select$queryNodesForViewportFocus, selectId, nextActiveTargetIndex) : $elm$core$Platform$Cmd$none;
        var _v25 = A2($author$project$KaizenDraft$Select$Select$update, $author$project$KaizenDraft$Select$Select$OpenMenu, $author$project$KaizenDraft$Select$Select$State(state_));
        var stateWithOpenMenu = _v25.b.a;
        var cmdWithOpenMenu = _v25.c;
        var _v26 = state_.menuOpen ? _Utils_Tuple2(_Utils_update(state_, {
          activeTargetIndex: nextActiveTargetIndex,
          menuNavigation: $author$project$KaizenDraft$Select$Select$Keyboard
        }), nodeQueryForViewportFocus) : _Utils_Tuple2(_Utils_update(stateWithOpenMenu, {
          menuNavigation: $author$project$KaizenDraft$Select$Select$Keyboard
        }), cmdWithOpenMenu);
        var updatedState = _v26.a;
        var updatedCmd = _v26.b;
        return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(updatedState), updatedCmd);
      case 'OpenMenu':
        return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(_Utils_update(state_, {
          activeTargetIndex: 0,
          menuOpen: true
        })), $elm$core$Platform$Cmd$none);
      case 'CloseMenu':
        return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(_Utils_update(state_, {
          activeTargetIndex: 0,
          menuListScrollTop: 0,
          menuNavigation: $author$project$KaizenDraft$Select$Select$Mouse,
          menuOpen: false,
          menuViewportFocusNodes: $elm$core$Maybe$Nothing
        })), $elm$core$Platform$Cmd$none);
      case 'MenuListScrollTop':
        var position = msg.a;
        return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(_Utils_update(state_, {
          menuListScrollTop: position
        })), $elm$core$Platform$Cmd$none);
      case 'SetMouseMenuNavigation':
        return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$Internal, $author$project$KaizenDraft$Select$Select$State(_Utils_update(state_, {
          menuNavigation: $author$project$KaizenDraft$Select$Select$Mouse
        })), $elm$core$Platform$Cmd$none);
      default:
        return _Utils_Tuple3($author$project$KaizenDraft$Select$Select$DeselectSingleSelectItem, $author$project$KaizenDraft$Select$Select$State(state_), $elm$core$Platform$Cmd$none);
    }
  });
  var $author$project$ResponsePreviewSetup$Containers$AccountDemographics$State$updateAccountDemographic = F3(function (context, msg, accountDemographic) {
    switch (msg.$) {
      case 'DebounceMsg':
        var subMsg = msg.a;
        var _v1 = A2($Gizra$elm_debouncer$Debouncer$Basic$update, subMsg, accountDemographic.debouncer);
        var subModel = _v1.a;
        var subCmd = _v1.b;
        var emittedMsg = _v1.c;
        var mappedCmd = A2($elm$core$Platform$Cmd$map, $author$project$ResponsePreviewSetup$Containers$AccountDemographics$Types$DebounceMsg, subCmd);
        var updatedModel = _Utils_update(accountDemographic, {
          debouncer: subModel
        });
        if (emittedMsg.$ === 'Just') {
          var emitted = emittedMsg.a;
          return A2($elm$core$Tuple$mapSecond, function (cmd) {
            return $elm$core$Platform$Cmd$batch(_List_fromArray([cmd, mappedCmd]));
          }, A3($author$project$ResponsePreviewSetup$Containers$AccountDemographics$State$updateAccountDemographic, context, emitted, updatedModel));
        } else {
          return _Utils_Tuple2(updatedModel, mappedCmd);
        }
      case 'SelectDemographicValue':
        var demographicValue = msg.a;
        return _Utils_Tuple2(_Utils_update(accountDemographic, {
          uiSelectedDemographicValue: $elm$core$Maybe$Just(demographicValue)
        }), $elm$core$Platform$Cmd$none);
      case 'DemographicValueQuery':
        if (msg.a.$ === 'Ok') {
          var selectOptionData = msg.a.a;
          var mappedQueriedSelectOptions = A2($elm$core$List$map, $author$project$ResponsePreviewSetup$Mappers$selectOptionMapper, selectOptionData);
          var appendQueriedData = F2(function (queriedOption, currentOptions) {
            return A2($elm$core$List$any, function (co) {
              return _Utils_eq(queriedOption.id, co.id);
            }, currentOptions) ? currentOptions : A2($elm$core$List$cons, queriedOption, currentOptions);
          });
          return _Utils_Tuple2(_Utils_update(accountDemographic, {
            selectOptions: A3($elm$core$List$foldr, appendQueriedData, accountDemographic.selectOptions, mappedQueriedSelectOptions),
            uiQueriedSelectOptions: $author$project$ResponsePreviewSetup$Common$Types$Resolved(mappedQueriedSelectOptions)
          }), $elm$core$Platform$Cmd$none);
        } else {
          return _Utils_Tuple2(_Utils_update(accountDemographic, {
            uiQueriedSelectOptions: $author$project$ResponsePreviewSetup$Common$Types$Error
          }), $elm$core$Platform$Cmd$none);
        }
      case 'ClearSelectedDemographicValue':
        return _Utils_Tuple2(_Utils_update(accountDemographic, {
          uiSelectedDemographicValue: $elm$core$Maybe$Nothing
        }), $elm$core$Platform$Cmd$none);
      case 'UpdateDemographics':
        var inputString = msg.a;
        var params = {
          demographicId: accountDemographic.id,
          limit: 10,
          locale: 'en',
          text: inputString
        };
        return _Utils_Tuple2(_Utils_update(accountDemographic, {
          uiQueriedSelectOptions: $author$project$ResponsePreviewSetup$Common$Types$Resolving
        }), A4($author$project$ResponsePreviewSetup$Requests$Request$queryRequest, context.securityToken, A2($author$project$ResponsePreviewSetup$Requests$DemographicValues$buildUrl, context.actions.demographicSelectOptionsAction, params), $author$project$ResponsePreviewSetup$Containers$AccountDemographics$Types$DemographicValueQuery, $author$project$ResponsePreviewSetup$Requests$DemographicValues$decoder));
      default:
        var selectMsg = msg.a;
        var _v3 = A2($author$project$KaizenDraft$Select$Select$update, selectMsg, accountDemographic.uiDemographicValueSelect);
        var action = _v3.a;
        var selectState = _v3.b;
        var cmds = _v3.c;
        var _v4 = function () {
          switch (action.$) {
            case 'Select':
              var item = action.a;
              return _Utils_Tuple2(_Utils_update(accountDemographic, {
                uiDemographicValueSelect: selectState,
                uiSelectedDemographicValue: $elm$core$Maybe$Just(item)
              }), $elm$core$Platform$Cmd$none);
            case 'InputChange':
              var string = action.a;
              var _v6 = A2($Gizra$elm_debouncer$Debouncer$Basic$update, $Gizra$elm_debouncer$Debouncer$Basic$provideInput($author$project$ResponsePreviewSetup$Containers$AccountDemographics$Types$UpdateDemographics(string)), accountDemographic.debouncer);
              var subCmd = _v6.b;
              return _Utils_Tuple2(_Utils_update(accountDemographic, {
                uiDemographicValueSelect: selectState,
                uiQueriedSelectOptions: $author$project$ResponsePreviewSetup$Common$Types$Debouncing
              }), A2($elm$core$Platform$Cmd$map, $author$project$ResponsePreviewSetup$Containers$AccountDemographics$Types$DebounceMsg, subCmd));
            default:
              return _Utils_Tuple2(_Utils_update(accountDemographic, {
                uiDemographicValueSelect: selectState
              }), $elm$core$Platform$Cmd$none);
          }
        }();
        var updatedAccountDemopgrahic = _v4.a;
        var cmd = _v4.b;
        return _Utils_Tuple2(updatedAccountDemopgrahic, $elm$core$Platform$Cmd$batch(_List_fromArray([cmd, A2($elm$core$Platform$Cmd$map, $author$project$ResponsePreviewSetup$Containers$AccountDemographics$Types$SelectMsg, cmds)])));
    }
  });
  var $author$project$ResponsePreviewSetup$Containers$AccountDemographics$State$update = F3(function (context, msg, accountDemographics) {
    if (msg.$ === 'AccountDemographicMsg') {
      var accountDemographicId = msg.a;
      var accountDemographicMsg = msg.b;
      var updateDemographic = function (accountDemographic) {
        return _Utils_eq(accountDemographicId, accountDemographic.id) ? A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$ResponsePreviewSetup$Containers$AccountDemographics$Types$AccountDemographicMsg(accountDemographicId)), A3($author$project$ResponsePreviewSetup$Containers$AccountDemographics$State$updateAccountDemographic, context, accountDemographicMsg, accountDemographic)) : _Utils_Tuple2(accountDemographic, $elm$core$Platform$Cmd$none);
      };
      var updatedAccountDemographics = A2($elm$core$List$map, updateDemographic, accountDemographics);
      return _Utils_Tuple2(A2($elm$core$List$map, $elm$core$Tuple$first, updatedAccountDemographics), $elm$core$Platform$Cmd$batch(A2($elm$core$List$map, $elm$core$Tuple$second, updatedAccountDemographics)));
    } else {
      return _Utils_Tuple2(accountDemographics, $elm$core$Platform$Cmd$none);
    }
  });
  var $author$project$ResponsePreviewSetup$Requests$Helpers$Url$appendQuery = F3(function (url, property, value) {
    var _v0 = url.query;
    if (_v0.$ === 'Just') {
      var query = _v0.a;
      return _Utils_update(url, {
        query: $elm$core$Maybe$Just(query + ('&' + (property + ('=' + value))))
      });
    } else {
      return _Utils_update(url, {
        query: $elm$core$Maybe$Just(property + ('=' + value))
      });
    }
  });
  var $author$project$ResponsePreviewSetup$Requests$Helpers$Url$parsedUrl = function (path) {
    return $elm$url$Url$fromString(path);
  };
  var $elm$url$Url$addPort = F2(function (maybePort, starter) {
    if (maybePort.$ === 'Nothing') {
      return starter;
    } else {
      var port_ = maybePort.a;
      return starter + (':' + $elm$core$String$fromInt(port_));
    }
  });
  var $elm$url$Url$addPrefixed = F3(function (prefix, maybeSegment, starter) {
    if (maybeSegment.$ === 'Nothing') {
      return starter;
    } else {
      var segment = maybeSegment.a;
      return _Utils_ap(starter, _Utils_ap(prefix, segment));
    }
  });
  var $elm$url$Url$toString = function (url) {
    var http = function () {
      var _v0 = url.protocol;
      if (_v0.$ === 'Http') {
        return 'http://';
      } else {
        return 'https://';
      }
    }();
    return A3($elm$url$Url$addPrefixed, '#', url.fragment, A3($elm$url$Url$addPrefixed, '?', url.query, _Utils_ap(A2($elm$url$Url$addPort, url.port_, _Utils_ap(http, url.host)), url.path)));
  };
  var $author$project$ResponsePreviewSetup$Requests$Request$urlAppend = F3(function (path, property, value) {
    var parsedUrl = function () {
      var _v0 = $author$project$ResponsePreviewSetup$Requests$Helpers$Url$parsedUrl(path);
      if (_v0.$ === 'Just') {
        var url = _v0.a;
        return $elm$url$Url$toString(A3($author$project$ResponsePreviewSetup$Requests$Helpers$Url$appendQuery, url, property, value));
      } else {
        return '#';
      }
    }();
    return parsedUrl;
  });
  var $author$project$ResponsePreviewSetup$State$updateState = F2(function (msg, state) {
    switch (msg.$) {
      case 'AccountDemographics':
        var accountDemoMsg = msg.a;
        var _v1 = A3($author$project$ResponsePreviewSetup$Containers$AccountDemographics$State$update, state.appContext, accountDemoMsg, state.accountDemographics);
        var updatedAccountDemographicsState = _v1.a;
        var updatedAccountDemographicsCmds = _v1.b;
        return _Utils_Tuple2(_Utils_update(state, {
          accountDemographics: updatedAccountDemographicsState
        }), A2($elm$core$Platform$Cmd$map, $author$project$ResponsePreviewSetup$Types$AccountDemographics, updatedAccountDemographicsCmds));
      case 'Update':
        var buildParams = F2(function (accountDemographic, acc) {
          var _v2 = accountDemographic.uiSelectedDemographicValue;
          if (_v2.$ === 'Just') {
            var demographicValue = _v2.a;
            return _Utils_ap(acc, _List_fromArray([{
              id: accountDemographic.id,
              selectedDemographicValue: demographicValue
            }]));
          } else {
            return acc;
          }
        });
        var selectedAccountDemographics = A3($elm$core$List$foldl, buildParams, _List_Nil, state.accountDemographics);
        return _Utils_Tuple2(state, A3($author$project$ResponsePreviewSetup$Requests$Request$send, state.appContext.securityToken, state.appContext.actions.setupPreviewAction, $author$project$ResponsePreviewSetup$Requests$SelectedDemographicValues$encode({
          demographics: selectedAccountDemographics
        })));
      case 'UpdateResponse':
        if (msg.a.$ === 'Ok') {
          var redirectUrl = msg.a.a;
          return _Utils_Tuple2(state, $elm$browser$Browser$Navigation$load(A3($author$project$ResponsePreviewSetup$Requests$Request$urlAppend, redirectUrl, 'welcome', 'true')));
        } else {
          return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
        }
      case 'CloseApp':
        return _Utils_Tuple2(_Utils_update(state, {
          accountDemographics: A2($elm$core$List$map, function (accDemo) {
            return _Utils_update(accDemo, {
              uiSelectedDemographicValue: A3($author$project$ResponsePreviewSetup$Mappers$selectedDemographicValueMapper, accDemo.id, accDemo.selectOptions, state.demographicAssignments)
            });
          }, state.accountDemographics),
          appVisible: false
        }), $author$project$ResponsePreviewSetup$Ports$closeApp(_Utils_Tuple0));
      default:
        return _Utils_Tuple2(_Utils_update(state, {
          appVisible: true
        }), $elm$core$Platform$Cmd$none);
    }
  });
  var $author$project$ResponsePreviewSetup$State$update = F2(function (appMsg, appState) {
    if (appState.$ === 'AppOk') {
      var state = appState.a;
      return A2($elm$core$Tuple$mapFirst, $author$project$ResponsePreviewSetup$Types$AppOk, A2($author$project$ResponsePreviewSetup$State$updateState, appMsg, state));
    } else {
      return _Utils_Tuple2(appState, $elm$core$Platform$Cmd$none);
    }
  });
  var $elm$json$Json$Decode$value = _Json_decodeValue;
  var $author$project$ResponsePreviewSetup$Types$CloseApp = {
    $: 'CloseApp'
  };
  var $author$project$ResponsePreviewSetup$Types$Update = {
    $: 'Update'
  };
  var $author$project$Text$Text$ZenHeading2 = {
    $: 'ZenHeading2'
  };
  var $elm$html$Html$a = _VirtualDom_node('a');
  var $elm$html$Html$div = _VirtualDom_node('div');
  var $author$project$Text$Text$Config = function (a) {
    return {
      $: 'Config',
      a: a
    };
  };
  var $author$project$Text$Text$DefaultStyle = {
    $: 'DefaultStyle'
  };
  var $author$project$Text$Text$defaultConfig = {
    id: $elm$core$Maybe$Nothing,
    inheritBaseline: false,
    inline: false,
    style: $author$project$Text$Text$DefaultStyle,
    tag: $elm$html$Html$div
  };
  var $elm$html$Html$h2 = _VirtualDom_node('h2');
  var $author$project$Text$Text$h2 = $author$project$Text$Text$Config(_Utils_update($author$project$Text$Text$defaultConfig, {
    tag: $elm$html$Html$h2
  }));
  var $elm$html$Html$header = _VirtualDom_node('header');
  var $author$project$KaizenDraft$Button$Button$Config = function (a) {
    return {
      $: 'Config',
      a: a
    };
  };
  var $author$project$KaizenDraft$Button$Button$icon = F2(function (svgAsset, _v0) {
    var config = _v0.a;
    return $author$project$KaizenDraft$Button$Button$Config(_Utils_update(config, {
      icon: $elm$core$Maybe$Just(svgAsset)
    }));
  });
  var $author$project$KaizenDraft$Button$Button$Default = {
    $: 'Default'
  };
  var $author$project$KaizenDraft$Button$Button$End = {
    $: 'End'
  };
  var $author$project$KaizenDraft$Button$Button$defaults = {
    automationId: $elm$core$Maybe$Nothing,
    buttonType: $elm$core$Maybe$Nothing,
    destructive: false,
    disabled: false,
    form: false,
    fullWidth: false,
    href: $elm$core$Maybe$Nothing,
    icon: $elm$core$Maybe$Nothing,
    iconButton: false,
    iconPosition: $author$project$KaizenDraft$Button$Button$End,
    id: $elm$core$Maybe$Nothing,
    newTabAndIUnderstandTheAccessibilityImplications: false,
    onBlur: $elm$core$Maybe$Nothing,
    onClick: $elm$core$Maybe$Nothing,
    onFocus: $elm$core$Maybe$Nothing,
    onMouseDown: $elm$core$Maybe$Nothing,
    preventKeydownOn: _List_Nil,
    reversed: false,
    variant: $author$project$KaizenDraft$Button$Button$Default
  };
  var $author$project$KaizenDraft$Button$Button$iconButton = function (svgAsset) {
    return $author$project$KaizenDraft$Button$Button$Config(_Utils_update($author$project$KaizenDraft$Button$Button$defaults, {
      icon: $elm$core$Maybe$Just(svgAsset),
      iconButton: true
    }));
  };
  var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
  var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
  var $elm$html$Html$nav = _VirtualDom_node('nav');
  var $elm$virtual_dom$VirtualDom$Normal = function (a) {
    return {
      $: 'Normal',
      a: a
    };
  };
  var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
  var $elm$html$Html$Events$on = F2(function (event, decoder) {
    return A2($elm$virtual_dom$VirtualDom$on, event, $elm$virtual_dom$VirtualDom$Normal(decoder));
  });
  var $elm$html$Html$Events$onClick = function (msg) {
    return A2($elm$html$Html$Events$on, 'click', $elm$json$Json$Decode$succeed(msg));
  };
  var $author$project$KaizenDraft$Button$Button$onClick = F2(function (value, _v0) {
    var config = _v0.a;
    return $author$project$KaizenDraft$Button$Button$Config(_Utils_update(config, {
      onClick: $elm$core$Maybe$Just(value)
    }));
  });
  var $author$project$KaizenDraft$Button$Button$Primary = {
    $: 'Primary'
  };
  var $author$project$KaizenDraft$Button$Button$primary = $author$project$KaizenDraft$Button$Button$Config(_Utils_update($author$project$KaizenDraft$Button$Button$defaults, {
    variant: $author$project$KaizenDraft$Button$Button$Primary
  }));
  var $elm$html$Html$section = _VirtualDom_node('section');
  var $elm$html$Html$span = _VirtualDom_node('span');
  var $author$project$Text$Text$style = F2(function (value, _v0) {
    var config = _v0.a;
    return $author$project$Text$Text$Config(_Utils_update(config, {
      style: value
    }));
  });
  var $cultureamp$elm_css_modules_loader$CssModules$CssModule = F2(function (a, b) {
    return {
      $: 'CssModule',
      a: a,
      b: b
    };
  });
  var $elm$html$Html$Attributes$stringProperty = F2(function (key, string) {
    return A2(_VirtualDom_property, key, $elm$json$Json$Encode$string(string));
  });
  var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
  var $cultureamp$elm_css_modules_loader$CssModules$class = F2(function (_v0, accessor) {
    var classes = _v0.b;
    return $elm$html$Html$Attributes$class(accessor(classes));
  });
  var $elm$core$List$filter = F2(function (isGood, list) {
    return A3($elm$core$List$foldr, F2(function (x, xs) {
      return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
    }), _List_Nil, list);
  });
  var $elm$html$Html$Attributes$classList = function (classes) {
    return $elm$html$Html$Attributes$class(A2($elm$core$String$join, ' ', A2($elm$core$List$map, $elm$core$Tuple$first, A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
  };
  var $cultureamp$elm_css_modules_loader$CssModules$classList = F2(function (_v0, list) {
    var classes = _v0.b;
    return $elm$html$Html$Attributes$classList(A2($elm$core$List$map, $elm$core$Tuple$mapFirst(function (accessor) {
      return accessor(classes);
    }), list));
  });
  var $cultureamp$elm_css_modules_loader$CssModules$toString = F2(function (_v0, accessor) {
    var classes = _v0.b;
    return accessor(classes);
  });
  var $cultureamp$elm_css_modules_loader$CssModules$css = F2(function (stylesheet, classes) {
    var cssModule = A2($cultureamp$elm_css_modules_loader$CssModules$CssModule, stylesheet, classes);
    return {
      _class: $cultureamp$elm_css_modules_loader$CssModules$class(cssModule),
      classList: $cultureamp$elm_css_modules_loader$CssModules$classList(cssModule),
      toString: $cultureamp$elm_css_modules_loader$CssModules$toString(cssModule)
    };
  });
  var $author$project$ResponsePreviewSetup$View$styles = A2($cultureamp$elm_css_modules_loader$CssModules$css, './ResponsePreviewSetup/Style.scss', {
    cancel: require("./ResponsePreviewSetup/Style.scss")["cancel"],
    close: require("./ResponsePreviewSetup/Style.scss")["close"],
    content: require("./ResponsePreviewSetup/Style.scss")["content"],
    dialog: require("./ResponsePreviewSetup/Style.scss")["dialog"],
    overlay: require("./ResponsePreviewSetup/Style.scss")["overlay"],
    sectionWrap: require("./ResponsePreviewSetup/Style.scss")["sectionWrap"],
    subHeading: require("./ResponsePreviewSetup/Style.scss")["subHeading"],
    visible: require("./ResponsePreviewSetup/Style.scss")["visible"]
  });
  var $author$project$Icon$SvgAsset$svgAsset = function (path) {
    return {
      id: 'elm-svg-asset-placeholder',
      viewBox: '0 0 0 0'
    };
  };
  var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
  var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
  var $author$project$KaizenDraft$Button$Button$Destructive = {
    $: 'Destructive'
  };
  var $author$project$KaizenDraft$Button$Button$Secondary = {
    $: 'Secondary'
  };
  var $elm$virtual_dom$VirtualDom$attribute = F2(function (key, value) {
    return A2(_VirtualDom_attribute, _VirtualDom_noOnOrFormAction(key), _VirtualDom_noJavaScriptOrHtmlUri(value));
  });
  var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
  var $fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel = $elm$html$Html$Attributes$attribute('aria-label');
  var $elm$html$Html$button = _VirtualDom_node('button');
  var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
  var $author$project$KaizenDraft$Button$Button$buttonTypeAttribs = function (config) {
    var _v0 = config.href;
    if (_v0.$ === 'Just') {
      return _List_Nil;
    } else {
      var _v1 = config.buttonType;
      if (_v1.$ === 'Just') {
        var buttonTypeValue = _v1.a;
        var encodedButtonType = function () {
          if (buttonTypeValue.$ === 'Submit') {
            return 'submit';
          } else {
            return 'reset';
          }
        }();
        return _List_fromArray([$elm$html$Html$Attributes$type_(encodedButtonType)]);
      } else {
        return _List_Nil;
      }
    }
  };
  var $elm$json$Json$Encode$bool = _Json_wrap;
  var $elm$html$Html$Attributes$boolProperty = F2(function (key, bool) {
    return A2(_VirtualDom_property, key, $elm$json$Json$Encode$bool(bool));
  });
  var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
  var $elm$html$Html$Attributes$href = function (url) {
    return A2($elm$html$Html$Attributes$stringProperty, 'href', _VirtualDom_noJavaScriptUri(url));
  };
  var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
  var $elm$html$Html$Events$onBlur = function (msg) {
    return A2($elm$html$Html$Events$on, 'blur', $elm$json$Json$Decode$succeed(msg));
  };
  var $author$project$KaizenDraft$Button$Button$onBlurAttribs = function (config) {
    var _v0 = config.onBlur;
    if (_v0.$ === 'Just') {
      var blurMsg = _v0.a;
      return _List_fromArray([$elm$html$Html$Events$onBlur(blurMsg)]);
    } else {
      return _List_Nil;
    }
  };
  var $elm$virtual_dom$VirtualDom$Custom = function (a) {
    return {
      $: 'Custom',
      a: a
    };
  };
  var $elm$html$Html$Events$custom = F2(function (event, decoder) {
    return A2($elm$virtual_dom$VirtualDom$on, event, $elm$virtual_dom$VirtualDom$Custom(decoder));
  });
  var $author$project$KaizenDraft$Button$Button$onClickAttribs = function (config) {
    var _v0 = config.onClick;
    if (_v0.$ === 'Just') {
      var msg = _v0.a;
      var preventDefault = function () {
        var _v1 = config.buttonType;
        if (_v1.$ === 'Just') {
          var buttonTypeValue = _v1.a;
          if (buttonTypeValue.$ === 'Submit') {
            return false;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }();
      var decoder = A2($elm$json$Json$Decode$map, function (m) {
        return {
          message: m,
          preventDefault: preventDefault,
          stopPropagation: false
        };
      }, $elm$json$Json$Decode$succeed(msg));
      return _List_fromArray([A2($elm$html$Html$Events$custom, 'click', decoder)]);
    } else {
      return _List_Nil;
    }
  };
  var $elm$html$Html$Events$onFocus = function (msg) {
    return A2($elm$html$Html$Events$on, 'focus', $elm$json$Json$Decode$succeed(msg));
  };
  var $author$project$KaizenDraft$Button$Button$onFocusAttribs = function (config) {
    var _v0 = config.onFocus;
    if (_v0.$ === 'Just') {
      var focusMsg = _v0.a;
      return _List_fromArray([$elm$html$Html$Events$onFocus(focusMsg)]);
    } else {
      return _List_Nil;
    }
  };
  var $elm$html$Html$Events$onMouseDown = function (msg) {
    return A2($elm$html$Html$Events$on, 'mousedown', $elm$json$Json$Decode$succeed(msg));
  };
  var $author$project$KaizenDraft$Button$Button$onMouseDownAttribs = function (config) {
    var _v0 = config.onMouseDown;
    if (_v0.$ === 'Just') {
      var mouseDownMsg = _v0.a;
      return _List_fromArray([$elm$html$Html$Events$onMouseDown(mouseDownMsg)]);
    } else {
      return _List_Nil;
    }
  };
  var $elm$json$Json$Decode$oneOf = _Json_oneOf;
  var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
    return {
      $: 'MayPreventDefault',
      a: a
    };
  };
  var $elm$html$Html$Events$preventDefaultOn = F2(function (event, decoder) {
    return A2($elm$virtual_dom$VirtualDom$on, event, $elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
  });
  var $author$project$KaizenDraft$Button$Button$preventKeydownAttribs = function (config) {
    return $elm$core$List$isEmpty(config.preventKeydownOn) ? _List_Nil : _List_fromArray([A2($elm$html$Html$Events$preventDefaultOn, 'keydown', A2($elm$json$Json$Decode$map, function (msg) {
      return _Utils_Tuple2(msg, true);
    }, $elm$json$Json$Decode$oneOf(config.preventKeydownOn)))]);
  };
  var $author$project$KaizenDraft$Button$Button$styles = A2($cultureamp$elm_css_modules_loader$CssModules$css, '@cultureamp/kaizen-elm-draft-button/KaizenDraft/Button/components/GenericButton.module.scss', {
    button: require("@cultureamp/kaizen-elm-draft-button/KaizenDraft/Button/components/GenericButton.module.scss")["button"],
    container: require("@cultureamp/kaizen-elm-draft-button/KaizenDraft/Button/components/GenericButton.module.scss")["container"],
    content: require("@cultureamp/kaizen-elm-draft-button/KaizenDraft/Button/components/GenericButton.module.scss")["content"],
    destructive: require("@cultureamp/kaizen-elm-draft-button/KaizenDraft/Button/components/GenericButton.module.scss")["destructive"],
    destructiveModifier: require("@cultureamp/kaizen-elm-draft-button/KaizenDraft/Button/components/GenericButton.module.scss")["destructiveModifier"],
    form: require("@cultureamp/kaizen-elm-draft-button/KaizenDraft/Button/components/GenericButton.module.scss")["form"],
    fullWidth: require("@cultureamp/kaizen-elm-draft-button/KaizenDraft/Button/components/GenericButton.module.scss")["fullWidth"],
    iconButton: require("@cultureamp/kaizen-elm-draft-button/KaizenDraft/Button/components/GenericButton.module.scss")["iconButton"],
    iconWrapper: require("@cultureamp/kaizen-elm-draft-button/KaizenDraft/Button/components/GenericButton.module.scss")["iconWrapper"],
    label: require("@cultureamp/kaizen-elm-draft-button/KaizenDraft/Button/components/GenericButton.module.scss")["label"],
    primary: require("@cultureamp/kaizen-elm-draft-button/KaizenDraft/Button/components/GenericButton.module.scss")["primary"],
    reversed: require("@cultureamp/kaizen-elm-draft-button/KaizenDraft/Button/components/GenericButton.module.scss")["reversed"],
    secondary: require("@cultureamp/kaizen-elm-draft-button/KaizenDraft/Button/components/GenericButton.module.scss")["secondary"],
    secondaryDestructive: require("@cultureamp/kaizen-elm-draft-button/KaizenDraft/Button/components/GenericButton.module.scss")["secondaryDestructive"]
  });
  var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
  var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
  var $author$project$KaizenDraft$Button$Button$Start = {
    $: 'Start'
  };
  var $author$project$Icon$Icon$Config = function (a) {
    return {
      $: 'Config',
      a: a
    };
  };
  var $author$project$Icon$Icon$Presentation = {
    $: 'Presentation'
  };
  var $author$project$Icon$Icon$defaults = {
    inheritSize: false,
    role: $author$project$Icon$Icon$Presentation
  };
  var $author$project$Icon$Icon$presentation = $author$project$Icon$Icon$Config($author$project$Icon$Icon$defaults);
  var $fapian$elm_html_aria$Html$Attributes$Aria$boolAttribute = F2(function (name, val) {
    return A2($elm$html$Html$Attributes$attribute, name, A2($elm$json$Json$Encode$encode, 0, $elm$json$Json$Encode$bool(val)));
  });
  var $fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden = $fapian$elm_html_aria$Html$Attributes$Aria$boolAttribute('aria-hidden');
  var $fapian$elm_html_aria$Html$Attributes$Aria$ariaLabelledby = $elm$html$Html$Attributes$attribute('aria-labelledby');
  var $elm$core$String$concat = function (strings) {
    return A2($elm$core$String$join, '', strings);
  };
  var $author$project$Icon$Icon$descId = function (id) {
    return id + '-desc';
  };
  var $fapian$elm_html_aria$Html$Attributes$Aria$role = $elm$html$Html$Attributes$attribute('role');
  var $author$project$Icon$Icon$titleId = function (id) {
    return id + '-label';
  };
  var $author$project$Icon$Icon$a11yAttributes = function (_v0) {
    var role = _v0.a.role;
    if (role.$ === 'Presentation') {
      return _List_fromArray([$fapian$elm_html_aria$Html$Attributes$Aria$role('presentation'), $fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)]);
    } else {
      var id = role.a.a;
      var desc = role.c;
      return _List_fromArray([$fapian$elm_html_aria$Html$Attributes$Aria$role('img'), $fapian$elm_html_aria$Html$Attributes$Aria$ariaLabelledby(function () {
        if (desc.$ === 'Just') {
          return $elm$core$String$concat(_List_fromArray([$author$project$Icon$Icon$titleId(id), ' ', $author$project$Icon$Icon$descId(id)]));
        } else {
          return $author$project$Icon$Icon$titleId(id);
        }
      }())]);
    }
  };
  var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
  var $elm$svg$Svg$desc = $elm$svg$Svg$trustedNode('desc');
  var $elm$svg$Svg$title = $elm$svg$Svg$trustedNode('title');
  var $author$project$Icon$Icon$a11yElements = function (_v0) {
    var role = _v0.a.role;
    if (role.$ === 'Img') {
      var id = role.a.a;
      var title = role.b.a;
      var desc = role.c;
      return _List_fromArray([A2($elm$svg$Svg$title, _List_fromArray([$elm$html$Html$Attributes$id($author$project$Icon$Icon$titleId(id))]), _List_fromArray([$elm$html$Html$text(title)])), function () {
        if (desc.$ === 'Just') {
          var str = desc.a.a;
          return A2($elm$svg$Svg$desc, _List_fromArray([$elm$html$Html$Attributes$id($author$project$Icon$Icon$descId(id))]), _List_fromArray([$elm$html$Html$text(str)]));
        } else {
          return $elm$html$Html$text('');
        }
      }()]);
    } else {
      return _List_Nil;
    }
  };
  var $elm$core$List$append = F2(function (xs, ys) {
    if (!ys.b) {
      return xs;
    } else {
      return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
    }
  });
  var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
  var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
  var $elm$svg$Svg$use = $elm$svg$Svg$trustedNode('use');
  var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
  var $elm$svg$Svg$Attributes$xlinkHref = function (value) {
    return A3(_VirtualDom_attributeNS, 'http://www.w3.org/1999/xlink', 'xlink:href', _VirtualDom_noJavaScriptUri(value));
  };
  var $author$project$Icon$Icon$view = F2(function (config, svgAsset) {
    var configValue = config.a;
    var _v0 = A2($cultureamp$elm_css_modules_loader$CssModules$css, '@cultureamp/kaizen-elm-component-library/components/Icon/Icon.module.scss', {
      icon: require("@cultureamp/kaizen-elm-component-library/components/Icon/Icon.module.scss")["icon"],
      inheritSize: require("@cultureamp/kaizen-elm-component-library/components/Icon/Icon.module.scss")["inheritSize"]
    });
    var toString = _v0.toString;
    return A2($elm$svg$Svg$svg, A2($elm$core$List$append, _List_fromArray([$elm$svg$Svg$Attributes$class(A2($elm$core$String$join, ' ', A2($elm$core$List$map, toString, A2($elm$core$List$map, $elm$core$Tuple$first, A2($elm$core$List$filter, $elm$core$Tuple$second, _List_fromArray([_Utils_Tuple2(function ($) {
      return $.icon;
    }, true), _Utils_Tuple2(function ($) {
      return $.inheritSize;
    }, configValue.inheritSize)])))))), $elm$svg$Svg$Attributes$viewBox(svgAsset.viewBox), A2($elm$html$Html$Attributes$attribute, 'focusable', 'false')]), $author$project$Icon$Icon$a11yAttributes(config)), A2($elm$core$List$append, $author$project$Icon$Icon$a11yElements(config), _List_fromArray([A2($elm$svg$Svg$use, _List_fromArray([$elm$svg$Svg$Attributes$xlinkHref('#' + svgAsset.id)]), _List_Nil)])));
  });
  var $author$project$KaizenDraft$Button$Button$viewIconFor = F2(function (configValue, forPosition) {
    if (_Utils_eq(configValue.iconPosition, forPosition)) {
      var _v0 = configValue.icon;
      if (_v0.$ === 'Just') {
        var svgAsset = _v0.a;
        return A2($elm$html$Html$span, _List_fromArray([$author$project$KaizenDraft$Button$Button$styles._class(function ($) {
          return $.iconWrapper;
        })]), _List_fromArray([A2($author$project$Icon$Icon$view, $author$project$Icon$Icon$presentation, svgAsset)]));
      } else {
        return $elm$html$Html$text('');
      }
    } else {
      return $elm$html$Html$text('');
    }
  });
  var $author$project$KaizenDraft$Button$Button$viewLabel = F2(function (label, isIconButton) {
    return isIconButton ? $elm$html$Html$text('') : A2($elm$html$Html$span, _List_fromArray([$author$project$KaizenDraft$Button$Button$styles._class(function ($) {
      return $.label;
    })]), _List_fromArray([$elm$html$Html$text(label)]));
  });
  var $author$project$KaizenDraft$Button$Button$viewContent = F2(function (_v0, label) {
    var config = _v0.a;
    return A2($elm$html$Html$span, _List_fromArray([$author$project$KaizenDraft$Button$Button$styles._class(function ($) {
      return $.content;
    })]), _List_fromArray([A2($author$project$KaizenDraft$Button$Button$viewIconFor, config, $author$project$KaizenDraft$Button$Button$Start), A2($author$project$KaizenDraft$Button$Button$viewLabel, label, config.iconButton), A2($author$project$KaizenDraft$Button$Button$viewIconFor, config, $author$project$KaizenDraft$Button$Button$End)]));
  });
  var $author$project$KaizenDraft$Button$Button$view = F2(function (_v0, label) {
    var config = _v0.a;
    var titleAttr = config.iconButton ? _List_fromArray([$elm$html$Html$Attributes$title(label), $fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(label)]) : _List_Nil;
    var targetValue = config.newTabAndIUnderstandTheAccessibilityImplications ? '_blank' : '_self';
    var idAttr = function () {
      var _v3 = config.id;
      if (_v3.$ === 'Just') {
        var idString = _v3.a;
        return _List_fromArray([$elm$html$Html$Attributes$id(idString)]);
      } else {
        return _List_Nil;
      }
    }();
    var disabledAttr = config.disabled ? _List_fromArray([$elm$html$Html$Attributes$disabled(true)]) : _List_Nil;
    var buttonClass = _List_fromArray([$author$project$KaizenDraft$Button$Button$styles.classList(_List_fromArray([_Utils_Tuple2(function ($) {
      return $.button;
    }, true), _Utils_Tuple2(function ($) {
      return $.primary;
    }, _Utils_eq(config.variant, $author$project$KaizenDraft$Button$Button$Primary)), _Utils_Tuple2(function ($) {
      return $.secondary;
    }, _Utils_eq(config.variant, $author$project$KaizenDraft$Button$Button$Secondary)), _Utils_Tuple2(function ($) {
      return $.iconButton;
    }, config.iconButton), _Utils_Tuple2(function ($) {
      return $.destructive;
    }, _Utils_eq(config.variant, $author$project$KaizenDraft$Button$Button$Destructive)), _Utils_Tuple2(function ($) {
      return $.form;
    }, config.form), _Utils_Tuple2(function ($) {
      return $.reversed;
    }, config.reversed), _Utils_Tuple2(function ($) {
      return $.destructiveModifier;
    }, config.destructive)]))]);
    var automationIdAttr = function () {
      var _v2 = config.automationId;
      if (_v2.$ === 'Just') {
        var idString = _v2.a;
        return _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'data-automation-id', idString)]);
      } else {
        return _List_Nil;
      }
    }();
    var attribs = _Utils_ap(buttonClass, _Utils_ap($author$project$KaizenDraft$Button$Button$onClickAttribs(config), _Utils_ap($author$project$KaizenDraft$Button$Button$onFocusAttribs(config), _Utils_ap($author$project$KaizenDraft$Button$Button$onBlurAttribs(config), _Utils_ap($author$project$KaizenDraft$Button$Button$preventKeydownAttribs(config), _Utils_ap($author$project$KaizenDraft$Button$Button$onMouseDownAttribs(config), _Utils_ap(automationIdAttr, _Utils_ap(titleAttr, _Utils_ap($author$project$KaizenDraft$Button$Button$buttonTypeAttribs(config), idAttr)))))))));
    return A2($elm$html$Html$span, _List_fromArray([$author$project$KaizenDraft$Button$Button$styles.classList(_List_fromArray([_Utils_Tuple2(function ($) {
      return $.container;
    }, true), _Utils_Tuple2(function ($) {
      return $.fullWidth;
    }, config.fullWidth)]))]), _List_fromArray([function () {
      var _v1 = config.href;
      if (_v1.$ === 'Just') {
        var hrefValue = _v1.a;
        return A2($elm$html$Html$a, _Utils_ap(attribs, _List_fromArray([$elm$html$Html$Attributes$href(hrefValue), $elm$html$Html$Attributes$target(targetValue)])), _List_fromArray([A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$KaizenDraft$Button$Button$viewContent, $author$project$KaizenDraft$Button$Button$Config(config), label))]));
      } else {
        return A2($elm$html$Html$button, _Utils_ap(attribs, disabledAttr), _List_fromArray([A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$KaizenDraft$Button$Button$viewContent, $author$project$KaizenDraft$Button$Button$Config(config), label))]));
      }
    }()]));
  });
  var $author$project$ResponsePreviewSetup$Containers$AccountDemographics$View$styles = A2($cultureamp$elm_css_modules_loader$CssModules$css, './ResponsePreviewSetup/Containers/AccountDemographics/Style.scss', {
    accountDemographic: require("./ResponsePreviewSetup/Containers/AccountDemographics/Style.scss")["accountDemographic"],
    demographicContent: require("./ResponsePreviewSetup/Containers/AccountDemographics/Style.scss")["demographicContent"],
    dropdownWrapper: require("./ResponsePreviewSetup/Containers/AccountDemographics/Style.scss")["dropdownWrapper"],
    title: require("./ResponsePreviewSetup/Containers/AccountDemographics/Style.scss")["title"]
  });
  var $author$project$KaizenDraft$Select$Select$Bold = {
    $: 'Bold'
  };
  var $author$project$KaizenDraft$Select$Select$Default = {
    $: 'Default'
  };
  var $author$project$Text$Text$Label = {
    $: 'Label'
  };
  var $author$project$Text$Text$div = $author$project$Text$Text$Config(_Utils_update($author$project$Text$Text$defaultConfig, {
    tag: $elm$html$Html$div
  }));
  var $elm$core$List$takeReverse = F3(function (n, list, kept) {
    takeReverse: while (true) {
      if (n <= 0) {
        return kept;
      } else {
        if (!list.b) {
          return kept;
        } else {
          var x = list.a;
          var xs = list.b;
          var $temp$n = n - 1,
            $temp$list = xs,
            $temp$kept = A2($elm$core$List$cons, x, kept);
          n = $temp$n;
          list = $temp$list;
          kept = $temp$kept;
          continue takeReverse;
        }
      }
    }
  });
  var $elm$core$List$takeTailRec = F2(function (n, list) {
    return $elm$core$List$reverse(A3($elm$core$List$takeReverse, n, list, _List_Nil));
  });
  var $elm$core$List$takeFast = F3(function (ctr, n, list) {
    if (n <= 0) {
      return _List_Nil;
    } else {
      var _v0 = _Utils_Tuple2(n, list);
      _v0$1: while (true) {
        _v0$5: while (true) {
          if (!_v0.b.b) {
            return list;
          } else {
            if (_v0.b.b.b) {
              switch (_v0.a) {
                case 1:
                  break _v0$1;
                case 2:
                  var _v2 = _v0.b;
                  var x = _v2.a;
                  var _v3 = _v2.b;
                  var y = _v3.a;
                  return _List_fromArray([x, y]);
                case 3:
                  if (_v0.b.b.b.b) {
                    var _v4 = _v0.b;
                    var x = _v4.a;
                    var _v5 = _v4.b;
                    var y = _v5.a;
                    var _v6 = _v5.b;
                    var z = _v6.a;
                    return _List_fromArray([x, y, z]);
                  } else {
                    break _v0$5;
                  }
                default:
                  if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
                    var _v7 = _v0.b;
                    var x = _v7.a;
                    var _v8 = _v7.b;
                    var y = _v8.a;
                    var _v9 = _v8.b;
                    var z = _v9.a;
                    var _v10 = _v9.b;
                    var w = _v10.a;
                    var tl = _v10.b;
                    return ctr > 1000 ? A2($elm$core$List$cons, x, A2($elm$core$List$cons, y, A2($elm$core$List$cons, z, A2($elm$core$List$cons, w, A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2($elm$core$List$cons, x, A2($elm$core$List$cons, y, A2($elm$core$List$cons, z, A2($elm$core$List$cons, w, A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
                  } else {
                    break _v0$5;
                  }
              }
            } else {
              if (_v0.a === 1) {
                break _v0$1;
              } else {
                break _v0$5;
              }
            }
          }
        }
        return list;
      }
      var _v1 = _v0.b;
      var x = _v1.a;
      return _List_fromArray([x]);
    }
  });
  var $elm$core$List$take = F2(function (n, list) {
    return A3($elm$core$List$takeFast, 0, n, list);
  });
  var $author$project$SurveyBuilderCommon$Translations$getNextLocale = function (locale) {
    var localeList = A2($elm$core$String$split, '-', locale);
    var uncheckedLocaleCount = $elm$core$List$length(localeList) - 1;
    return A2($elm$core$String$join, '-', A2($elm$core$List$take, uncheckedLocaleCount, localeList));
  };
  var $author$project$SurveyBuilderCommon$Translations$getTranslation = F2(function (locale, translatableString) {
    return A2($elm$core$Dict$get, locale, translatableString);
  });
  var $author$project$SurveyBuilderCommon$Translations$getTranslationWithDefault = F3(function (locale, translatableString, _default) {
    return A2($elm$core$String$contains, '-', locale) ? A2($elm$core$Maybe$withDefault, A3($author$project$SurveyBuilderCommon$Translations$getTranslationWithDefault, $author$project$SurveyBuilderCommon$Translations$getNextLocale(locale), translatableString, _default), A2($author$project$SurveyBuilderCommon$Translations$getTranslation, locale, translatableString)) : A2($elm$core$Maybe$withDefault, A2($elm$core$Maybe$withDefault, _default, A2($author$project$SurveyBuilderCommon$Translations$getTranslation, 'en', translatableString)), A2($author$project$SurveyBuilderCommon$Translations$getTranslation, locale, translatableString));
  });
  var $author$project$KaizenDraft$Select$Select$Config = function (a) {
    return {
      $: 'Config',
      a: a
    };
  };
  var $author$project$KaizenDraft$Select$Select$isLoading = F2(function (predicate, _v0) {
    var config = _v0.a;
    return $author$project$KaizenDraft$Select$Select$Config(_Utils_update(config, {
      isLoading: predicate
    }));
  });
  var $author$project$KaizenDraft$Select$Select$menuItems = F2(function (items, _v0) {
    var config = _v0.a;
    return $author$project$KaizenDraft$Select$Select$Config(_Utils_update(config, {
      menuItems: items
    }));
  });
  var $author$project$KaizenDraft$Select$Select$placeholder = F2(function (plc, _v0) {
    var config = _v0.a;
    return $author$project$KaizenDraft$Select$Select$Config(_Utils_update(config, {
      placeholder: plc
    }));
  });
  var $author$project$KaizenDraft$Select$Select$searchable = F2(function (predicate, _v0) {
    var config = _v0.a;
    return $author$project$KaizenDraft$Select$Select$Config(_Utils_update(config, {
      searchable: predicate
    }));
  });
  var $author$project$KaizenDraft$Select$Select$selectIdentifier = function (id_) {
    return $author$project$KaizenDraft$Select$Select$SelectId(id_);
  };
  var $author$project$ResponsePreviewSetup$Containers$AccountDemographics$Helpers$selectedDemographicValueName = F2(function (menuItemType, maybeDemographicValue) {
    return A2($elm$core$Maybe$map, function (demographicValue) {
      return {
        item: demographicValue,
        label: A3($author$project$SurveyBuilderCommon$Translations$getTranslationWithDefault, 'en', demographicValue.name, ''),
        menuItemType: menuItemType
      };
    }, maybeDemographicValue);
  });
  var $author$project$KaizenDraft$Select$Select$Single = function (a) {
    return {
      $: 'Single',
      a: a
    };
  };
  var $author$project$KaizenDraft$Select$Select$Faded = {
    $: 'Faded'
  };
  var $author$project$KaizenDraft$Select$Select$defaults = {
    clearable: false,
    controlHasUnconstrainedHeight: false,
    disabled: false,
    isLoading: false,
    menuItems: _List_Nil,
    placeholder: _Utils_Tuple2('Select...', $author$project$KaizenDraft$Select$Select$Faded),
    searchable: true,
    selectType: $author$project$KaizenDraft$Select$Select$Default,
    state: $author$project$KaizenDraft$Select$Select$initState,
    variant: $author$project$KaizenDraft$Select$Select$Single($elm$core$Maybe$Nothing)
  };
  var $author$project$KaizenDraft$Select$Select$single = function (maybeSelectedItem) {
    return $author$project$KaizenDraft$Select$Select$Config(_Utils_update($author$project$KaizenDraft$Select$Select$defaults, {
      variant: $author$project$KaizenDraft$Select$Select$Single(maybeSelectedItem)
    }));
  };
  var $author$project$KaizenDraft$Select$Select$state = F2(function (state_, _v0) {
    var config = _v0.a;
    return $author$project$KaizenDraft$Select$Select$Config(_Utils_update(config, {
      state: state_
    }));
  });
  var $author$project$KaizenDraft$Select$Select$Cautionary = {
    $: 'Cautionary'
  };
  var $author$project$KaizenDraft$Select$Select$Error = {
    $: 'Error'
  };
  var $author$project$KaizenDraft$Select$Select$SearchableSelectContainerClicked = function (a) {
    return {
      $: 'SearchableSelectContainerClicked',
      a: a
    };
  };
  var $author$project$KaizenDraft$Select$Select$UnsearchableSelectContainerClicked = function (a) {
    return {
      $: 'UnsearchableSelectContainerClicked',
      a: a
    };
  };
  var $author$project$KaizenDraft$Select$Select$ViewDummyInputData = F4(function (id, maybeTargetItem, totalViewableMenuItems, menuOpen) {
    return {
      id: id,
      maybeTargetItem: maybeTargetItem,
      menuOpen: menuOpen,
      totalViewableMenuItems: totalViewableMenuItems
    };
  });
  var $author$project$KaizenDraft$Select$Select$ViewMenuData = F6(function (variant, selectId, viewableMenuItems, initialMousedown, activeTargetIndex, menuNavigation) {
    return {
      activeTargetIndex: activeTargetIndex,
      initialMousedown: initialMousedown,
      menuNavigation: menuNavigation,
      selectId: selectId,
      variant: variant,
      viewableMenuItems: viewableMenuItems
    };
  });
  var $author$project$KaizenDraft$Select$Select$ViewSelectInputData = F6(function (id, maybeInputValue, maybeActiveTarget, totalViewableMenuItems, menuOpen, usePorts) {
    return {
      id: id,
      maybeActiveTarget: maybeActiveTarget,
      maybeInputValue: maybeInputValue,
      menuOpen: menuOpen,
      totalViewableMenuItems: totalViewableMenuItems,
      usePorts: usePorts
    };
  });
  var $author$project$KaizenDraft$Select$Select$filterMenuItem = F2(function (maybeQuery, item) {
    if (maybeQuery.$ === 'Nothing') {
      return true;
    } else {
      if (maybeQuery.a === '') {
        return true;
      } else {
        var query = maybeQuery.a;
        return A2($elm$core$String$contains, $elm$core$String$toLower(query), $elm$core$String$toLower(item.label));
      }
    }
  });
  var $elm$core$List$member = F2(function (x, xs) {
    return A2($elm$core$List$any, function (a) {
      return _Utils_eq(a, x);
    }, xs);
  });
  var $author$project$KaizenDraft$Select$Select$filterMultiSelectedItems = F2(function (selectedItems, currentMenuItems) {
    return $elm$core$List$isEmpty(selectedItems) ? currentMenuItems : A2($elm$core$List$filter, function (i) {
      return !A2($elm$core$List$member, i, selectedItems);
    }, currentMenuItems);
  });
  var $author$project$KaizenDraft$Select$Select$buildMenuItems = F2(function (config, state_) {
    var _v0 = config.variant;
    if (_v0.$ === 'Single') {
      return config.searchable ? A2($elm$core$List$filter, $author$project$KaizenDraft$Select$Select$filterMenuItem(state_.inputValue), config.menuItems) : config.menuItems;
    } else {
      var maybeSelectedMenuItems = _v0.b;
      return config.searchable ? A2($author$project$KaizenDraft$Select$Select$filterMultiSelectedItems, maybeSelectedMenuItems, A2($elm$core$List$filter, $author$project$KaizenDraft$Select$Select$filterMenuItem(state_.inputValue), config.menuItems)) : A2($author$project$KaizenDraft$Select$Select$filterMultiSelectedItems, maybeSelectedMenuItems, config.menuItems);
    }
  });
  var $elm$core$List$drop = F2(function (n, list) {
    drop: while (true) {
      if (n <= 0) {
        return list;
      } else {
        if (!list.b) {
          return list;
        } else {
          var x = list.a;
          var xs = list.b;
          var $temp$n = n - 1,
            $temp$list = xs;
          n = $temp$n;
          list = $temp$list;
          continue drop;
        }
      }
    }
  });
  var $elm$core$List$head = function (list) {
    if (list.b) {
      var x = list.a;
      var xs = list.b;
      return $elm$core$Maybe$Just(x);
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };
  var $elm_community$list_extra$List$Extra$getAt = F2(function (idx, xs) {
    return idx < 0 ? $elm$core$Maybe$Nothing : $elm$core$List$head(A2($elm$core$List$drop, idx, xs));
  });
  var $author$project$KaizenDraft$Select$Select$isEmptyInputValue = function (inputValue) {
    return $elm$core$String$isEmpty(A2($elm$core$Maybe$withDefault, '', inputValue));
  };
  var $elm$virtual_dom$VirtualDom$lazy = _VirtualDom_lazy;
  var $elm$html$Html$Lazy$lazy = $elm$virtual_dom$VirtualDom$lazy;
  var $author$project$KaizenDraft$Select$Select$styles = A2($cultureamp$elm_css_modules_loader$CssModules$css, '@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss', {
    bold: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["bold"],
    cautionary: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["cautionary"],
    clearButtonWrapper: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["clearButtonWrapper"],
    container: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["container"],
    control: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["control"],
    controlHasUnconstrainedHeight: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["controlHasUnconstrainedHeight"],
    disabled: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["disabled"],
    error: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["error"],
    faded: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["faded"],
    fadedBold: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["fadedBold"],
    iconButton: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["iconButton"],
    iconButtonDisabled: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["iconButtonDisabled"],
    indicatorContainer: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["indicatorContainer"],
    indicators: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["indicators"],
    isFocused: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["isFocused"],
    isSelected: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["isSelected"],
    isTarget: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["isTarget"],
    menu: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["menu"],
    menuList: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["menuList"],
    multiValue: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["multiValue"],
    option: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["option"],
    placeholder: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["placeholder"],
    preventPointer: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["preventPointer"],
    singleValue: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["singleValue"],
    valueContainer: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["valueContainer"]
  });
  var $author$project$KaizenDraft$Select$Select$SingleSelectClearButtonPressed = {
    $: 'SingleSelectClearButtonPressed'
  };
  var $author$project$KaizenDraft$Select$Select$viewClearButton = A2($elm$html$Html$span, _List_fromArray([$author$project$KaizenDraft$Select$Select$styles._class(function ($) {
    return $.clearButtonWrapper;
  })]), _List_fromArray([A2($author$project$KaizenDraft$Button$Button$view, A2($author$project$KaizenDraft$Button$Button$onClick, $author$project$KaizenDraft$Select$Select$SingleSelectClearButtonPressed, $author$project$KaizenDraft$Button$Button$iconButton(require('@cultureamp/kaizen-elm-component-library/icons/clear.icon.svg').__esModule ? require('@cultureamp/kaizen-elm-component-library/icons/clear.icon.svg').default : require('@cultureamp/kaizen-elm-component-library/icons/clear.icon.svg'))), 'clear')]));
  var $author$project$KaizenDraft$Select$Select$EnterSelect = function (a) {
    return {
      $: 'EnterSelect',
      a: a
    };
  };
  var $author$project$KaizenDraft$Select$Select$InputReceivedFocused = function (a) {
    return {
      $: 'InputReceivedFocused',
      a: a
    };
  };
  var $author$project$KaizenDraft$Select$Select$KeyboardDown = F2(function (a, b) {
    return {
      $: 'KeyboardDown',
      a: a,
      b: b
    };
  });
  var $author$project$KaizenDraft$Select$Select$KeyboardUp = F2(function (a, b) {
    return {
      $: 'KeyboardUp',
      a: a,
      b: b
    };
  });
  var $author$project$KaizenDraft$Select$Select$OnInputBlurred = function (a) {
    return {
      $: 'OnInputBlurred',
      a: a
    };
  };
  var $author$project$KaizenDraft$Select$Select$ToggleMenuAtKey = function (a) {
    return {
      $: 'ToggleMenuAtKey',
      a: a
    };
  };
  var $elm$html$Html$input = _VirtualDom_node('input');
  var $author$project$KaizenDraft$UserInteractions$Keyboard$DownArrow = {
    $: 'DownArrow'
  };
  var $author$project$KaizenDraft$UserInteractions$Keyboard$Backspace = {
    $: 'Backspace'
  };
  var $author$project$KaizenDraft$UserInteractions$Keyboard$Enter = {
    $: 'Enter'
  };
  var $author$project$KaizenDraft$UserInteractions$Keyboard$Escape = {
    $: 'Escape'
  };
  var $author$project$KaizenDraft$UserInteractions$Keyboard$Other = {
    $: 'Other'
  };
  var $author$project$KaizenDraft$UserInteractions$Keyboard$Shift = {
    $: 'Shift'
  };
  var $author$project$KaizenDraft$UserInteractions$Keyboard$Space = {
    $: 'Space'
  };
  var $author$project$KaizenDraft$UserInteractions$Keyboard$Tab = {
    $: 'Tab'
  };
  var $author$project$KaizenDraft$UserInteractions$Keyboard$UpArrow = {
    $: 'UpArrow'
  };
  var $author$project$KaizenDraft$UserInteractions$KeyCodes$backspace = 8;
  var $author$project$KaizenDraft$UserInteractions$KeyCodes$downArrow = 40;
  var $author$project$KaizenDraft$UserInteractions$KeyCodes$enter = 13;
  var $author$project$KaizenDraft$UserInteractions$KeyCodes$escape = 27;
  var $author$project$KaizenDraft$UserInteractions$KeyCodes$shift = 16;
  var $author$project$KaizenDraft$UserInteractions$KeyCodes$space = 32;
  var $author$project$KaizenDraft$UserInteractions$KeyCodes$tab = 9;
  var $author$project$KaizenDraft$UserInteractions$KeyCodes$upArrow = 38;
  var $author$project$KaizenDraft$UserInteractions$Keyboard$keyCodeToKey = function (keyCode) {
    return _Utils_eq(keyCode, $author$project$KaizenDraft$UserInteractions$KeyCodes$escape) ? $author$project$KaizenDraft$UserInteractions$Keyboard$Escape : _Utils_eq(keyCode, $author$project$KaizenDraft$UserInteractions$KeyCodes$backspace) ? $author$project$KaizenDraft$UserInteractions$Keyboard$Backspace : _Utils_eq(keyCode, $author$project$KaizenDraft$UserInteractions$KeyCodes$upArrow) ? $author$project$KaizenDraft$UserInteractions$Keyboard$UpArrow : _Utils_eq(keyCode, $author$project$KaizenDraft$UserInteractions$KeyCodes$downArrow) ? $author$project$KaizenDraft$UserInteractions$Keyboard$DownArrow : _Utils_eq(keyCode, $author$project$KaizenDraft$UserInteractions$KeyCodes$enter) ? $author$project$KaizenDraft$UserInteractions$Keyboard$Enter : _Utils_eq(keyCode, $author$project$KaizenDraft$UserInteractions$KeyCodes$space) ? $author$project$KaizenDraft$UserInteractions$Keyboard$Space : _Utils_eq(keyCode, $author$project$KaizenDraft$UserInteractions$KeyCodes$shift) ? $author$project$KaizenDraft$UserInteractions$Keyboard$Shift : _Utils_eq(keyCode, $author$project$KaizenDraft$UserInteractions$KeyCodes$tab) ? $author$project$KaizenDraft$UserInteractions$Keyboard$Tab : $author$project$KaizenDraft$UserInteractions$Keyboard$Other;
  };
  var $author$project$KaizenDraft$UserInteractions$Keyboard$decoder = $author$project$KaizenDraft$UserInteractions$Keyboard$keyCodeToKey;
  var $author$project$KaizenDraft$Events$Events$isCode = F3(function (key, msg, code) {
    return _Utils_eq($author$project$KaizenDraft$UserInteractions$Keyboard$decoder(code), key) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('not the right key');
  });
  var $elm$json$Json$Decode$int = _Json_decodeInt;
  var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
  var $author$project$KaizenDraft$Events$Events$isDownArrow = function (msg) {
    return A2($elm$json$Json$Decode$andThen, A2($author$project$KaizenDraft$Events$Events$isCode, $author$project$KaizenDraft$UserInteractions$Keyboard$DownArrow, msg), $elm$html$Html$Events$keyCode);
  };
  var $author$project$KaizenDraft$Events$Events$isEnter = function (msg) {
    return A2($elm$json$Json$Decode$andThen, A2($author$project$KaizenDraft$Events$Events$isCode, $author$project$KaizenDraft$UserInteractions$Keyboard$Enter, msg), $elm$html$Html$Events$keyCode);
  };
  var $author$project$KaizenDraft$Events$Events$isEscape = function (msg) {
    return A2($elm$json$Json$Decode$andThen, A2($author$project$KaizenDraft$Events$Events$isCode, $author$project$KaizenDraft$UserInteractions$Keyboard$Escape, msg), $elm$html$Html$Events$keyCode);
  };
  var $author$project$KaizenDraft$Events$Events$isSpace = function (msg) {
    return A2($elm$json$Json$Decode$andThen, A2($author$project$KaizenDraft$Events$Events$isCode, $author$project$KaizenDraft$UserInteractions$Keyboard$Space, msg), $elm$html$Html$Events$keyCode);
  };
  var $author$project$KaizenDraft$Events$Events$isUpArrow = function (msg) {
    return A2($elm$json$Json$Decode$andThen, A2($author$project$KaizenDraft$Events$Events$isCode, $author$project$KaizenDraft$UserInteractions$Keyboard$UpArrow, msg), $elm$html$Html$Events$keyCode);
  };
  var $elm$html$Html$Attributes$readonly = $elm$html$Html$Attributes$boolProperty('readOnly');
  var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
  var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
  var $elm$html$Html$Attributes$tabindex = function (n) {
    return A2(_VirtualDom_attribute, 'tabIndex', $elm$core$String$fromInt(n));
  };
  var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
  var $author$project$KaizenDraft$Select$Select$viewDummyInput = function (viewDummyInputData) {
    var whenEnterEvent = function () {
      var _v0 = viewDummyInputData.maybeTargetItem;
      if (_v0.$ === 'Just') {
        var menuItem = _v0.a;
        return _List_fromArray([$author$project$KaizenDraft$Events$Events$isEnter($author$project$KaizenDraft$Select$Select$EnterSelect(menuItem.item))]);
      } else {
        return _List_Nil;
      }
    }();
    var whenArrowEvents = viewDummyInputData.menuOpen && !viewDummyInputData.totalViewableMenuItems ? _List_Nil : _List_fromArray([$author$project$KaizenDraft$Events$Events$isDownArrow(A2($author$project$KaizenDraft$Select$Select$KeyboardDown, $author$project$KaizenDraft$Select$Select$SelectId(viewDummyInputData.id), viewDummyInputData.totalViewableMenuItems)), $author$project$KaizenDraft$Events$Events$isUpArrow(A2($author$project$KaizenDraft$Select$Select$KeyboardUp, $author$project$KaizenDraft$Select$Select$SelectId(viewDummyInputData.id), viewDummyInputData.totalViewableMenuItems))]);
    return A2($elm$html$Html$input, _Utils_ap(_List_fromArray([A2($elm$html$Html$Attributes$style, 'label', 'dummyInput'), A2($elm$html$Html$Attributes$style, 'background', '0'), A2($elm$html$Html$Attributes$style, 'border', '0'), A2($elm$html$Html$Attributes$style, 'font-size', 'inherit'), A2($elm$html$Html$Attributes$style, 'outline', '0'), A2($elm$html$Html$Attributes$style, 'padding', '0'), A2($elm$html$Html$Attributes$style, 'width', '1px'), A2($elm$html$Html$Attributes$style, 'color', 'transparent')]), _List_fromArray([$elm$html$Html$Attributes$readonly(true), $elm$html$Html$Attributes$value(''), $elm$html$Html$Attributes$tabindex(0), $elm$html$Html$Attributes$id('dummy-input-' + viewDummyInputData.id), $elm$html$Html$Events$onFocus($author$project$KaizenDraft$Select$Select$InputReceivedFocused($elm$core$Maybe$Nothing)), $elm$html$Html$Events$onBlur($author$project$KaizenDraft$Select$Select$OnInputBlurred($elm$core$Maybe$Nothing)), A2($elm$html$Html$Events$custom, 'keydown', A2($elm$json$Json$Decode$map, function (msg) {
      return {
        message: msg,
        preventDefault: true,
        stopPropagation: true
      };
    }, $elm$json$Json$Decode$oneOf(_Utils_ap(_List_fromArray([$author$project$KaizenDraft$Events$Events$isSpace($author$project$KaizenDraft$Select$Select$ToggleMenuAtKey($author$project$KaizenDraft$Select$Select$SelectId(viewDummyInputData.id))), $author$project$KaizenDraft$Events$Events$isEscape($author$project$KaizenDraft$Select$Select$CloseMenu), $author$project$KaizenDraft$Events$Events$isDownArrow(A2($author$project$KaizenDraft$Select$Select$KeyboardDown, $author$project$KaizenDraft$Select$Select$SelectId(viewDummyInputData.id), viewDummyInputData.totalViewableMenuItems)), $author$project$KaizenDraft$Events$Events$isUpArrow(A2($author$project$KaizenDraft$Select$Select$KeyboardUp, $author$project$KaizenDraft$Select$Select$SelectId(viewDummyInputData.id), viewDummyInputData.totalViewableMenuItems))]), _Utils_ap(whenEnterEvent, whenArrowEvents)))))])), _List_Nil);
  };
  var $elm_community$html_extra$Html$Extra$nothing = $elm$html$Html$text('');
  var $elm_community$html_extra$Html$Extra$viewIf = F2(function (condition, html) {
    return condition ? html : $elm_community$html_extra$Html$Extra$nothing;
  });
  var $author$project$KaizenDraft$Select$Select$viewLoading = A2($elm$html$Html$span, _List_fromArray([$author$project$KaizenDraft$Select$Select$styles._class(function ($) {
    return $.iconButton;
  })]), _List_fromArray([A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Icon$Icon$view, $author$project$Icon$Icon$presentation, require('@cultureamp/kaizen-elm-component-library/icons/spinner.icon.svg').__esModule ? require('@cultureamp/kaizen-elm-component-library/icons/spinner.icon.svg').default : require('@cultureamp/kaizen-elm-component-library/icons/spinner.icon.svg')))]));
  var $author$project$KaizenDraft$Select$Select$MenuListScrollTop = function (a) {
    return {
      $: 'MenuListScrollTop',
      a: a
    };
  };
  var $author$project$KaizenDraft$Select$Select$SetMouseMenuNavigation = {
    $: 'SetMouseMenuNavigation'
  };
  var $author$project$KaizenDraft$Select$Select$ViewMenuItemData = F8(function (index, itemSelected, isClickFocused, menuItemIsTarget, selectId, menuItem, menuNavigation, initialMousedown) {
    return {
      index: index,
      initialMousedown: initialMousedown,
      isClickFocused: isClickFocused,
      itemSelected: itemSelected,
      menuItem: menuItem,
      menuItemIsTarget: menuItemIsTarget,
      menuNavigation: menuNavigation,
      selectId: selectId
    };
  });
  var $author$project$KaizenDraft$Select$Select$isMenuItemClickFocused = F2(function (initialMousedown, i) {
    if (initialMousedown.$ === 'MenuItemMousedown') {
      var _int = initialMousedown.a;
      return _Utils_eq(_int, i);
    } else {
      return false;
    }
  });
  var $author$project$KaizenDraft$Select$Select$isSelected = F2(function (menuItem, maybeSelectedItem) {
    if (maybeSelectedItem.$ === 'Just') {
      var item = maybeSelectedItem.a;
      return _Utils_eq(item, menuItem);
    } else {
      return false;
    }
  });
  var $author$project$KaizenDraft$Select$Select$isTarget = F2(function (activeTargetIndex, i) {
    return _Utils_eq(activeTargetIndex, i);
  });
  var $author$project$KaizenDraft$Select$Select$ClearFocusedItem = {
    $: 'ClearFocusedItem'
  };
  var $author$project$KaizenDraft$Select$Select$HoverFocused = function (a) {
    return {
      $: 'HoverFocused',
      a: a
    };
  };
  var $author$project$KaizenDraft$Select$Select$MenuItemClickFocus = function (a) {
    return {
      $: 'MenuItemClickFocus',
      a: a
    };
  };
  var $author$project$KaizenDraft$Select$Select$SelectedItem = function (a) {
    return {
      $: 'SelectedItem',
      a: a
    };
  };
  var $elm$core$Basics$negate = function (n) {
    return -n;
  };
  var $author$project$KaizenDraft$Select$Select$viewMenuItem = function (viewMenuItemData) {
    return _Utils_Tuple2($elm$core$String$fromInt(viewMenuItemData.index), A2($elm$html$Html$Lazy$lazy, function (data) {
      var resolveMouseUp = function () {
        var _v0 = data.initialMousedown;
        if (_v0.$ === 'MenuItemMousedown') {
          return _List_fromArray([A2($elm$html$Html$Events$on, 'mouseup', $elm$json$Json$Decode$succeed($author$project$KaizenDraft$Select$Select$SelectedItem(data.menuItem.item)))]);
        } else {
          return _List_Nil;
        }
      }();
      var resolveMouseLeave = data.isClickFocused ? _List_fromArray([A2($elm$html$Html$Events$on, 'mouseleave', $elm$json$Json$Decode$succeed($author$project$KaizenDraft$Select$Select$ClearFocusedItem))]) : _List_Nil;
      return A2($elm$html$Html$div, _Utils_ap(_List_fromArray([$fapian$elm_html_aria$Html$Attributes$Aria$role('listitem'), $elm$html$Html$Attributes$tabindex(-1), A2($elm$html$Html$Events$preventDefaultOn, 'mousedown', A2($elm$json$Json$Decode$map, function (msg) {
        return _Utils_Tuple2(msg, true);
      }, $elm$json$Json$Decode$succeed($author$project$KaizenDraft$Select$Select$MenuItemClickFocus(data.index)))), A2($elm$html$Html$Events$on, 'mouseover', $elm$json$Json$Decode$succeed($author$project$KaizenDraft$Select$Select$HoverFocused(data.index))), $elm$html$Html$Attributes$id(A2($author$project$KaizenDraft$Select$Select$menuItemId, data.selectId, data.index)), $author$project$KaizenDraft$Select$Select$styles.classList(_List_fromArray([_Utils_Tuple2(function ($) {
        return $.option;
      }, true), _Utils_Tuple2(function ($) {
        return $.isSelected;
      }, data.itemSelected), _Utils_Tuple2(function ($) {
        return $.isFocused;
      }, data.isClickFocused), _Utils_Tuple2(function ($) {
        return $.isTarget;
      }, data.menuItemIsTarget), _Utils_Tuple2(function ($) {
        return $.preventPointer;
      }, _Utils_eq(data.menuNavigation, $author$project$KaizenDraft$Select$Select$Keyboard))])), A2($elm$html$Html$Attributes$attribute, 'data-automation-id', 'Select__Option')]), _Utils_ap(resolveMouseLeave, resolveMouseUp)), _List_fromArray([$elm$html$Html$text(data.menuItem.label)]));
    }, viewMenuItemData));
  };
  var $author$project$KaizenDraft$Select$Select$buildMenuItem = F7(function (selectId, variant, initialMousedown, activeTargetIndex, menuNavigation, idx, item) {
    if (variant.$ === 'Single') {
      var maybeSelectedItem = variant.a;
      return $author$project$KaizenDraft$Select$Select$viewMenuItem(A8($author$project$KaizenDraft$Select$Select$ViewMenuItemData, idx, A2($author$project$KaizenDraft$Select$Select$isSelected, item, maybeSelectedItem), A2($author$project$KaizenDraft$Select$Select$isMenuItemClickFocused, initialMousedown, idx), A2($author$project$KaizenDraft$Select$Select$isTarget, activeTargetIndex, idx), selectId, item, menuNavigation, initialMousedown));
    } else {
      return $author$project$KaizenDraft$Select$Select$viewMenuItem(A8($author$project$KaizenDraft$Select$Select$ViewMenuItemData, idx, false, A2($author$project$KaizenDraft$Select$Select$isMenuItemClickFocused, initialMousedown, idx), A2($author$project$KaizenDraft$Select$Select$isTarget, activeTargetIndex, idx), selectId, item, menuNavigation, initialMousedown));
    }
  });
  var $elm$json$Json$Decode$float = _Json_decodeFloat;
  var $elm$core$String$fromFloat = _String_fromNumber;
  var $author$project$KaizenDraft$Select$Select$hasMenuItems = function (items) {
    return !!$elm$core$List$length(items);
  };
  var $author$project$KaizenDraft$Select$Select$menuMarginTop = 8;
  var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
    return _VirtualDom_keyedNode(_VirtualDom_noScript(tag));
  };
  var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
  var $author$project$KaizenDraft$Select$Select$viewMenu = function (viewMenuData) {
    var resolveMouseover = _Utils_eq(viewMenuData.menuNavigation, $author$project$KaizenDraft$Select$Select$Keyboard) ? _List_fromArray([A2($elm$html$Html$Events$on, 'mousemove', $elm$json$Json$Decode$succeed($author$project$KaizenDraft$Select$Select$SetMouseMenuNavigation))]) : _List_Nil;
    return A2($elm_community$html_extra$Html$Extra$viewIf, $author$project$KaizenDraft$Select$Select$hasMenuItems(viewMenuData.viewableMenuItems), A2($elm$html$Html$div, _Utils_ap(_List_fromArray([$author$project$KaizenDraft$Select$Select$styles._class(function ($) {
      return $.menu;
    }), A2($elm$html$Html$Attributes$style, 'margin-top', $elm$core$String$fromFloat($author$project$KaizenDraft$Select$Select$menuMarginTop) + 'px')]), resolveMouseover), _List_fromArray([A3($elm$html$Html$Keyed$node, 'div', _List_fromArray([$author$project$KaizenDraft$Select$Select$styles._class(function ($) {
      return $.menuList;
    }), $elm$html$Html$Attributes$id($author$project$KaizenDraft$Select$Select$menuListId(viewMenuData.selectId)), A2($elm$html$Html$Events$on, 'scroll', A2($elm$json$Json$Decode$map, $author$project$KaizenDraft$Select$Select$MenuListScrollTop, A2($elm$json$Json$Decode$at, _List_fromArray(['target', 'scrollTop']), $elm$json$Json$Decode$float)))]), A2($elm$core$List$indexedMap, A5($author$project$KaizenDraft$Select$Select$buildMenuItem, viewMenuData.selectId, viewMenuData.variant, viewMenuData.initialMousedown, viewMenuData.activeTargetIndex, viewMenuData.menuNavigation), viewMenuData.viewableMenuItems))])));
  };
  var $author$project$KaizenDraft$Select$Select$DeselectedMultiItem = function (a) {
    return {
      $: 'DeselectedMultiItem',
      a: a
    };
  };
  var $author$project$KaizenDraft$Tag$Tag$Medium = {
    $: 'Medium'
  };
  var $author$project$KaizenDraft$Select$Select$MultiItemFocus = function (a) {
    return {
      $: 'MultiItemFocus',
      a: a
    };
  };
  var $author$project$KaizenDraft$Tag$Tag$ValidationCautionary = {
    $: 'ValidationCautionary'
  };
  var $author$project$KaizenDraft$Tag$Tag$ValidationNegative = {
    $: 'ValidationNegative'
  };
  var $author$project$KaizenDraft$Tag$Tag$Config = function (a) {
    return {
      $: 'Config',
      a: a
    };
  };
  var $author$project$KaizenDraft$Tag$Tag$allowTextWrapping = F2(function (value, _v0) {
    var config = _v0.a;
    return $author$project$KaizenDraft$Tag$Tag$Config(_Utils_update(config, {
      allowTextWrapping: value
    }));
  });
  var $author$project$KaizenDraft$Tag$Tag$Default = {
    $: 'Default'
  };
  var $author$project$KaizenDraft$Tag$Tag$defaults = {
    allowTextWrapping: false,
    dismissible: false,
    inline: false,
    onDismiss: $elm$core$Maybe$Nothing,
    onMousedown: $elm$core$Maybe$Nothing,
    onMouseleave: $elm$core$Maybe$Nothing,
    size: $author$project$KaizenDraft$Tag$Tag$Medium,
    truncationWidth: $elm$core$Maybe$Nothing,
    variant: $author$project$KaizenDraft$Tag$Tag$Default
  };
  var $author$project$KaizenDraft$Tag$Tag$default = $author$project$KaizenDraft$Tag$Tag$Config(_Utils_update($author$project$KaizenDraft$Tag$Tag$defaults, {
    variant: $author$project$KaizenDraft$Tag$Tag$Default
  }));
  var $author$project$KaizenDraft$Tag$Tag$dismissible = F2(function (predicate, _v0) {
    var config = _v0.a;
    return $author$project$KaizenDraft$Tag$Tag$Config(_Utils_update(config, {
      dismissible: predicate
    }));
  });
  var $author$project$KaizenDraft$Tag$Tag$inline = F2(function (predicate, _v0) {
    var config = _v0.a;
    return $author$project$KaizenDraft$Tag$Tag$Config(_Utils_update(config, {
      inline: predicate
    }));
  });
  var $author$project$KaizenDraft$Tag$Tag$onDismiss = F2(function (msg, _v0) {
    var config = _v0.a;
    return $author$project$KaizenDraft$Tag$Tag$Config(_Utils_update(config, {
      onDismiss: $elm$core$Maybe$Just(msg)
    }));
  });
  var $author$project$KaizenDraft$Tag$Tag$onMousedown = F2(function (msg, _v0) {
    var config = _v0.a;
    return $author$project$KaizenDraft$Tag$Tag$Config(_Utils_update(config, {
      onMousedown: $elm$core$Maybe$Just(msg)
    }));
  });
  var $author$project$KaizenDraft$Tag$Tag$onMouseleave = F2(function (msg, _v0) {
    var config = _v0.a;
    return $author$project$KaizenDraft$Tag$Tag$Config(_Utils_update(config, {
      onMouseleave: $elm$core$Maybe$Just(msg)
    }));
  });
  var $author$project$KaizenDraft$Tag$Tag$size = F2(function (size_, _v0) {
    var config = _v0.a;
    return $author$project$KaizenDraft$Tag$Tag$Config(_Utils_update(config, {
      size: size_
    }));
  });
  var $author$project$KaizenDraft$Tag$Tag$truncateWidth = F2(function (width, _v0) {
    var config = _v0.a;
    return $author$project$KaizenDraft$Tag$Tag$Config(_Utils_update(config, {
      truncationWidth: $elm$core$Maybe$Just(width)
    }));
  });
  var $author$project$KaizenDraft$Tag$Tag$Validation = function (a) {
    return {
      $: 'Validation',
      a: a
    };
  };
  var $author$project$KaizenDraft$Tag$Tag$validation = function (variant) {
    return $author$project$KaizenDraft$Tag$Tag$Config(_Utils_update($author$project$KaizenDraft$Tag$Tag$defaults, {
      variant: $author$project$KaizenDraft$Tag$Tag$Validation(variant)
    }));
  };
  var $author$project$KaizenDraft$Tag$Tag$Small = {
    $: 'Small'
  };
  var $author$project$KaizenDraft$Tag$Tag$exclamationIconAsset = require('@cultureamp/kaizen-elm-component-library/icons/exclamation.icon.svg').__esModule ? require('@cultureamp/kaizen-elm-component-library/icons/exclamation.icon.svg').default : require('@cultureamp/kaizen-elm-component-library/icons/exclamation.icon.svg');
  var $author$project$KaizenDraft$Tag$Tag$informationIconAsset = require('@cultureamp/kaizen-elm-component-library/icons/information.icon.svg').__esModule ? require('@cultureamp/kaizen-elm-component-library/icons/information.icon.svg').default : require('@cultureamp/kaizen-elm-component-library/icons/information.icon.svg');
  var $author$project$KaizenDraft$Tag$Tag$styles = A2($cultureamp$elm_css_modules_loader$CssModules$css, '@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss', {
    _default: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["default"],
    dismissButton: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["dismissButton"],
    dismissible: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["dismissible"],
    iconWrapper: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["iconWrapper"],
    inline: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["inline"],
    layoutContainer: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["layoutContainer"],
    medium: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["medium"],
    pulse: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["pulse"],
    pulseRing: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["pulseRing"],
    root: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["root"],
    sentimentNegative: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["sentimentNegative"],
    sentimentNeutral: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["sentimentNeutral"],
    sentimentNone: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["sentimentNone"],
    sentimentPositive: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["sentimentPositive"],
    small: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["small"],
    statusAction: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["statusAction"],
    statusClosed: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["statusClosed"],
    statusDraft: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["statusDraft"],
    statusLive: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["statusLive"],
    textContent: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["textContent"],
    truncate: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["truncate"],
    validationCautionary: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["validationCautionary"],
    validationIcon: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["validationIcon"],
    validationInformative: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["validationInformative"],
    validationNegative: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["validationNegative"],
    validationPositive: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/Tag.scss")["validationPositive"]
  });
  var $author$project$KaizenDraft$Tag$Tag$stylesElmExtra = A2($cultureamp$elm_css_modules_loader$CssModules$css, '@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/TagElmExtra.scss', {
    mediumAllowingTextWrapping: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/TagElmExtra.scss")["mediumAllowingTextWrapping"],
    smallAllowingTextWrapping: require("@cultureamp/kaizen-elm-draft-tag/KaizenDraft/Tag/TagElmExtra.scss")["smallAllowingTextWrapping"]
  });
  var $author$project$Icon$Icon$inheritSize = F2(function (value, _v0) {
    var config = _v0.a;
    return $author$project$Icon$Icon$Config(_Utils_update(config, {
      inheritSize: value
    }));
  });
  var $author$project$KaizenDraft$Tag$Tag$viewClear = function (config) {
    var mouseleave = function (onMouseleaveMsg) {
      return A2($elm$html$Html$Events$on, 'mouseleave', $elm$json$Json$Decode$succeed(onMouseleaveMsg));
    };
    var mousedown = function (onMousedownMsg) {
      return A2($elm$html$Html$Events$on, 'mousedown', $elm$json$Json$Decode$succeed(onMousedownMsg));
    };
    var dismiss = function (onDismissMsg) {
      return $elm$html$Html$Events$onClick(onDismissMsg);
    };
    var events = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A2($elm$core$Maybe$map, dismiss, config.onDismiss), A2($elm$core$Maybe$map, mousedown, config.onMousedown), A2($elm$core$Maybe$map, mouseleave, config.onMouseleave)]));
    return A2($elm$html$Html$button, _Utils_ap(_List_fromArray([$author$project$KaizenDraft$Tag$Tag$styles._class(function ($) {
      return $.dismissButton;
    })]), events), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$author$project$KaizenDraft$Tag$Tag$styles._class(function ($) {
      return $.iconWrapper;
    })]), _List_fromArray([A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Icon$Icon$view, A2($author$project$Icon$Icon$inheritSize, true, $author$project$Icon$Icon$presentation), require('@cultureamp/kaizen-elm-component-library/icons/clear.icon.svg').__esModule ? require('@cultureamp/kaizen-elm-component-library/icons/clear.icon.svg').default : require('@cultureamp/kaizen-elm-component-library/icons/clear.icon.svg')))]))]));
  };
  var $author$project$KaizenDraft$Tag$Tag$viewIndicatorIcon = function (config) {
    return A2($elm$html$Html$span, _List_fromArray([$author$project$KaizenDraft$Tag$Tag$styles._class(function ($) {
      return $.pulse;
    })]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$author$project$KaizenDraft$Tag$Tag$styles._class(function ($) {
      return $.pulseRing;
    })]), _List_Nil)]));
  };
  var $author$project$KaizenDraft$Tag$Tag$viewPositiveValidationIcon = function (config) {
    return A2($elm$html$Html$span, _List_fromArray([$author$project$KaizenDraft$Tag$Tag$styles._class(function ($) {
      return $.validationIcon;
    })]), _List_fromArray([A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Icon$Icon$view, $author$project$Icon$Icon$presentation, require('@cultureamp/kaizen-elm-component-library/icons/success.icon.svg').__esModule ? require('@cultureamp/kaizen-elm-component-library/icons/success.icon.svg').default : require('@cultureamp/kaizen-elm-component-library/icons/success.icon.svg')))]));
  };
  var $author$project$KaizenDraft$Tag$Tag$viewTextContent = F2(function (config, value) {
    var resolveTruncation = function () {
      var _v0 = config.truncationWidth;
      if (_v0.$ === 'Just') {
        var width = _v0.a;
        return _List_fromArray([$author$project$KaizenDraft$Tag$Tag$styles._class(function ($) {
          return $.truncate;
        }), A2($elm$html$Html$Attributes$style, 'max-width', $elm$core$String$fromFloat(width) + 'px')]);
      } else {
        return _List_Nil;
      }
    }();
    return A2($elm$html$Html$span, _Utils_ap(_List_fromArray([$author$project$KaizenDraft$Tag$Tag$styles._class(function ($) {
      return $.textContent;
    })]), resolveTruncation), _List_fromArray([$elm$html$Html$text(value)]));
  });
  var $author$project$KaizenDraft$Tag$Tag$viewValidationIcon = F2(function (config, iconAsset) {
    return A2($elm$html$Html$span, _List_fromArray([$author$project$KaizenDraft$Tag$Tag$styles._class(function ($) {
      return $.validationIcon;
    })]), _List_fromArray([A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Icon$Icon$view, $author$project$Icon$Icon$presentation, iconAsset))]));
  });
  var $author$project$KaizenDraft$Tag$Tag$view = F2(function (_v0, value) {
    var config = _v0.a;
    var resolveVariantStyle = function () {
      var _v8 = config.variant;
      switch (_v8.$) {
        case 'Default':
          return _List_fromArray([_Utils_Tuple2(function ($) {
            return $._default;
          }, true)]);
        case 'Sentiment':
          switch (_v8.a.$) {
            case 'SentimentPositive':
              var _v9 = _v8.a;
              return _List_fromArray([_Utils_Tuple2(function ($) {
                return $.sentimentPositive;
              }, true)]);
            case 'SentimentNeutral':
              var _v10 = _v8.a;
              return _List_fromArray([_Utils_Tuple2(function ($) {
                return $.sentimentNeutral;
              }, true)]);
            case 'SentimentNegative':
              var _v11 = _v8.a;
              return _List_fromArray([_Utils_Tuple2(function ($) {
                return $.sentimentNegative;
              }, true)]);
            default:
              var _v12 = _v8.a;
              return _List_fromArray([_Utils_Tuple2(function ($) {
                return $.sentimentNone;
              }, true)]);
          }
        case 'Validation':
          switch (_v8.a.$) {
            case 'ValidationPositive':
              var _v13 = _v8.a;
              return _List_fromArray([_Utils_Tuple2(function ($) {
                return $.validationPositive;
              }, true)]);
            case 'ValidationInformative':
              var _v14 = _v8.a;
              return _List_fromArray([_Utils_Tuple2(function ($) {
                return $.validationInformative;
              }, true)]);
            case 'ValidationNegative':
              var _v15 = _v8.a;
              return _List_fromArray([_Utils_Tuple2(function ($) {
                return $.validationNegative;
              }, true)]);
            default:
              var _v16 = _v8.a;
              return _List_fromArray([_Utils_Tuple2(function ($) {
                return $.validationCautionary;
              }, true)]);
          }
        default:
          switch (_v8.a.$) {
            case 'StatusLive':
              var _v17 = _v8.a;
              return _List_fromArray([_Utils_Tuple2(function ($) {
                return $.statusLive;
              }, true)]);
            case 'StatusDraft':
              var _v18 = _v8.a;
              return _List_fromArray([_Utils_Tuple2(function ($) {
                return $.statusDraft;
              }, true)]);
            case 'StatusClosed':
              var _v19 = _v8.a;
              return _List_fromArray([_Utils_Tuple2(function ($) {
                return $.statusClosed;
              }, true)]);
            default:
              var _v20 = _v8.a;
              return _List_fromArray([_Utils_Tuple2(function ($) {
                return $.statusAction;
              }, true)]);
          }
      }
    }();
    var resolveValidationIcon = function () {
      var _v3 = config.variant;
      if (_v3.$ === 'Validation') {
        switch (_v3.a.$) {
          case 'ValidationPositive':
            var _v4 = _v3.a;
            return _Utils_eq(config.size, $author$project$KaizenDraft$Tag$Tag$Medium) ? $author$project$KaizenDraft$Tag$Tag$viewPositiveValidationIcon(config) : $elm$html$Html$text('');
          case 'ValidationInformative':
            var _v5 = _v3.a;
            return _Utils_eq(config.size, $author$project$KaizenDraft$Tag$Tag$Medium) ? A2($author$project$KaizenDraft$Tag$Tag$viewValidationIcon, config, $author$project$KaizenDraft$Tag$Tag$informationIconAsset) : $elm$html$Html$text('');
          case 'ValidationNegative':
            var _v6 = _v3.a;
            return _Utils_eq(config.size, $author$project$KaizenDraft$Tag$Tag$Medium) ? A2($author$project$KaizenDraft$Tag$Tag$viewValidationIcon, config, $author$project$KaizenDraft$Tag$Tag$exclamationIconAsset) : $elm$html$Html$text('');
          default:
            var _v7 = _v3.a;
            return _Utils_eq(config.size, $author$project$KaizenDraft$Tag$Tag$Medium) ? A2($author$project$KaizenDraft$Tag$Tag$viewValidationIcon, config, $author$project$KaizenDraft$Tag$Tag$exclamationIconAsset) : $elm$html$Html$text('');
        }
      } else {
        return $elm$html$Html$text('');
      }
    }();
    var resolveIndicatorIcon = function () {
      var _v1 = config.variant;
      if (_v1.$ === 'Status' && _v1.a.$ === 'StatusLive') {
        var _v2 = _v1.a;
        return $author$project$KaizenDraft$Tag$Tag$viewIndicatorIcon(config);
      } else {
        return $elm$html$Html$text('');
      }
    }();
    var resolveClear = config.dismissible ? $author$project$KaizenDraft$Tag$Tag$viewClear(config) : $elm$html$Html$text('');
    return A2($elm$html$Html$div, _List_fromArray([$author$project$KaizenDraft$Tag$Tag$styles.classList(_Utils_ap(_List_fromArray([_Utils_Tuple2(function ($) {
      return $.root;
    }, true), _Utils_Tuple2(function ($) {
      return $.medium;
    }, _Utils_eq(config.size, $author$project$KaizenDraft$Tag$Tag$Medium) && !config.allowTextWrapping), _Utils_Tuple2(function ($) {
      return $.small;
    }, _Utils_eq(config.size, $author$project$KaizenDraft$Tag$Tag$Small) && !config.allowTextWrapping), _Utils_Tuple2(function ($) {
      return $.inline;
    }, config.inline), _Utils_Tuple2(function ($) {
      return $.dismissible;
    }, config.dismissible)]), resolveVariantStyle)), $author$project$KaizenDraft$Tag$Tag$stylesElmExtra.classList(_List_fromArray([_Utils_Tuple2(function ($) {
      return $.mediumAllowingTextWrapping;
    }, _Utils_eq(config.size, $author$project$KaizenDraft$Tag$Tag$Medium) && config.allowTextWrapping), _Utils_Tuple2(function ($) {
      return $.smallAllowingTextWrapping;
    }, _Utils_eq(config.size, $author$project$KaizenDraft$Tag$Tag$Small) && config.allowTextWrapping)]))]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$author$project$KaizenDraft$Tag$Tag$styles._class(function ($) {
      return $.layoutContainer;
    })]), _List_fromArray([resolveValidationIcon, A2($author$project$KaizenDraft$Tag$Tag$viewTextContent, config, value), resolveClear, resolveIndicatorIcon]))]));
  });
  var $author$project$KaizenDraft$Select$Select$viewMultiValue = F4(function (_v0, mousedownedItem, index, menuItem) {
    var truncationWidth = _v0.truncationWidth;
    var allowTextWrapping = _v0.allowTextWrapping;
    var resolveVariant = function () {
      var _v3 = menuItem.menuItemType;
      switch (_v3.$) {
        case 'Default':
          return $author$project$KaizenDraft$Tag$Tag$default;
        case 'Cautionary':
          return $author$project$KaizenDraft$Tag$Tag$validation($author$project$KaizenDraft$Tag$Tag$ValidationCautionary);
        default:
          return $author$project$KaizenDraft$Tag$Tag$validation($author$project$KaizenDraft$Tag$Tag$ValidationNegative);
      }
    }();
    var resolveTruncationWidth = function (tagConfig) {
      if (truncationWidth.$ === 'Just') {
        var width = truncationWidth.a;
        return A2($author$project$KaizenDraft$Tag$Tag$truncateWidth, width, tagConfig);
      } else {
        return tagConfig;
      }
    };
    var resolveAllowTextWrapping = function (tagConfig) {
      return allowTextWrapping ? A2($author$project$KaizenDraft$Tag$Tag$allowTextWrapping, true, tagConfig) : tagConfig;
    };
    var isMousedowned = function () {
      if (mousedownedItem.$ === 'MultiItemMousedown') {
        var i = mousedownedItem.a;
        return _Utils_eq(i, index);
      } else {
        return false;
      }
    }();
    var resolveMouseleave = function (tagConfig) {
      return isMousedowned ? A2($author$project$KaizenDraft$Tag$Tag$onMouseleave, $author$project$KaizenDraft$Select$Select$ClearFocusedItem, tagConfig) : tagConfig;
    };
    return A3($elm$html$Html$Keyed$node, 'div', _List_fromArray([$author$project$KaizenDraft$Select$Select$styles._class(function ($) {
      return $.multiValue;
    })]), _List_fromArray([_Utils_Tuple2('multi-value-' + $elm$core$String$fromInt(index), A2($elm$html$Html$Lazy$lazy, function (mi) {
      return A2($author$project$KaizenDraft$Tag$Tag$view, resolveMouseleave(resolveAllowTextWrapping(resolveTruncationWidth(A2($author$project$KaizenDraft$Tag$Tag$inline, true, A2($author$project$KaizenDraft$Tag$Tag$onMousedown, $author$project$KaizenDraft$Select$Select$MultiItemFocus(index), A2($author$project$KaizenDraft$Tag$Tag$onDismiss, $author$project$KaizenDraft$Select$Select$DeselectedMultiItem(mi.item), A2($author$project$KaizenDraft$Tag$Tag$dismissible, true, A2($author$project$KaizenDraft$Tag$Tag$size, $author$project$KaizenDraft$Tag$Tag$Medium, resolveVariant)))))))), mi.label);
    }, menuItem))]));
  });
  var $author$project$KaizenDraft$Select$Select$FadedBold = {
    $: 'FadedBold'
  };
  var $author$project$KaizenDraft$Select$Select$viewPlaceholder = function (config) {
    var _v0 = config.placeholder;
    var placeholderValue = _v0.a;
    var style = _v0.b;
    return A2($elm$html$Html$div, _List_fromArray([$author$project$KaizenDraft$Select$Select$styles.classList(_List_fromArray([_Utils_Tuple2(function ($) {
      return $.placeholder;
    }, true), _Utils_Tuple2(function ($) {
      return $.faded;
    }, _Utils_eq(style, $author$project$KaizenDraft$Select$Select$Faded)), _Utils_Tuple2(function ($) {
      return $.bold;
    }, _Utils_eq(style, $author$project$KaizenDraft$Select$Select$Bold)), _Utils_Tuple2(function ($) {
      return $.fadedBold;
    }, _Utils_eq(style, $author$project$KaizenDraft$Select$Select$FadedBold))]))]), _List_fromArray([$elm$html$Html$text(placeholderValue)]));
  };
  var $author$project$KaizenDraft$Select$SelectInput$Dynamic = {
    $: 'Dynamic'
  };
  var $author$project$KaizenDraft$Select$SelectInput$Fixed = {
    $: 'Fixed'
  };
  var $author$project$KaizenDraft$Select$Select$InputChanged = F2(function (a, b) {
    return {
      $: 'InputChanged',
      a: a,
      b: b
    };
  });
  var $author$project$KaizenDraft$Select$Select$InputMousedowned = {
    $: 'InputMousedowned'
  };
  var $author$project$KaizenDraft$Select$Select$canBeSpaceToggled = F2(function (menuOpen, inputValue) {
    return !menuOpen && $author$project$KaizenDraft$Select$Select$isEmptyInputValue(inputValue);
  });
  var $author$project$KaizenDraft$Select$SelectInput$Config = function (a) {
    return {
      $: 'Config',
      a: a
    };
  };
  var $author$project$KaizenDraft$Select$SelectInput$currentValue = F2(function (value_, _v0) {
    var config = _v0.a;
    return $elm$core$String$isEmpty(value_) ? $author$project$KaizenDraft$Select$SelectInput$Config(_Utils_update(config, {
      currentValue: $elm$core$Maybe$Nothing
    })) : $author$project$KaizenDraft$Select$SelectInput$Config(_Utils_update(config, {
      currentValue: $elm$core$Maybe$Just(value_)
    }));
  });
  var $author$project$KaizenDraft$Select$SelectInput$defaults = {
    currentValue: $elm$core$Maybe$Nothing,
    disabled: false,
    inputSizing: $author$project$KaizenDraft$Select$SelectInput$Dynamic,
    minWidth: $author$project$KaizenDraft$Select$SelectInput$defaultWidth,
    onBlur: $elm$core$Maybe$Nothing,
    onFocus: $elm$core$Maybe$Nothing,
    onInput: $elm$core$Maybe$Nothing,
    onMousedown: $elm$core$Maybe$Nothing,
    onWithStopPropagationAndPreventDefault: _List_Nil
  };
  var $author$project$KaizenDraft$Select$SelectInput$default = $author$project$KaizenDraft$Select$SelectInput$Config($author$project$KaizenDraft$Select$SelectInput$defaults);
  var $author$project$KaizenDraft$Select$SelectInput$inputSizing = F2(function (width, _v0) {
    var config = _v0.a;
    return $author$project$KaizenDraft$Select$SelectInput$Config(_Utils_update(config, {
      inputSizing: width
    }));
  });
  var $author$project$KaizenDraft$Select$SelectInput$onBlurMsg = F2(function (msg, _v0) {
    var config = _v0.a;
    return $author$project$KaizenDraft$Select$SelectInput$Config(_Utils_update(config, {
      onBlur: $elm$core$Maybe$Just(msg)
    }));
  });
  var $author$project$KaizenDraft$Select$SelectInput$onFocusMsg = F2(function (msg, _v0) {
    var config = _v0.a;
    return $author$project$KaizenDraft$Select$SelectInput$Config(_Utils_update(config, {
      onFocus: $elm$core$Maybe$Just(msg)
    }));
  });
  var $author$project$KaizenDraft$Select$SelectInput$onInput = F2(function (msg, _v0) {
    var config = _v0.a;
    return $author$project$KaizenDraft$Select$SelectInput$Config(_Utils_update(config, {
      onInput: $elm$core$Maybe$Just(msg)
    }));
  });
  var $author$project$KaizenDraft$Select$SelectInput$onMousedown = F2(function (msg, _v0) {
    var config = _v0.a;
    return $author$project$KaizenDraft$Select$SelectInput$Config(_Utils_update(config, {
      onMousedown: $elm$core$Maybe$Just(msg)
    }));
  });
  var $author$project$KaizenDraft$Select$SelectInput$onWithStopPropagationAndPreventDefault = F2(function (decoders, _v0) {
    var config = _v0.a;
    return $author$project$KaizenDraft$Select$SelectInput$Config(_Utils_update(config, {
      onWithStopPropagationAndPreventDefault: decoders
    }));
  });
  var $author$project$KaizenDraft$Events$Events$stringAt = function (path) {
    return A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$string);
  };
  var $author$project$KaizenDraft$Events$Events$mapAt = F2(function (path, msg) {
    return A2($elm$json$Json$Decode$map, msg, $author$project$KaizenDraft$Events$Events$stringAt(path));
  });
  var $author$project$KaizenDraft$Events$Events$onInputAt = F2(function (path, msg) {
    return A2($elm$html$Html$Events$on, 'input', A2($author$project$KaizenDraft$Events$Events$mapAt, path, msg));
  });
  var $elm$html$Html$Attributes$size = function (n) {
    return A2(_VirtualDom_attribute, 'size', $elm$core$String$fromInt(n));
  };
  var $author$project$KaizenDraft$Select$SelectInput$styles = A2($cultureamp$elm_css_modules_loader$CssModules$css, '@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss', {
    autosizeInputContainer: require("@cultureamp/kaizen-elm-draft-select/KaizenDraft/Select/styles.elm.scss")["autosizeInputContainer"]
  });
  var $author$project$KaizenDraft$Select$SelectInput$view = F2(function (_v0, id_) {
    var config = _v0.a;
    var sizerStyles = _List_fromArray([A2($elm$html$Html$Attributes$style, 'position', 'absolute'), A2($elm$html$Html$Attributes$style, 'top', '0px'), A2($elm$html$Html$Attributes$style, 'left', '0px'), A2($elm$html$Html$Attributes$style, 'visibility', 'hidden'), A2($elm$html$Html$Attributes$style, 'height', '0px'), A2($elm$html$Html$Attributes$style, 'overflow', 'scroll'), A2($elm$html$Html$Attributes$style, 'white-space', 'pre'), A2($elm$html$Html$Attributes$style, 'font-size', '16px'), A2($elm$html$Html$Attributes$style, 'letter-spacing', 'normal'), A2($elm$html$Html$Attributes$style, 'text-transform', 'none')]);
    var preventOn = A2($elm$html$Html$Events$custom, 'keydown', A2($elm$json$Json$Decode$map, function (m) {
      return {
        message: m,
        preventDefault: true,
        stopPropagation: true
      };
    }, $elm$json$Json$Decode$oneOf(config.onWithStopPropagationAndPreventDefault)));
    var mousedown = function (mousedownMsg) {
      return A2($elm$html$Html$Events$on, 'mousedown', $elm$json$Json$Decode$succeed(mousedownMsg));
    };
    var input_ = function (changeMsg) {
      return A2($author$project$KaizenDraft$Events$Events$onInputAt, _List_fromArray(['target', 'value']), changeMsg);
    };
    var inputValue = A2($elm$core$Maybe$withDefault, '', config.currentValue);
    var inputWidthStyle = function () {
      var _v1 = config.inputSizing;
      if (_v1.$ === 'Dynamic') {
        return $elm$core$String$isEmpty(inputValue) ? _List_fromArray([$elm$html$Html$Attributes$size(1)]) : _List_fromArray([$elm$html$Html$Attributes$size($elm$core$String$length(inputValue) + config.minWidth)]);
      } else {
        return _List_fromArray([A2($elm$html$Html$Attributes$style, 'width', $elm$core$String$fromInt(config.minWidth) + 'px')]);
      }
    }();
    var inputStyles = _Utils_ap(_List_fromArray([A2($elm$html$Html$Attributes$style, 'box-sizing', 'content-box'), A2($elm$html$Html$Attributes$style, 'background', '0px center'), A2($elm$html$Html$Attributes$style, 'border', '0px'), A2($elm$html$Html$Attributes$style, 'font-size', 'inherit'), A2($elm$html$Html$Attributes$style, 'outline', '0px'), A2($elm$html$Html$Attributes$style, 'padding', '0px'), A2($elm$html$Html$Attributes$style, 'color', 'inherit')]), inputWidthStyle);
    var focus = function (focusMsg) {
      return $elm$html$Html$Events$onFocus(focusMsg);
    };
    var blur = function (blurMsg) {
      return $elm$html$Html$Events$onBlur(blurMsg);
    };
    var events = config.disabled ? _List_Nil : _Utils_ap(A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A2($elm$core$Maybe$map, input_, config.onInput), A2($elm$core$Maybe$map, blur, config.onBlur), A2($elm$core$Maybe$map, focus, config.onFocus), A2($elm$core$Maybe$map, mousedown, config.onMousedown)])), _List_fromArray([preventOn]));
    return A2($elm$html$Html$div, _List_fromArray([$author$project$KaizenDraft$Select$SelectInput$styles._class(function ($) {
      return $.autosizeInputContainer;
    })]), _List_fromArray([A2($elm$html$Html$input, _Utils_ap(_List_fromArray([$elm$html$Html$Attributes$id($author$project$KaizenDraft$Select$SelectInput$inputId(id_)), $elm$html$Html$Attributes$value(inputValue), $elm$html$Html$Attributes$type_('text'), A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'new-password')]), _Utils_ap(events, inputStyles)), _List_Nil), A2($elm$html$Html$div, _Utils_ap(_List_fromArray([$elm$html$Html$Attributes$id($author$project$KaizenDraft$Select$SelectInput$sizerId(id_))]), sizerStyles), _List_fromArray([$elm$html$Html$text(inputValue)]))]));
  });
  var $author$project$KaizenDraft$Select$Select$viewSelectInput = function (viewSelectInputData) {
    var whenArrowEvents = viewSelectInputData.menuOpen && !viewSelectInputData.totalViewableMenuItems ? _List_Nil : _List_fromArray([$author$project$KaizenDraft$Events$Events$isDownArrow(A2($author$project$KaizenDraft$Select$Select$KeyboardDown, $author$project$KaizenDraft$Select$Select$SelectId(viewSelectInputData.id), viewSelectInputData.totalViewableMenuItems)), $author$project$KaizenDraft$Events$Events$isUpArrow(A2($author$project$KaizenDraft$Select$Select$KeyboardUp, $author$project$KaizenDraft$Select$Select$SelectId(viewSelectInputData.id), viewSelectInputData.totalViewableMenuItems))]);
    var spaceKeydownDecoder = function (decoders) {
      return A2($author$project$KaizenDraft$Select$Select$canBeSpaceToggled, viewSelectInputData.menuOpen, viewSelectInputData.maybeInputValue) ? A2($elm$core$List$cons, $author$project$KaizenDraft$Events$Events$isSpace($author$project$KaizenDraft$Select$Select$ToggleMenuAtKey($author$project$KaizenDraft$Select$Select$SelectId(viewSelectInputData.id))), decoders) : decoders;
    };
    var resolveInputWidth = function (selectInputConfig) {
      return viewSelectInputData.usePorts ? A2($author$project$KaizenDraft$Select$SelectInput$inputSizing, $author$project$KaizenDraft$Select$SelectInput$Fixed, selectInputConfig) : A2($author$project$KaizenDraft$Select$SelectInput$inputSizing, $author$project$KaizenDraft$Select$SelectInput$Dynamic, selectInputConfig);
    };
    var resolveInputValue = A2($elm$core$Maybe$withDefault, '', viewSelectInputData.maybeInputValue);
    var enterKeydownDecoder = function () {
      var _v0 = viewSelectInputData.maybeActiveTarget;
      if (_v0.$ === 'Just') {
        var mi = _v0.a;
        return _List_fromArray([$author$project$KaizenDraft$Events$Events$isEnter($author$project$KaizenDraft$Select$Select$EnterSelect(mi.item))]);
      } else {
        return _List_Nil;
      }
    }();
    return A2($author$project$KaizenDraft$Select$SelectInput$view, A3($elm$core$Basics$apL, $author$project$KaizenDraft$Select$SelectInput$onWithStopPropagationAndPreventDefault, _Utils_ap(spaceKeydownDecoder(enterKeydownDecoder), _Utils_ap(_List_fromArray([$author$project$KaizenDraft$Events$Events$isEscape($author$project$KaizenDraft$Select$Select$CloseMenu)]), whenArrowEvents)), resolveInputWidth(A2($author$project$KaizenDraft$Select$SelectInput$onMousedown, $author$project$KaizenDraft$Select$Select$InputMousedowned, A2($author$project$KaizenDraft$Select$SelectInput$currentValue, resolveInputValue, A2($author$project$KaizenDraft$Select$SelectInput$onFocusMsg, $author$project$KaizenDraft$Select$Select$InputReceivedFocused($elm$core$Maybe$Just($author$project$KaizenDraft$Select$Select$SelectId(viewSelectInputData.id))), A2($author$project$KaizenDraft$Select$SelectInput$onBlurMsg, $author$project$KaizenDraft$Select$Select$OnInputBlurred($elm$core$Maybe$Just($author$project$KaizenDraft$Select$Select$SelectId(viewSelectInputData.id))), A2($author$project$KaizenDraft$Select$SelectInput$onInput, $author$project$KaizenDraft$Select$Select$InputChanged($author$project$KaizenDraft$Select$Select$SelectId(viewSelectInputData.id)), $author$project$KaizenDraft$Select$SelectInput$default))))))), viewSelectInputData.id);
  };
  var $author$project$KaizenDraft$Select$Select$viewSelectedPlaceholder = function (item) {
    var _v0 = _Utils_Tuple2(item.label, $author$project$KaizenDraft$Select$Select$Bold);
    var placeholderValue = _v0.a;
    var style = _v0.b;
    return A2($elm$html$Html$div, _List_fromArray([$author$project$KaizenDraft$Select$Select$styles.classList(_List_fromArray([_Utils_Tuple2(function ($) {
      return $.singleValue;
    }, true), _Utils_Tuple2(function ($) {
      return $.faded;
    }, _Utils_eq(style, $author$project$KaizenDraft$Select$Select$Faded)), _Utils_Tuple2(function ($) {
      return $.bold;
    }, _Utils_eq(style, $author$project$KaizenDraft$Select$Select$Bold)), _Utils_Tuple2(function ($) {
      return $.fadedBold;
    }, _Utils_eq(style, $author$project$KaizenDraft$Select$Select$FadedBold))]))]), _List_fromArray([$elm$html$Html$text(placeholderValue)]));
  };
  var $author$project$KaizenDraft$Select$Select$view = F2(function (_v0, selectId) {
    var config = _v0.a;
    var resolvePlaceholder = function () {
      var _v6 = config.variant;
      if (_v6.$ === 'Multi') {
        if (!_v6.b.b) {
          return $author$project$KaizenDraft$Select$Select$viewPlaceholder(config);
        } else {
          return $elm$html$Html$text('');
        }
      } else {
        if (_v6.a.$ === 'Just') {
          var v = _v6.a.a;
          return $author$project$KaizenDraft$Select$Select$viewSelectedPlaceholder(v);
        } else {
          var _v7 = _v6.a;
          return $author$project$KaizenDraft$Select$Select$viewPlaceholder(config);
        }
      }
    }();
    var resolveLoadingSpinner = config.isLoading && config.searchable ? $author$project$KaizenDraft$Select$Select$viewLoading : $elm$html$Html$text('');
    var resolveContainerMsg = config.searchable ? $author$project$KaizenDraft$Select$Select$SearchableSelectContainerClicked(selectId) : $author$project$KaizenDraft$Select$Select$UnsearchableSelectContainerClicked(selectId);
    var clearButtonVisible = function () {
      if (config.clearable && !config.disabled) {
        var _v4 = config.variant;
        if (_v4.$ === 'Multi') {
          return false;
        } else {
          var maybeSelectedItem = _v4.a;
          if (maybeSelectedItem.$ === 'Just') {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    }();
    var _v1 = config.state;
    var state_ = _v1.a;
    var buildMulti = function () {
      var _v3 = config.variant;
      if (_v3.$ === 'Multi') {
        var tagConfig = _v3.a;
        var multiSelectedValues = _v3.b;
        return A2($elm$core$List$indexedMap, A2($author$project$KaizenDraft$Select$Select$viewMultiValue, tagConfig, state_.initialMousedown), multiSelectedValues);
      } else {
        return _List_fromArray([$elm$html$Html$text('')]);
      }
    }();
    var buildPlaceholder = $author$project$KaizenDraft$Select$Select$isEmptyInputValue(state_.inputValue) ? resolvePlaceholder : $elm$html$Html$text('');
    var preventDefault = function () {
      if (config.searchable) {
        var _v2 = state_.initialMousedown;
        switch (_v2.$) {
          case 'NothingMousedown':
            return false;
          case 'InputMousedown':
            return false;
          default:
            return true;
        }
      } else {
        return true;
      }
    }();
    var viewableMenuItems = A2($author$project$KaizenDraft$Select$Select$buildMenuItems, config, state_);
    var enterSelectTargetItem = state_.menuOpen && !$elm$core$List$isEmpty(viewableMenuItems) ? A2($elm_community$list_extra$List$Extra$getAt, state_.activeTargetIndex, viewableMenuItems) : $elm$core$Maybe$Nothing;
    var totalMenuItems = $elm$core$List$length(viewableMenuItems);
    var buildInput = !config.disabled ? config.searchable ? A2($elm$html$Html$Lazy$lazy, $author$project$KaizenDraft$Select$Select$viewSelectInput, A6($author$project$KaizenDraft$Select$Select$ViewSelectInputData, $author$project$KaizenDraft$Select$Select$getSelectId(selectId), state_.inputValue, enterSelectTargetItem, totalMenuItems, state_.menuOpen, state_.usePorts)) : A2($elm$html$Html$Lazy$lazy, $author$project$KaizenDraft$Select$Select$viewDummyInput, A4($author$project$KaizenDraft$Select$Select$ViewDummyInputData, $author$project$KaizenDraft$Select$Select$getSelectId(selectId), enterSelectTargetItem, totalMenuItems, state_.menuOpen)) : $elm$html$Html$text('');
    return A2($elm$html$Html$div, _List_fromArray([$author$project$KaizenDraft$Select$Select$styles._class(function ($) {
      return $.container;
    })]), _List_fromArray([A2($elm$html$Html$div, _Utils_ap(_List_fromArray([$author$project$KaizenDraft$Select$Select$styles.classList(_List_fromArray([_Utils_Tuple2(function ($) {
      return $.control;
    }, true), _Utils_Tuple2(function ($) {
      return $.disabled;
    }, config.disabled), _Utils_Tuple2(function ($) {
      return $.isFocused;
    }, state_.controlFocused), _Utils_Tuple2(function ($) {
      return $.cautionary;
    }, _Utils_eq(config.selectType, $author$project$KaizenDraft$Select$Select$Cautionary) && !state_.controlFocused), _Utils_Tuple2(function ($) {
      return $.error;
    }, _Utils_eq(config.selectType, $author$project$KaizenDraft$Select$Select$Error) && !state_.controlFocused), _Utils_Tuple2(function ($) {
      return $.controlHasUnconstrainedHeight;
    }, config.controlHasUnconstrainedHeight)])), A2($elm$html$Html$Attributes$attribute, 'data-automation-id', 'Select__Control')]), config.disabled ? _List_Nil : _List_fromArray([A2($elm$html$Html$Events$preventDefaultOn, 'mousedown', A2($elm$json$Json$Decode$map, function (msg) {
      return _Utils_Tuple2(msg, preventDefault);
    }, $elm$json$Json$Decode$succeed(resolveContainerMsg)))])), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$author$project$KaizenDraft$Select$Select$styles._class(function ($) {
      return $.valueContainer;
    })]), _List_fromArray([A2($elm$html$Html$span, _List_Nil, buildMulti), buildPlaceholder, buildInput])), A2($elm$html$Html$div, _List_fromArray([$author$project$KaizenDraft$Select$Select$styles._class(function ($) {
      return $.indicators;
    })]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$author$project$KaizenDraft$Select$Select$styles._class(function ($) {
      return $.indicatorContainer;
    })]), _List_fromArray([resolveLoadingSpinner, clearButtonVisible ? $author$project$KaizenDraft$Select$Select$viewClearButton : $elm$html$Html$text(''), A2($elm$html$Html$span, _List_fromArray([$author$project$KaizenDraft$Select$Select$styles.classList(_List_fromArray([_Utils_Tuple2(function ($) {
      return $.iconButton;
    }, !config.disabled), _Utils_Tuple2(function ($) {
      return $.iconButtonDisabled;
    }, config.disabled)]))]), _List_fromArray([A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Icon$Icon$view, $author$project$Icon$Icon$presentation, require('@cultureamp/kaizen-elm-component-library/icons/chevron-down.icon.svg').__esModule ? require('@cultureamp/kaizen-elm-component-library/icons/chevron-down.icon.svg').default : require('@cultureamp/kaizen-elm-component-library/icons/chevron-down.icon.svg')))]))]))]))])), A2($elm_community$html_extra$Html$Extra$viewIf, state_.menuOpen, A2($elm$html$Html$Lazy$lazy, $author$project$KaizenDraft$Select$Select$viewMenu, A6($author$project$KaizenDraft$Select$Select$ViewMenuData, config.variant, selectId, viewableMenuItems, state_.initialMousedown, state_.activeTargetIndex, state_.menuNavigation)))]));
  });
  var $author$project$Text$Text$styles = A2($cultureamp$elm_css_modules_loader$CssModules$css, '@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss', {
    body: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["body"],
    bodyBold: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["bodyBold"],
    button: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["button"],
    controlAction: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["controlAction"],
    defaultStyle: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["defaultStyle"],
    display: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["display"],
    heading: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["heading"],
    inheritBaseline: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["inheritBaseline"],
    inline: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["inline"],
    label: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["label"],
    lede: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["lede"],
    notification: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["notification"],
    pageTitle: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["pageTitle"],
    paragraph: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["paragraph"],
    small: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["small"],
    smallBold: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["smallBold"],
    title: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["title"],
    zenDataLarge: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["zen-data-large"],
    zenDataLargeUnits: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["zen-data-large-units"],
    zenDataMedium: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["zen-data-medium"],
    zenDataMediumUnits: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["zen-data-medium-units"],
    zenDataSmall: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["zen-data-small"],
    zenDataSmallUnits: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["zen-data-small-units"],
    zenDisplay0: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["zen-display-0"],
    zenHeading1: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["zen-heading-1"],
    zenHeading2: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["zen-heading-2"],
    zenHeading3: require("@cultureamp/kaizen-elm-component-library/components/Text/Text.module.scss")["zen-heading-3"]
  });
  var $author$project$Text$Text$className = F4(function (tag, typeStyle, shouldInheritBaseline, shouldInline) {
    var styleClass = function () {
      switch (typeStyle.$) {
        case 'DefaultStyle':
          return function ($) {
            return $.defaultStyle;
          };
        case 'PageTitle':
          return function ($) {
            return $.pageTitle;
          };
        case 'Title':
          return function ($) {
            return $.title;
          };
        case 'Display':
          return function ($) {
            return $.display;
          };
        case 'Heading':
          return function ($) {
            return $.heading;
          };
        case 'Paragraph':
          return function ($) {
            return $.paragraph;
          };
        case 'Lede':
          return function ($) {
            return $.lede;
          };
        case 'Body':
          return function ($) {
            return $.body;
          };
        case 'BodyBold':
          return function ($) {
            return $.bodyBold;
          };
        case 'Small':
          return function ($) {
            return $.small;
          };
        case 'SmallBold':
          return function ($) {
            return $.smallBold;
          };
        case 'Notification':
          return function ($) {
            return $.notification;
          };
        case 'Label':
          return function ($) {
            return $.label;
          };
        case 'ControlAction':
          return function ($) {
            return $.controlAction;
          };
        case 'Button':
          return function ($) {
            return $.button;
          };
        case 'ZenDisplay0':
          return function ($) {
            return $.zenDisplay0;
          };
        case 'ZenHeading1':
          return function ($) {
            return $.zenHeading1;
          };
        case 'ZenHeading2':
          return function ($) {
            return $.zenHeading2;
          };
        case 'ZenHeading3':
          return function ($) {
            return $.zenHeading3;
          };
        case 'ZenDataLarge':
          return function ($) {
            return $.zenDataLarge;
          };
        case 'ZenDataLargeUnits':
          return function ($) {
            return $.zenDataLargeUnits;
          };
        case 'ZenDataMedium':
          return function ($) {
            return $.zenDataMedium;
          };
        case 'ZenDataMediumUnits':
          return function ($) {
            return $.zenDataMediumUnits;
          };
        case 'ZenDataSmall':
          return function ($) {
            return $.zenDataSmall;
          };
        default:
          return function ($) {
            return $.zenDataSmallUnits;
          };
      }
    }();
    return $author$project$Text$Text$styles.classList(_List_fromArray([_Utils_Tuple2(styleClass, true), _Utils_Tuple2(function ($) {
      return $.inheritBaseline;
    }, shouldInheritBaseline), _Utils_Tuple2(function ($) {
      return $.inline;
    }, shouldInline)]));
  });
  var $author$project$Text$Text$view = F2(function (_v0, children) {
    var config = _v0.a;
    var resolveId = function () {
      var _v1 = config.id;
      if (_v1.$ === 'Just') {
        var id_ = _v1.a;
        return _List_fromArray([$elm$html$Html$Attributes$id(id_)]);
      } else {
        return _List_Nil;
      }
    }();
    return A2(config.tag, _Utils_ap(_List_fromArray([A4($author$project$Text$Text$className, config.tag, config.style, config.inheritBaseline, config.inline)]), resolveId), children);
  });
  var $author$project$ResponsePreviewSetup$Containers$AccountDemographics$View$viewAccountDemographic = function (accountDemographic) {
    var isLoading = function () {
      var _v0 = accountDemographic.uiQueriedSelectOptions;
      switch (_v0.$) {
        case 'NoData':
          return false;
        case 'Resolving':
          return true;
        case 'Debouncing':
          return true;
        case 'Resolved':
          return false;
        default:
          return false;
      }
    }();
    var buildMenuItems = F2(function (selectOption, acc) {
      return A2($elm$core$List$cons, {
        item: selectOption,
        label: A3($author$project$SurveyBuilderCommon$Translations$getTranslationWithDefault, 'en', selectOption.name, ''),
        menuItemType: $author$project$KaizenDraft$Select$Select$Default
      }, acc);
    });
    var menuList = A3($elm$core$List$foldr, buildMenuItems, _List_Nil, accountDemographic.selectOptions);
    return A2($elm$html$Html$div, _List_fromArray([$author$project$ResponsePreviewSetup$Containers$AccountDemographics$View$styles._class(function ($) {
      return $.accountDemographic;
    })]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$author$project$ResponsePreviewSetup$Containers$AccountDemographics$View$styles._class(function ($) {
      return $.title;
    })]), _List_fromArray([A2($author$project$Text$Text$view, A2($author$project$Text$Text$style, $author$project$Text$Text$Label, $author$project$Text$Text$div), _List_fromArray([$elm$html$Html$text(A3($author$project$SurveyBuilderCommon$Translations$getTranslationWithDefault, 'en', accountDemographic.name, ''))]))])), A2($elm$html$Html$div, _List_fromArray([$author$project$ResponsePreviewSetup$Containers$AccountDemographics$View$styles._class(function ($) {
      return $.dropdownWrapper;
    })]), _List_fromArray([A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$ResponsePreviewSetup$Containers$AccountDemographics$Types$AccountDemographicMsg(accountDemographic.id), $author$project$ResponsePreviewSetup$Containers$AccountDemographics$Types$SelectMsg), A2($author$project$KaizenDraft$Select$Select$view, A2($author$project$KaizenDraft$Select$Select$isLoading, isLoading, A2($author$project$KaizenDraft$Select$Select$menuItems, menuList, A2($author$project$KaizenDraft$Select$Select$searchable, true, A2($author$project$KaizenDraft$Select$Select$placeholder, _Utils_Tuple2('Select Demographic', $author$project$KaizenDraft$Select$Select$Bold), A2($author$project$KaizenDraft$Select$Select$state, accountDemographic.uiDemographicValueSelect, $author$project$KaizenDraft$Select$Select$single(A2($author$project$ResponsePreviewSetup$Containers$AccountDemographics$Helpers$selectedDemographicValueName, $author$project$KaizenDraft$Select$Select$Default, accountDemographic.uiSelectedDemographicValue))))))), $author$project$KaizenDraft$Select$Select$selectIdentifier($author$project$ResponsePreviewSetup$Common$Types$demographicIdToString(accountDemographic.id))))]))]));
  };
  var $author$project$ResponsePreviewSetup$Containers$AccountDemographics$View$view = function (accountDemographics) {
    return A2($elm$html$Html$div, _List_fromArray([$author$project$ResponsePreviewSetup$Containers$AccountDemographics$View$styles._class(function ($) {
      return $.demographicContent;
    })]), A2($elm$core$List$map, $author$project$ResponsePreviewSetup$Containers$AccountDemographics$View$viewAccountDemographic, accountDemographics));
  };
  var $author$project$ResponsePreviewSetup$View$view = function (model) {
    if (model.$ === 'AppOk') {
      var state = model.a;
      return A2($elm$html$Html$div, _List_fromArray([$author$project$ResponsePreviewSetup$View$styles.classList(_List_fromArray([_Utils_Tuple2(function ($) {
        return $.content;
      }, true), _Utils_Tuple2(function ($) {
        return $.visible;
      }, state.appVisible)]))]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$author$project$ResponsePreviewSetup$View$styles._class(function ($) {
        return $.overlay;
      }), $elm$html$Html$Events$onClick($author$project$ResponsePreviewSetup$Types$CloseApp)]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$author$project$ResponsePreviewSetup$View$styles.classList(_List_fromArray([_Utils_Tuple2(function ($) {
        return $.dialog;
      }, true), _Utils_Tuple2(function ($) {
        return $.subHeading;
      }, true)]))]), _List_fromArray([A2($elm$html$Html$header, _List_Nil, _List_fromArray([A2($author$project$Text$Text$view, A2($author$project$Text$Text$style, $author$project$Text$Text$ZenHeading2, $author$project$Text$Text$h2), _List_fromArray([$elm$html$Html$text('Survey preview setup')])), A2($elm$html$Html$span, _List_fromArray([$author$project$ResponsePreviewSetup$View$styles._class(function ($) {
        return $.close;
      })]), _List_fromArray([A2($author$project$KaizenDraft$Button$Button$view, A2($author$project$KaizenDraft$Button$Button$onClick, $author$project$ResponsePreviewSetup$Types$CloseApp, $author$project$KaizenDraft$Button$Button$iconButton(require('@kaizen/component-library/icons/close.icon.svg').__esModule ? require('@kaizen/component-library/icons/close.icon.svg').default : require('@kaizen/component-library/icons/close.icon.svg'))), 'close')]))])), A2($elm$html$Html$section, _List_fromArray([$author$project$ResponsePreviewSetup$View$styles._class(function ($) {
        return $.sectionWrap;
      })]), _List_fromArray([A2($elm$html$Html$map, $author$project$ResponsePreviewSetup$Types$AccountDemographics, $author$project$ResponsePreviewSetup$Containers$AccountDemographics$View$view(state.accountDemographics))])), A2($elm$html$Html$nav, _List_Nil, _List_fromArray([A2($elm$html$Html$a, _List_fromArray([$author$project$ResponsePreviewSetup$View$styles._class(function ($) {
        return $.cancel;
      }), $elm$html$Html$Events$onClick($author$project$ResponsePreviewSetup$Types$CloseApp)]), _List_fromArray([$elm$html$Html$text('Cancel')])), A2($author$project$KaizenDraft$Button$Button$view, A2($author$project$KaizenDraft$Button$Button$icon, require('@kaizen/component-library/icons/sync.icon.svg').__esModule ? require('@kaizen/component-library/icons/sync.icon.svg').default : require('@kaizen/component-library/icons/sync.icon.svg'), A2($author$project$KaizenDraft$Button$Button$onClick, $author$project$ResponsePreviewSetup$Types$Update, $author$project$KaizenDraft$Button$Button$primary)), 'Update')]))]))]));
    } else {
      return $elm$html$Html$text('');
    }
  };
  var $author$project$ResponsePreviewSetupApp$main = $elm$browser$Browser$element({
    init: $author$project$ResponsePreviewSetup$State$init,
    subscriptions: $author$project$ResponsePreviewSetup$State$subscriptions,
    update: $author$project$ResponsePreviewSetup$State$update,
    view: $author$project$ResponsePreviewSetup$View$view
  });
  _Platform_export({
    'ResponsePreviewSetupApp': {
      'init': $author$project$ResponsePreviewSetupApp$main($elm$json$Json$Decode$value)(0)
    }
  });
})(this);